(function () {
    'use strict';

    'use strict';
angular.module('ngKomondorEditor', ['komondor-editor']);
angular.module('komondor-editor', ['ng-komondor-editor.templates', 'ngKomondor', 'ngKomondorMediaLibrary', 'ngSanitize', 'FBAngular', 'angular-md5']);
'use strict';
angular.module('komondor-editor').directive('disableRightClick', function () {
    return {
        link: function link(scope, elem, attrs) {
            if (angular.isDefined(attrs.disableRightClick) && attrs.disableRightClick === 'true') {
                elem.attr('oncontextmenu', 'return false;');
            }
            elem.removeAttr('disableRightClick');
        }
    };
});
'use strict';
angular.module('komondor-editor').directive('editableModifier', function () {
    return {
        restrict: 'A',
        scope: { formatter: '=' },
        controller: ["$scope", function controller($scope) {
            this.formatter = $scope.formatter;
        }]
    };
});
'use strict';
angular.module('komondor-editor').directive('editable', ["$sce", "$timeout", "$log", "editorState", "ElementAttributes", "$document", function ($sce, $timeout, $log, editorState, ElementAttributes, $document) {
    return {
        restrict: 'A',
        require: ['ngModel', '?^component', '?^editor', '?^editableModifier'],
        link: link
    };
    function link($scope, element, attrs, controllers) {
        var ngModel = controllers[0];
        var componentCtrl = controllers[1];
        var editorCtrl = controllers[2];
        var editableModifierCtrl = controllers[3];
        var checkForLink = function checkForLink(element) {
            var foundElement = element;
            while (foundElement && foundElement.tagName !== 'A') {
                if (foundElement.parentElement && !foundElement.hasAttribute('component')) {
                    foundElement = foundElement.parentElement;
                } else {
                    foundElement = null;
                }
            }
            return foundElement;
        };
        setEditable(element, editorCtrl ? editorCtrl.state.editMode : true);
        $scope.$on('editor:editmode', function ($event, value) {
            setEditable(element, value);
        });
        $scope.$on('editable:reformat', function () {
            var modelValue = ngModel.$modelValue;
            var formatters = ngModel.$formatters;
            var idx = formatters.length;
            var viewValue = modelValue;
            while (idx--) {
                viewValue = formatters[idx](viewValue);
            }
            if (ngModel.$viewValue !== viewValue) {
                ngModel.$viewValue = ngModel.$$lastCommittedViewValue = viewValue;
                ngModel.$render();
            }
        });
        if (editableModifierCtrl && editableModifierCtrl.formatter) {
            ngModel.$formatters.push(editableModifierCtrl.formatter);
        }
        ngModel.$render = function () {
            element.html($sce.getTrustedHtml(ngModel.$viewValue || ''));
        };
        element.on('keyup', function () {
            $scope.$evalAsync(function () {
                read(element, componentCtrl, ngModel);
            });
        });
        element.on('paste', function ($event) {
            $event.stopPropagation();
            if (editorCtrl.options.pastePlainText) {
                pastePlainText($event);
            }
            $scope.$evalAsync(function () {
                if (read(element, componentCtrl, ngModel)) {
                    ngModel.$render();
                }
            });
        });
        element.on('blur', function () {
            // If the processing changes the value, we need to
            // render it back to the view straight away
            if (read(element, componentCtrl, ngModel)) {
                ngModel.$render();
            }
            if (ngModel.$dirty) {
                $timeout(function () {
                    $scope.$emit('component:changed');
                });
            }
        });
        element.on('focus', function () {
            ngModel.$setTouched();
            $timeout(function () {
                $scope.$emit('component:focus', ngModel.$viewValue);
            });
        });
        element[0].addEventListener('click', function ($event) {
            if (editorState.editMode) {
                $event.preventDefault();
                return;
            }
            var linkElement = checkForLink($event.target);
            if (linkElement) {
                var linkAttributes = new ElementAttributes(angular.element(linkElement));
                editorCtrl.options.onClickLink($event, linkAttributes.get());
            }
        }, { capture: true });
    }
    function setEditable(element, value) {
        if (value) {
            element.attr('contenteditable', 'true');
        } else {
            element.removeAttr('contenteditable');
        }
    }
    function read(element, componentCtrl, ngModel) {
        var raw = element.html();
        var html = componentCtrl ? componentCtrl.processHtml(raw) : raw;
        var reRender = false;
        // If the html has changed make the control dirty
        if (ngModel.$viewValue !== html) {
            ngModel.$setDirty();
        }
        // Write to data model.
        ngModel.$setViewValue(html);
        // let the event handler which called this know that html has
        // changed and needs to be re-rendered
        if (html !== raw) {
            reRender = true;
        }
        return reRender;
    }
    function pastePlainText($event) {
        $event.preventDefault();
        var text = ($event.originalEvent || $event).clipboardData.getData('text/plain');
        text = text.replace(/[\r\n]/g, '').trim();
        $document[0].execCommand('insertText', false, text);
    }
}]);
'use strict';
angular.module('komondor-editor').directive('includeReplace', function () {
    return {
        require: 'ngInclude',
        restrict: 'A',
        link: link
    };
    function link(scope, el) {
        el.replaceWith(el.children());
    }
});
'use strict';
angular.module('komondor-editor').directive('linkedComponent', ["editorState", "ElementAttributes", function (editorState, ElementAttributes) {
    return {
        restrict: 'A',
        controller: ["$scope", "$element", function controller($scope, $element) {
            var editorCtrl = $element.controller('editor');
            var whitelist = ['class', 'target', 'data-*', 'href'];
            function applyLinkAttributes() {
                var link = $scope.model.link || {};
                var linkNodeAttributes = new ElementAttributes($element, whitelist);
                linkNodeAttributes.clean();
                linkNodeAttributes.set(link);
                // Keep it as placeholder in editMode to avoid unexpected behavior
                // (e.g. in FF contenteditable stops working if it's wrapped in a link with href attr)
                if (editorCtrl.options.linkNoHrefOnEdit && editorState.editMode && link.href) {
                    $element.removeAttr('href');
                }
            }
            this.$onInit = function () {
                applyLinkAttributes();
                $scope.$watch('model.link', function (newValue, oldValue) {
                    if (newValue !== oldValue) {
                        applyLinkAttributes();
                    }
                });
                $element[0].addEventListener('click', function ($event) {
                    if (editorState.editMode) {
                        $event.preventDefault();
                        return;
                    }
                    // Skip for inner link
                    if ($event.target && $event.target.tagName === 'A') {
                        return;
                    }
                    editorCtrl.options.onClickLink($event, angular.copy($scope.model.link));
                }, { capture: true });
                $scope.$on('editor:editmode', applyLinkAttributes);
            };
        }]
    };
}]);
'use strict';
angular.module('komondor-editor').service('editorClipboard', ["localStorageValid", "$window", function (localStorageValid, $window) {
    var localStorage = localStorageValid() ? $window.localStorage : {};
    this.set = function (key, data) {
        localStorage[key] = angular.toJson(data);
        return localStorage[key];
    };
    this.get = function (key) {
        return angular.fromJson(localStorage[key]);
    };
}]);
'use strict';
angular.module('komondor-editor').controller('EditorCtrl', ["$scope", "$timeout", "$document", "$compile", "$element", "editorDefaultOptions", "$window", "editorState", "componentSelectorModal", "EditorLinkControls", "editorControls", "EditorHistory", "EditorTracker", "WindowSelection", "checkEditorHeight", "kdGate", "editorClipboard", function ($scope, $timeout, $document, $compile, $element, editorDefaultOptions, $window, editorState, componentSelectorModal, EditorLinkControls, editorControls, EditorHistory, EditorTracker, WindowSelection, checkEditorHeight, kdGate, editorClipboard) {
    var self = this;
    this.options = angular.extend({}, editorDefaultOptions, $scope.options || {});
    this.state = editorState;
    this.element = $element;
    this.model = $scope.model;
    this.checkHeight = checkEditorHeight;
    this.textFormattingTemplate = setTextFormattingTemplate(this.options.textFormatting);
    function setTextFormattingTemplate(option) {
        var allowedTypes = ['inline', 'dropdown'];
        var templateType = allowedTypes.indexOf(option) > -1 ? option : 'inline';
        return 'ng-komondor-editor/scripts/editor/editor-controls/editor-controls.text-' + templateType + '.html';
    }
    if (!this.state.history) {
        this.state.history = new EditorHistory(this.options.trackHistoryOptions);
        this.state.tracker = new EditorTracker(this.state.history, this.options.trackHistoryOptions);
    }
    $scope.property = $scope.property || 'components';
    this.property = $scope.property;
    if (!$scope.model[$scope.property]) {
        $scope.model[$scope.property] = [];
    }
    $scope.$on('component:trace', function ($event, data) {
        $scope.componentTraceItems = data.reverse();
        self.rootModel = data[0].model;
    });
    $scope.$on('$destroy', function () {
        editorState.componentDomStorage.removeEditor(self.getScopeId());
    });
    $scope.$on('component:removed', function () {
        editorControls.reset();
    });
    $scope.setFocusToItem = function (model, $event) {
        $scope.$broadcast('component:request-focus', model);
        $event.stopPropagation();
    };
    $scope.colorTextBg = function (colour) {
        var cb = false;
        if (angular.isFunction(this.options.onColorTextBg)) {
            cb = this.options.onColorTextBg(colour, $scope);
        }
        if (!cb) {
            $scope.execCommand('hiliteColor', false, colour);
        }
    };
    $scope.colorText = function (colour) {
        var cb = false;
        if (angular.isFunction(this.options.onColorText)) {
            cb = this.options.onColorText(colour, $scope);
        }
        if (!cb) {
            $scope.execCommand('foreColor', false, colour);
        }
    };
    // Check if current editor is selected
    $scope.isEditorSelected = function () {
        /*
        * Check if editor is selected and editMode active
        * Selected means that editor has a selected(focused) component
         */
        var scopeId = self.getScopeId();
        return self.state.editMode && self.state.selectedEditorScopeId === scopeId;
    };
    $scope.$on('component:de-select', function () {
        self.state.selectedEditorScopeId = null;
    });
    this.getHTML = function () {
        return this.element.children()[0].innerHTML;
    };
    this.toggleEditMode = function () {
        this.setEditMode(!$scope.editor.state.editMode);
    };
    this.setEditMode = function (editMode) {
        $scope.editor.state.editMode = editMode ? true : false;
        if (!editMode) {
            editorControls.reset();
        }
        $scope.$broadcast('editor:editmode', $scope.editor.state.editMode);
    };
    this.click = function (component, componentScope, componentListCtrl, parentComponentListCtrl) {
        // do not select anything while in non-editing/presentation mode
        if (!$scope.editor.state.editMode || $scope.editor.state.pickup) {
            return;
        }
        if (componentListCtrl.getChildCount() === 0) {
            componentSelectorModal.show(this.options).then(function (name, selected) {
                if (angular.isObject(name)) {
                    componentListCtrl.pasteChild(name, selected, false, componentListCtrl.isCommittable());
                } else {
                    componentListCtrl.addNewChild(name, selected, false, componentListCtrl.isCommittable());
                }
            });
        }
        return this.select(component, componentScope, parentComponentListCtrl || componentListCtrl);
    };
    this.changeDropTarget = function (dropTargetScope) {
        if (this.state.pickup.drop) {
            this.state.pickup.drop.dropTarget(false);
        }
        if (dropTargetScope) {
            dropTargetScope.dropTarget(true);
        }
        this.state.pickup.drop = dropTargetScope;
    };
    this.select = function (component, componentScope, componentListCtrl) {
        // We don't want to rebuild the controls if we aren't changing our selection
        if (this.state.componentScope === componentScope && this.state.componentListCtrl === componentListCtrl) {
            return;
        }
        // De-select the component
        if (this.state.componentScope) {
            this.state.componentScope.setSelected(false);
            self.options.style = null;
            this.checkHeight.unwatch();
        }
        // De-select the component list
        if (this.state.componentListCtrl && (typeof componentListCtrl === 'undefined' || this.state.componentListCtrl !== componentListCtrl)) {
            this.state.componentListCtrl.setSelected(false);
        }
        // Assign the new values
        this.state.selected = component;
        this.state.componentScope = componentScope;
        this.state.componentListCtrl = componentListCtrl;
        this.state.link = null;
        this.element.removeClass('root-model-active');
        // Select the new component
        if (this.state.componentScope) {
            this.checkHeight.watch($scope, this.state.componentScope.ctrl.element);
            this.state.selectedEditorScopeId = this.getScopeId();
            // Create new editor controls
            editorControls.create(this.state.componentScope.ctrl.element, this.state.componentScope, $scope);
            // Apply link button handlers here
            self.state.link = new EditorLinkControls(self.state, self.options, componentScope.ctrl.rebuild.bind(componentScope.ctrl));
            var isRootModelSelect = self.rootModel.length && self.rootModel[0] === component;
            if (isRootModelSelect) {
                this.element.addClass('root-model-active');
            }
            this.state.componentScope.setSelected(true);
            // Set editor controls gates
            this.state.gates = {
                moveDelete: this.options.moveDelete,
                copyComponent: this.options.copyComponent,
                highlightText: this.options.highlightText,
                textOptions: kdGate.allows('editor:component-' + this.state.selected.type + '.text-options'),
                options: kdGate.allows('editor:component-' + this.state.selected.type + '.options'),
                classList: kdGate.allows('editor:component-' + this.state.selected.type + '.class-list')
            };
            if (this.options.trackHistoryOptions.enabled) {
                this.setHistoryTracker();
            }
        }
        // Updated the components you can create inside the currently selected list
        var contextConfig = this.options.nestableComponents[componentListCtrl.context];
        this.state.nestableComponents = contextConfig ? contextConfig[componentListCtrl.slot] : {};
        this.state.componentListCtrl.setSelected(true);
        // Updates the component class list available
        if (this.state.selected) {
            var componentOptions = this.options.componentOptions[this.state.selected.type];
            this.state.tagList = componentOptions ? componentOptions.tags : null;
            this.state.classList = this.options.componentClasses[this.state.selected.type];
        } else {
            this.state.tagList = null;
            this.state.classList = null;
        }
    };
    this.showTextControls = function (tagStr) {
        if (!this.state.componentScope) {
            return false;
        }
        var tagArr = tagStr.split(' ');
        var componentType = this.state.componentScope.model.type;
        var currentComponent = this.options.componentOptions[componentType];
        var componentAllowedTags = currentComponent ? currentComponent.allowedTags : null;
        if (!componentAllowedTags) {
            componentAllowedTags = this.options.textControls;
        }
        for (var i = 0; i < tagArr.length; i++) {
            if (componentAllowedTags[tagArr[i]]) {
                return true;
            }
            // Show link buttons if it's enabled on component level
            if (currentComponent && currentComponent.link && tagArr[i] === 'a') {
                return true;
            }
        }
    };
    this.pickupComponent = function (model, componentListCtrl, ghost) {
        var self = this;
        this.state.pickup = {
            model: model,
            editor: this,
            list: componentListCtrl,
            ghost: ghost,
            destroy: function destroy() {
                self.changeDropTarget(null);
                self.state.pickup.ghost.destroy();
                self.state.pickup = false;
            }
        };
        ghost.setMouseUpOutsideCallback(this.state.pickup.destroy);
        ghost.setGhostBusterCallback(this.state.pickup.destroy);
    };
    this.moveComponent = function (insertNear, componentListCtrl, after) {
        // If nothing is picked up, do nothing
        if (!this.state.pickup) {
            return;
        }
        var oldList = this.state.pickup.list;
        var newList = componentListCtrl;
        var newIdx = newList.indexOfChild(insertNear) + (after ? 1 : 0);
        var oldIdx = oldList.indexOfChild(this.state.pickup.model);
        var oldListNear = oldList.getByIndex(oldIdx + 1);
        var target = {
            editor: this,
            list: newList,
            index: newIdx
        };
        // If beforeMove callback returns false then do nothing
        if (this.options.beforeMove(this.state.pickup, target) === false) {
            return;
        }
        // for mousemove within the picked-up-component
        var pickedUp = this.state.pickup.model;
        if (pickedUp === insertNear) {
            return;
        }
        // Why do we do this here?
        // Is this disabling some component options before we even know we have moved?
        this.state.componentScope = null;
        this.state.classList = null;
        this.state.tagList = null;
        // Change our pickup state to point at the new list
        // so that if we move again it works
        self.state.pickup.list = newList;
        $timeout(function () {
            self.moveComponentToList(oldList, newList, pickedUp, insertNear, !after);
            var commit = { scrollAfter: true };
            commit.undo = function () {
                self.moveComponentToList(newList, oldList, pickedUp, oldListNear, true);
                $timeout(function () {
                    oldList.setComponentPath(commit, pickedUp);
                });
            };
            commit.redo = function () {
                self.moveComponentToList(oldList, newList, pickedUp, insertNear, !after);
                $timeout(function () {
                    newList.setComponentPath(commit, pickedUp);
                });
            };
            self.state.history.commit(commit);
        });
    };
    this.copyToClipboard = function (model) {
        editorClipboard.set('copied-component', model);
        this.options.onCopyComponent(model, this);
    };
    this.mouseMove = function ($event) {
        if (!this.state.pickup) {
            return;
        }
        if (this.state.pickup.model && this.state.pickup.ghost) {
            this.state.pickup.ghost.move($event);
        }
    };
    /**
     * Check if picked up component is on target nested|overlay list
     * @param {string} targetType
     * @param {string} slot
     * @returns {boolean}
     */
    this.isComponentNestable = function (targetType, slot) {
        if (!this.state.pickup) {
            return;
        }
        slot = slot || 'nested';
        var componentType = this.state.pickup.model.type, targetOptions = this.options.nestableComponents[targetType];
        return targetOptions[slot] && targetOptions[slot][componentType];
    };
    this.moveComponentToList = function (oldList, newList, model, insertNear, before) {
        oldList.removeChild(model);
        newList.addChild(model, insertNear, before);
    };
    this.getScopeId = function () {
        return $scope.$id;
    };
    this.getEditable = function () {
        // Try and find a contenteditable parent
        var editable = angular.element(WindowSelection.get());
        while (editable.length && editable.attr('contenteditable') === undefined) {
            editable = editable.parent();
        }
        return editable;
    };
    this.setHistoryTracker = function () {
        if (!this.state.componentScope.ctrl.list.isCommittable()) {
            this.state.tracker.removeWatchers();
            this.state.history.setComponentScopePath(null, null);
        } else if (!this.state.tracker.isScopeActive(this.state.componentScope)) {
            this.state.tracker.setWatchers(this.state.componentScope);
            this.state.history.setComponentScopePath(this.getScopeId(), this.state.componentScope.getPath());
        }
    };
    this.destroyComponent = function () {
        this.state.componentScope.destroy();
    };
    this.copyComponent = function () {
        this.state.componentScope.copyToClipboard();
    };
    this.startMoveComponent = function ($event) {
        this.state.componentScope.pickup($event);
    };
    this.changeTextDirection = function (rtl) {
        $scope.$broadcast('component:text-direction-rtl', rtl);
    };
}]);
'use strict';
angular.module('komondor-editor').factory('editorDefaultOptions', ["$q", "notify", "$window", function ($q, notify, $window) {
    return {
        trackHistoryOptions: {
            enabled: false,
            namespace: 'model',
            scroll: {
                enabled: false,
                offset: 0
            }
        },
        textFormatting: 'inline',
        // [inline | dropdown]
        moveDelete: true,
        copyComponent: true,
        showBreadcrumbs: true,
        highlightText: false,
        pastePlainText: false,
        //Strip html or not when copy paste to editable.
        softReturn: false,
        //Strip html or not when copy paste to editable.
        rtl: false,
        textControls: {
            b: 'no attributes',
            i: 'no attributes',
            u: 'no attributes',
            del: 'no attributes',
            sub: 'no attributes',
            sup: 'no attributes',
            a: true,
            font: true,
            div: 'no attributes',
            br: 'no attributes'
        },
        backwardsCompatibility: {
            paragraph: function paragraph(model) {
                model.type = 'textblock';
                model.tag = 'p';
                model.html = model.data.html;
                delete model.data.html;
            },
            heading: function heading(model) {
                model.type = 'textblock';
                model.tag = model.data.tag || 'h1';
                model.html = model.data.text;
                delete model.data.tag;
                delete model.data.text;
            }
        },
        nestableComponents: {
            editor: {
                components: {
                    textblock: 'Textblock',
                    bullets: 'Bullets',
                    table: 'Table',
                    image: 'Image',
                    'video-player': 'Video'
                }
            },
            bullets: { nested: { bullets: 'Bullets' } },
            image: {
                overlay: {
                    textblock: 'Textblock',
                    bullets: 'Bullets'
                }
            }
        },
        componentClasses: {
            bullets: {
                default: 'circles',
                classes: {
                    ' ': 'None',
                    circles: 'Circles',
                    numeric: 'Numeric'
                }
            }
        },
        componentOptions: {
            textblock: {
                defaultTag: 'p',
                tags: {
                    h1: 'Heading 1',
                    h2: 'Heading 2',
                    h3: 'Heading 3',
                    h4: 'Heading 4',
                    h5: 'Heading 5',
                    h6: 'Heading 6',
                    p: 'Paragraph',
                    blockquote: 'Blockquote',
                    cite: 'Cite'
                }
            },
            image: {
                templateUrl: 'ng-komondor-editor/scripts/components/image/image.options.html',
                dropdown: true,
                resizable: true,
                overlay: true,
                allowedTags: {},
                offline: false,
                caption: false,
                placeholderImage: 'https://static.twelfthman.co/bylder/placeholder-image.svg',
                urlAt: 'computed'    // store the url in data? [data|computed]
            },
            'video-player': {
                allowedTags: {},
                templateUrl: 'ng-komondor-editor/scripts/components/video-player/video-player.options.html',
                nativeControls: false,
                loop: true,
                autoplay: true,
                muted: false,
                caption: false,
                controls: true,
                preload: false,
                forcePoster: false,
                defaults: { controls: false }
            },
            bullets: { templateUrl: 'ng-komondor-editor/scripts/components/bullets/bullets.options.html' },
            'description-list': { templateUrl: 'ng-komondor-editor/scripts/components/description-list/description-list.options.html' },
            table: {
                templateUrl: 'ng-komondor-editor/scripts/components/table/table.options.html',
                tableClass: 'table table-bordered',
                highlightOptions: [],
                allowTh: false
            },
            tabs: {
                templateUrl: 'ng-komondor-editor/scripts/components/tabs/tabs.options.html',
                allowedTags: {},
                titlePosition: 'top'
            }
        },
        linkNoHrefOnEdit: true,
        onPasteComponent: function onPasteComponent(component) {
            return $q.resolve(component);
        },
        onCopyComponent: function onCopyComponent() {
            notify.alert('Component has been copied to clipboard!');
        },
        onColorText: null,
        onColorTextBg: null,
        onCreateLink: function onCreateLink(linkAttrs) {
            var attrs = angular.copy(linkAttrs) || {};
            var defer = $q.defer();
            var href = $window.prompt('Enter a URL', attrs.href === '#temp_url#' ? '' : attrs.href);
            if (href === null || href === undefined || /^\s*$/.test(href)) {
                defer.reject();
            } else {
                attrs.href = href;
                defer.resolve(attrs);
            }
            return defer.promise;
        },
        onClickLink: function onClickLink(event, attributes) {
            if (!attributes.href || attributes.href === '#') {
                event.preventDefault();
            }
        },
        onCreateLinkException: function onCreateLinkException(context, exception) {
            if (angular.isString(exception)) {
                notify.alert(exception);
            } else {
                throw exception;
            }
        },
        onRemoveLink: function onRemoveLink(linkAttrs) {
            var modalInstance = notify.confirm('Are you sure you want to delete this link?');
            return modalInstance.result.then(function () {
                return linkAttrs;
            });
        },
        /**
         * A callback to allow the application to deny component move
         * using complex logic.
         *
         * @param  {object} pickup - Pickup source information
         * @param  {object} pickup.model - The component being moved
         * @param  {object} pickup.list - The ComponentList controller being moved from
         * @param  {object} pickup.editor - The Editor controller being moved from
         * @param  {function} pickup.destroy - Call to drop the component then return false
         * @param  {object} pickup - Pickup target information
         * @param  {object} target.list - The ComponentList controller being moved to
         * @param  {object} target.editor - The Editor controller being moved to
         * @param  {number} target.index - Integer target index to place in target list
         *
         * @return mixed false to deny move, null otherwise
         */
        beforeMove: function beforeMove(pickup, target)
            /* jshint unused:vars */
            {
            }
    };
}]);
'use strict';
angular.module('komondor-editor').directive('editorDeselector', function () {
    return { link: link };
    function link(scope, elem) {
        elem.on('click', function () {
            scope.$broadcast('component:de-select');
        });
    }
});
'use strict';
angular.module('komondor-editor').directive('editor', ["$parse", "$document", function ($parse, $document) {
    return {
        replace: true,
        scope: {
            model: '=',
            options: '=?',
            property: '@?'
        },
        link: link,
        controller: 'EditorCtrl as editor',
        templateUrl: 'ng-komondor-editor/scripts/editor/editor.html'
    };
    function link($scope, element, attrs) {
        if (attrs.name) {
            var setter = $parse(attrs.name).assign;
            setter($scope.$parent, $scope.editor);
        }
        var enableEditorControls = function enableEditorControls() {
            $scope.$watch('editor.state.editMode', function () {
                if ($scope.editor.state.editMode) {
                    element.addClass('edit-mode');
                } else {
                    element.removeClass('edit-mode');
                }
            });
            $scope.$watch('editor.options.limited', function () {
                if ($scope.editor.options.limited) {
                    element.addClass('limited');
                } else {
                    element.removeClass('limited');
                }
            });
            $scope.execCommand = function (command, showDefaultUI, value) {
                $document[0].execCommand(command, showDefaultUI, value);
                var editable = $scope.editor.getEditable();
                if (editable) {
                    angular.element(editable).triggerHandler('keyup');
                }
            };
            $scope.getEditorPosition = function () {
                return element[0].getBoundingClientRect();
            };
        };
        // We might want to only bind these on pickup rather than having them always bound
        var setMouseEvents = function setMouseEvents() {
            // A mouse up on a component or list will drop the pickup item first and this won't execute
            element.on('mouseup', function () {
                if (!$scope.editor.state.editMode) {
                    return;
                }
                if ($scope.editor.state.pickup) {
                    $scope.editor.state.pickup.destroy();
                }
            });
            // Moves a ghost if there is one
            element.on('mousemove', function ($event) {
                if (!$scope.editor.state.editMode) {
                    return;
                }
                $scope.editor.mouseMove($event);
            });
        };
        setMouseEvents();
        enableEditorControls();
    }
}]);
'use strict';
angular.module('komondor-editor').provider('editorGates', ["kdGateProvider", function (kdGateProvider) {
    var prefix = 'editor:component-';
    var gates = ['class-list', 'options', 'text-options'];
    this.setGates = setGates;
    this.$get = function () {
        return true;
    };
    function setGates(components) {
        if (angular.isArray(components)) {
            for (var c = 0; c < components.length; c++) {
                set(components[c]);
            }
        } else {
            set(components);
        }
        function set(component) {
            for (var g = 0; g < gates.length; g++) {
                kdGateProvider.define('' + prefix + component + '.' + gates[g], function () {
                    return true;
                });
            }
        }
    }
}]).config(["editorGatesProvider", function (editorGatesProvider) {
    editorGatesProvider.setGates(['bullets', 'description-list', 'image', 'table', 'textblock', 'video-player', 'tabs']);
}]);
'use strict';
angular.module('komondor-editor').factory('EditorLinkControls', ["ComponentLink", "TextLink", function (ComponentLink, TextLink) {
    return function EditorLinkControls(editorState, editorOptions, linkRebuildToggleCallback) {
        var componentScope = editorState.componentScope;
        var componentType = componentScope.model.type;
        var componentOptions = editorOptions.componentOptions[componentType];
        var linkType = componentOptions && componentOptions.link ? 'component' : '';
        var link;
        var linkAttributes;
        this.getLink = function () {
            if (linkType === 'component') {
                return new ComponentLink(componentScope.model, linkRebuildToggleCallback);
            }
            return new TextLink();
        };
        this.create = function () {
            link = this.getLink();
            try {
                linkAttributes = link.getAttributes();
                editorOptions.onCreateLink(linkAttributes).then(link.setAttributes).catch(link.onSetAttributesDismiss);
            } catch (error) {
                editorOptions.onCreateLinkException('create', error);
            }
        };
        this.remove = function () {
            link = this.getLink();
            try {
                linkAttributes = link.getAttributes(true);
                editorOptions.onRemoveLink(angular.copy(linkAttributes)).then(link.emptyAttributes);
            } catch (error) {
                editorOptions.onCreateLinkException('remove', error);
            }
        };
        this.showRemoveButton = function () {
            if (linkType === 'component') {
                var linkModel = componentScope.model.link || {};
                return Object.keys(linkModel).length > 0;
            }
            return true;
        };
    };
}]);
'use strict';
angular.module('komondor-editor').service('editorState', ["componentDomStorage", function (componentDomStorage) {
    this.selectedEditorScopeId = null;
    this.selected = null;
    this.componentScope = null;
    this.componentListScope = null;
    this.marginScope = null;
    this.editMode = true;
    this.printMode = false;
    this.pickup = null;
    this.drop = null;
    this.classList = null;
    this.history = null;
    this.componentDomStorage = componentDomStorage;
    this.maxHeight = 0;
    this.muted = false;
}]);
'use strict';
angular.module('komondor-editor').service('checkEditorHeight', ["editorState", "md5", "debounce", function (editorState, md5, debounce) {
    var unbindWatcher = void 0;
    var editorElement = void 0;
    var componentElement = void 0;
    var callback = void 0;
    this.watch = watch;
    this.unwatch = unwatch;
    this.checkHeight = checkHeight;
    this.setCallback = setCallback;
    var debounceHeightCheck = debounce(checkHeight, 300);
    function watch($scope, element) {
        if (editorState.maxHeight > 0) {
            componentElement = element;
            editorElement = $scope.editor.element;
            componentElement.on('keydown', debounceHeightCheck);
            unbindWatcher = $scope.$watch(function () {
                return md5.createHash(angular.toJson(editorState.componentScope.model));
            }, debounceHeightCheck);
        }
    }
    function unwatch() {
        if (editorState.maxHeight > 0) {
            if (unbindWatcher) {
                unbindWatcher();
            }
            if (typeof componentElement !== 'undefined') {
                componentElement.off('keydown', debounceHeightCheck);
                componentElement = editorElement = null;
            }
        }
    }
    function checkHeight() {
        if (!editorState.editMode || editorState.pickup) {
            return;
        }
        var editorContent = editorElement[0].querySelector('div.editor-content');
        if (editorContent.clientHeight > editorState.maxHeight) {
            if (!editorElement.hasClass('warning-overflow')) {
                editorElement.addClass('warning-overflow');
                if (angular.isFunction(callback)) {
                    callback();
                }
            }
        } else {
            editorElement.removeClass('warning-overflow');
        }
    }
    function setCallback(cb) {
        callback = cb;
    }
}]);
'use strict';
angular.module('komondor-editor').factory('ElementAttributes', function () {
    return function ElementAttributes(element, whiteList) {
        whiteList = whiteList || [];
        var byWildcard = function byWildcard(attr) {
            var field;
            var suffix = '*';
            var result = false;
            for (var key in whiteList) {
                if (result) {
                    break;
                }
                field = whiteList[key];
                // Unfortunately IE doesn't support String.prototype.endsWith and String.prototype.startsWith
                // So it's changed to a bit primitive way
                if (field.indexOf(suffix, field.length - suffix.length) !== -1) {
                    result = attr.lastIndexOf(field.replace(suffix, ''), 0) === 0;
                }
            }
            return result;
        };
        var isOnWhiteList = function isOnWhiteList(attr) {
            // Accept all attributes if whiteList empty
            if (whiteList.length === 0) {
                return true;
            }
            return whiteList.indexOf(attr) !== -1 || byWildcard(attr);
        };
        return {
            get: function get() {
                var attributes = {};
                angular.forEach(element[0].attributes, function (item) {
                    attributes[item.name] = item.value;
                });
                return attributes;
            },
            set: function set(attributes) {
                attributes = attributes || {};
                var name;
                var value;
                for (name in attributes) {
                    value = attributes[name];
                    if (isOnWhiteList(name)) {
                        if (value) {
                            element.attr(name, value);
                        } else {
                            element.removeAttr(name);
                        }
                    }
                }
            },
            clean: function clean() {
                var attrs = element[0].attributes, counter, name;
                for (counter = attrs.length - 1; counter >= 0; counter--) {
                    name = attrs[counter].name;
                    if (isOnWhiteList(name)) {
                        element.removeAttr(name);
                    }
                }
            }
        };
    };
});
'use strict';
angular.module('komondor-editor').factory('getCaretOffset', function () {
    return function (element) {
        var caretOffset = 0;
        var doc = element.ownerDocument || element.document;
        var win = doc.defaultView || doc.parentWindow;
        var sel;
        if (typeof win.getSelection !== 'undefined') {
            sel = win.getSelection();
            if (sel.rangeCount > 0) {
                var range = win.getSelection().getRangeAt(0);
                var preCaretRange = range.cloneRange();
                preCaretRange.selectNodeContents(element);
                preCaretRange.setEnd(range.endContainer, range.endOffset);
                caretOffset = preCaretRange.toString().length;
            }
        } else if ((sel = doc.selection) && sel.type !== 'Control') {
            var textRange = sel.createRange();
            var preCaretTextRange = doc.body.createTextRange();
            preCaretTextRange.moveToElementText(element);
            preCaretTextRange.setEndPoint('EndToEnd', textRange);
            caretOffset = preCaretTextRange.text.length;
        }
        return caretOffset;
    };
});
'use strict';
angular.module('komondor-editor').factory('getRelativeEventCoords', ["$window", "$document", function ($window, $document) {
    return function (mouseEvent, element) {
        var result = {
            x: 0,
            y: 0
        };
        if (!mouseEvent) {
            mouseEvent = $window.event;
        }
        if (mouseEvent.pageX || mouseEvent.pageY) {
            result.x = mouseEvent.pageX;
            result.y = mouseEvent.pageY;
        } else if (mouseEvent.clientX || mouseEvent.clientY) {
            result.x = mouseEvent.clientX + $document[0].body.scrollLeft + $document[0].documentElement.scrollLeft;
            result.y = mouseEvent.clientY + $document[0].body.scrollTop + $document[0].documentElement.scrollTop;
        }
        var target = element ? element : mouseEvent.target;
        if (target) {
            var offEl = target;
            var offX = 0;
            var offY = 0;
            if (typeof offEl.offsetParent !== 'undefined') {
                while (offEl) {
                    offX += offEl.offsetLeft;
                    offY += offEl.offsetTop;
                    offEl = offEl.offsetParent;
                }
            } else {
                offX = offEl.x;
                offY = offEl.y;
            }
            var offsetTop = $window.pageYOffset || $document[0].documentElement.scrollTop || 0;
            result.x -= offX;
            result.y -= offY - offsetTop;
        }
        return result;
    };
}]);
'use strict';
/**
 *
 * @deprecated
 */
angular.module('komondor-editor').factory('getSourceBySize', ["$log", function ($log) {
    $log.warn('getSourceBySize factory is deprecated!');
    return function getSourceBySize(asset, width) {
        if (!width || !asset.sources || !angular.isObject(asset.sources) || Object.keys(asset.sources).length === 0) {
            return {
                url: asset.links.download,
                name: ''
            };
        }
        var sources = asset.sources;
        var keys = Object.keys(sources);
        //If only one size option - use it.
        if (keys.length === 1) {
            sources[keys[0]].name = keys[0];
            return sources[keys[0]];
        }
        var closest = {
            diff: -1,
            object: null
        };
        var biggest = null;
        //Find closest and biggest by width.
        for (var key in sources) {
            var obj = sources[key];
            obj.name = key;
            if (width <= obj.width) {
                var tmpDiff = obj.width - width;
                if (closest.diff > tmpDiff || closest.diff < 0) {
                    closest.diff = tmpDiff;
                    closest.object = obj;
                }
            }
            if (biggest === null || obj.width > biggest.width) {
                biggest = obj;
            }
        }
        //Is found closest
        if (closest.object) {
            return closest.object;
        }
        //If not use biggest.
        if (biggest) {
            return biggest;
        }
    };
}]);
'use strict';
angular.module('komondor-editor').factory('htmlSanitizer', function () {
    return function (html, keep) {
        if (keep === undefined || keep === null) {
            keep = {
                // IE tags for execCommand
                strong: 'no attributes',
                em: 'no attributes',
                b: 'no attributes',
                i: 'no attributes',
                u: 'no attributes',
                strike: 'no attributes',
                del: 'no attributes',
                sub: 'no attributes',
                sup: 'no attributes',
                a: true,
                span: true,
                font: true,
                div: 'no attributes',
                br: 'no attributes'
            };
        }
        function removeNotAllowedAttrs(tagName, wholeMatch) {
            var regexStr = 's([a-z-]+)(?:=(\'[^\']*\'|"[^"]*"|[w]+))?';
            var regex = new RegExp(regexStr, 'gi');
            return wholeMatch.replace(regex, function (match, attr) {
                return keep[tagName][attr] ? match : '';
            });
        }
        function replaceSomeTags(wholeMatch, closing, tagName) {
            closing = closing ? closing : '';
            var tagNoAttr = '<' + closing + tagName + '>';
            if (keep[tagName] === 'no attributes') {
                return tagNoAttr;
            }
            if (keep[tagName] === true) {
                return wholeMatch;
            }
            if (angular.isObject(keep[tagName]) && Object.keys(keep[tagName]).length) {
                return closing ? tagNoAttr : removeNotAllowedAttrs(tagName, wholeMatch);
            }
            return '';
        }
        // Remove all HTML tags except bold and italic
        html = html.replace(/<(\/)?([a-z]+) ?[^>]*>/g, replaceSomeTags);
        return html;
    };
});
'use strict';
angular.module('komondor-editor').factory('htmlSplitter', ["htmlSanitizer", function (htmlSanitizer) {
    return function (html, newElementCallback, keepTags) {
        var i, parts;
        // Check if there are paragraph tags in the html
        if (/<(p|li)[^>]*>/.test(html)) {
            // Extract the contents of each paragraph tag
            parts = [];
            var matchedTextBefore = void 0;
            var textBeforeMatches = /^(?!<p|li)([\S\s]*?)<(p|li)/gi.exec(html);
            if (textBeforeMatches && textBeforeMatches[1].trim()) {
                // Remove all comments
                matchedTextBefore = textBeforeMatches[1].replace(/<!--[\s\S]*?-->/g, '');
            }
            html.replace(/<(p|li)[^>]*>([\S\s]*?)<\/(p|li)>/gi, function (wholeMatch, tagName, innerHTML) {
                var html = innerHTML;
                if (matchedTextBefore) {
                    // Put text before and first paragraph content
                    matchedTextBefore = tagName === 'p' ? matchedTextBefore : '';
                    html = matchedTextBefore + html;
                    matchedTextBefore = null;
                }
                parts.push(html);
            });
        } else {
            parts = [html];
        }
        // Remove all HTML tags except bold and italic
        for (i = 0; i < parts.length; i++) {
            parts[i] = htmlSanitizer(parts[i], keepTags);
        }
        // We have to process them backwards due to angulars event resolution being a stack
        // We don't process the first part because it gets returned instead
        for (i = parts.length - 1; i > 0; i--) {
            // Only if its not just whitespace
            if (!/^\s*$/.test(parts[i])) {
                newElementCallback(parts[i]);
            }
        }
        // Return only the first paragraphs html
        return parts[0];
    };
}]);
'use strict';
angular.module('komondor-editor').service('imagePopup', ["$uibModal", function ($uibModal) {
    this.defaults = {
        windowClass: 'image-modal',
        size: 'lg',
        templateUrl: 'ng-komondor-editor/components/imageModal.html',
        controller: ['$scope', 'image', function ($scope, image) {
                    $scope.image = image;
                }]
    };
    this.openFromEvent = function ($event, options) {
        $event.stopPropagation();
        $event.preventDefault();
        $event.stopInteractionHandlers = true;
        // Consider that target is a button
        var button = angular.element($event.target);
        var container = button.parent().parent();
        // Keep a space before to make it work in edit mode
        var re = new RegExp(' src="([^">]*/([^">]*?))".*?>');
        var match = container.html().match(re);
        if (match.length > 1) {
            this.open(match[1], options);
        } else {
            throw new Error('Image src is not found');
        }
    };
    this.open = function (src, options) {
        $uibModal.open(angular.extend({}, this.defaults, options, {
            resolve: {
                image: function image() {
                    return { url: src };
                }
            }
        }));
    };
}]);
'use strict';
angular.module('komondor-editor').service('jsondiffpatch', ["$window", function ($window) {
    return $window.jsondiffpatch;
}]);
'use strict';
angular.module('komondor-editor').factory('keys', function () {
    return {
        ENTER: 13,
        BACKSPACE: 8,
        TAB: 9,
        DELETE: 46
    };
});
'use strict';
function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
            arr2[i] = arr[i];
        }
        return arr2;
    } else {
        return Array.from(arr);
    }
}
angular.module('komondor-editor').service('muteService', ["$document", "editorState", function ($document, editorState) {
    this.toggle = function () {
        editorState.muted = !editorState.muted;
        this.set($document[0]);
    };
    this.set = function (element) {
        findAudioNodes(element).map(setMuted);
    };
    function findAudioNodes(element) {
        return [].concat(_toConsumableArray(element.getElementsByTagName('video')), _toConsumableArray(element.getElementsByTagName('audio')));
    }
    function setMuted(node) {
        if (!node.hasAttribute('data-forcemute')) {
            // Make sure we don't have an override for the mute
            // on the specific video element
            node.muted = editorState.muted;
        }
        return node;
    }
}]);
'use strict';
angular.module('komondor-editor').service('tempLinkFilter', function () {
    var tempHref = '#temp_url#';
    this.get = function (node) {
        return angular.element(node.querySelectorAll('a[href=\'' + tempHref + '\']'));
    };
    this.getTempHref = function () {
        return tempHref;
    };
    this.replaceWithContent = function (node) {
        var elements = this.get(node);
        angular.forEach(elements, function (elem) {
            elem = angular.element(elem);
            elem.replaceWith(elem.html());
        });
    };
});
'use strict';
angular.module('komondor-editor').factory('TextLink', ["editorState", "$timeout", "ElementAttributes", "WindowSelection", "notify", "$window", "tempLinkFilter", function (editorState, $timeout, ElementAttributes, WindowSelection, notify, $window, tempLinkFilter) {
    return function TextLink() {
        var self = this;
        self.node = null;
        self.found = null;
        self.editable = null;
        function getLinkNode() {
            return angular.element(WindowSelection.get('A', 'component'));
        }
        function createLinkNode() {
            $window.document.execCommand('createLink', false, '#temp_url#');
            var linkNodeElement = getLinkNode();
            if (!linkNodeElement) {
                linkNodeElement = $window.document.querySelector('a[href=\'#temp_url#\']');
                linkNodeElement = angular.element(linkNodeElement);
            }
            return linkNodeElement;
        }
        function getEditableParent() {
            var editable = self.node.parent();
            while (editable.length && editable.attr('contenteditable') === undefined) {
                editable = editable.parent();
            }
            return editable;
        }
        function commitChanges() {
            // Trigger content editable ng-model update
            if (self.editable) {
                self.editable.triggerHandler('keyup');
            }
        }
        this.getAttributes = function (current) {
            self.node = getLinkNode();
            self.found = self.node.length;
            if (self.node.length === 0 && !current) {
                self.node = createLinkNode();
            }
            if (self.node.length === 0) {
                throw current ? 'Link not found' : 'Cannot create a link';
            }
            self.editable = getEditableParent();
            if (!self.found) {
                editorState.tracker.skip();
                commitChanges();
            }
            var linkNodeAttributes = new ElementAttributes(self.node);
            return linkNodeAttributes.get();
        };
        this.setAttributes = function (attributes) {
            var linkNodeAttributes = new ElementAttributes(self.node);
            linkNodeAttributes.set(attributes || {});
            tempLinkFilter.replaceWithContent(self.node[0]);
            commitChanges();
        };
        this.emptyAttributes = function () {
            var html = self.node.html();
            self.node.replaceWith($window.document.createTextNode(html));
            commitChanges();
        };
        this.onSetAttributesDismiss = function () {
            // Don't touch current link
            if (self.found) {
                return;
            }
            // Destroy temp link
            self.emptyAttributes();
        };
    };
}]);
'use strict';
angular.module('komondor-editor').service('WindowSelection', ["$window", "$document", function ($window, $document) {
    this.get = function (tag, stopElementAttr) {
        var node;
        var selection;
        // FF3.6, Safari4, Chrome5 (DOM Standards)
        if ($window.getSelection) {
            selection = $window.getSelection();
            node = selection.anchorNode;
            var userAgent = $window.navigator.userAgent;
            var isFirefox = /firefox/i.test(userAgent);
            // FF doesn't get [a] element it's selected for some reason
            // This part of code use in jQuery.fn.selectedText
            // Full code can be found here http://www.perplexed.co.uk/1020_text_selector_jquery_plugin.htm
            if (!selection.isCollapsed && isFirefox) {
                var anchorNode = selection.anchorNode.childNodes[selection.anchorOffset];
                // If we've selected an element, (note: only works on Anchors, only checked bold and spans)
                // we can use the anchorOffset to find the childNode that has been selected
                if (selection.focusNode.nodeName !== '#text' && anchorNode && anchorNode.nodeName !== '#text') {
                    node = selection.anchorNode.childNodes[selection.anchorOffset];
                }
            }
        }
        // IE
        if (!node && $document[0].selection) {
            selection = $document[0].selection;
            var range = selection.getRangeAt ? selection.getRangeAt(0) : selection.createRange();
            if (range.commonAncestorContainer) {
                node = range.commonAncestorContainer;
            } else {
                node = range.parentElement ? range.parentElement() : range.item(0);
            }
        }
        if (node) {
            node = node.nodeName === '#text' ? node.parentNode : node;
            if (tag && stopElementAttr) {
                var stopElement;
                while (node && node.tagName !== tag) {
                    if (node.tagName === 'BODY') {
                        node = null;
                    } else {
                        // Stop looking outside of the component
                        stopElement = node.parentNode.hasAttribute(stopElementAttr);
                        node = stopElement ? null : node.parentNode;
                    }
                }
            }
            return node;
        } else {
            return null;
        }
    };
}]);
'use strict';
angular.module('komondor-editor')    // Moving all backwards compatibility out from a main class
.factory('BackCompatTableAdapter', function () {
    return function BackCompatTableAdapter(table) {
        var self = this;
        // Main function to apply all fixes
        this.adapt = function () {
            table.applyForEveryCell(function (cell) {
                cell = self.adaptEmptyCell(cell);
                self.adaptThCell(cell);
                self.adaptClasses(cell);
            });
        };
        /**
         * This is a backwards compatibility to convert old cells
         * from array to object.
         *
         * @param  {Object} cell
         */
        this.adaptEmptyCell = function (cell) {
            if (angular.isArray(cell)) {
                return table.options.emptyCell();
            }
            return cell;
        };
        /**
         * This is a backwards compatibility to convert old cells with the
         * th class to use the th property.
         * @param  {Object} cell
         */
        this.adaptThCell = function (cell) {
            var classes = cell.class ? cell.class.split(' ') : [];
            var index = classes.indexOf('th');
            if (index !== -1) {
                classes.splice(index, 1);
                cell.class = classes.join(' ');
                if (cell.class === '') {
                    delete cell.class;
                }
                cell.th = true;
            }
            if (cell.th && !cell.classes) {
                cell.classes = ['th'];
            }
        };
        /**
         * This is a backwards compatibility to
         * clean up selected class from a cell
         * @param  {Object} cell
         */
        this.adaptClasses = function (cell) {
            var classes = angular.isArray(cell.classes) ? cell.classes : [];
            var index = classes.indexOf('selected');
            if (index !== -1) {
                classes.splice(index, 1);
            }
            if (cell.highlightOption) {
                classes.push(cell.highlightOption);
                // Put it to highlightClass and delete
                cell.highlightClass = cell.highlightOption;
                delete cell.highlightOption;
            }
            cell.classes = classes;
        };
    };
});
'use strict';
angular.module('komondor-editor').factory('BackCompatTabsAdapter', function () {
    return function BackCompatTabsAdapter(data) {
        // Main function to apply all fixes
        this.adapt = function () {
            if (!angular.isUndefined(data.has_info)) {
                data.hasInfo = data.has_info;
                delete data.has_info;
            }
            if (!angular.isUndefined(data.has_title)) {
                data.hasTitle = data.has_title;
                delete data.has_title;
            }
            if (data.selected) {
                delete data.selected;
            }
        };
    };
});
'use strict';
angular.module('komondor-editor').directive('bullets', ["$timeout", "keys", "htmlSplitter", "zeroWidthSpaceCleaner", "notify", "jsondiffpatch", function ($timeout, keys, htmlSplitter, zeroWidthSpaceCleaner, notify, jsondiffpatch) {
    var bindings = {};
    bindings[keys.ENTER] = pressEnter;
    bindings[keys.BACKSPACE] = pressDelete;
    bindings[keys.DELETE] = pressDelete;
    return {
        restrict: 'A',
        replace: true,
        require: '^component',
        templateUrl: 'ng-komondor-editor/scripts/components/bullets/bullets.html',
        link: link
    };
    function cancel($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return false;
    }
    function focusChild(element, $index) {
        $timeout(function () {
            var items = element.children();
            if (items[$index]) {
                items[$index].children[0].focus();
            }
        });
    }
    function pressEnter($event, $scope, element, $index) {
        $scope.data.list.splice($index + 1, 0, { html: '' });
        focusChild(element, $index + 1);
        return cancel($event);
    }
    function pressDelete($event, $scope, element, $index) {
        // Make sure to remove special characters before testing content
        // fixes issue on firefox of special characters remaining
        var content = $scope.data.list[$index].html.replace(/(<br\ ?\/?>)+/gi, '');
        content = zeroWidthSpaceCleaner.remove(content);
        // If the list item is not empty let the keypress through
        if (content !== '') {
            return;
        }
        // If the list item has nested children let the keypress through
        if ($scope.data.list[$index].nested && $scope.data.list[$index].nested.length > 0) {
            return;
        }
        if ($scope.data.list.length > 1) {
            // Remove the list item
            $scope.data.list.splice($index, 1);
            // Focus the list item before this one, or the first one
            focusChild(element, Math.max($index - 1, 0));
        } else {
            // Destroy the whole element
            $scope.forceDestroy();
        }
        // Cancel the keypress
        return cancel($event);
    }
    function link($scope, element, attributes, component) {
        var editorState = component.editor.state;
        var historyCommitAllowed = true;
        var commit = function commit(action) {
            return function () {
                historyCommitAllowed = false;
                action.apply($scope, arguments);
                $timeout(function () {
                    historyCommitAllowed = true;
                });
            };
        };
        $scope.selected = null;
        $scope.data.list = $scope.data.list || [{
                    html: ''
                }];
        component.setFocusRequestHandler(function () {
            focusChild(element, 0);
        });
        component.setHtmlProcessor(function (html) {
            return htmlSplitter(html, function (html) {
                if ($scope.selected) {
                    var idx = $scope.data.list.indexOf($scope.selected);
                    $scope.createNewBullet(html, idx + 1);
                } else {
                    $scope.createNewBullet(html);
                }
            }, component.sanitizerRules);
        });
        $scope.onKeydown = function ($event, $index) {
            if (bindings[$event.keyCode]) {
                return bindings[$event.keyCode]($event, $scope, element, $index);
            }
        };
        $scope.createNewBullet = function (html, idx) {
            var item = { html: html };
            if (idx === undefined) {
                $scope.data.list.push(item);
                idx = $scope.data.list.length - 1;
            } else {
                $scope.data.list.splice(idx, 0, item);
            }
            focusChild(element, idx);
        };
        $scope.$on('component:focus', function ($event) {
            for (var i = 0; i < $scope.data.list.length; i++) {
                var item = $scope.data.list[i];
                if (item === $event.targetScope.item) {
                    $scope.selected = item;
                }
            }
        });
        $scope.addNested = commit(function () {
            if ($scope.selected.nested) {
                return;
            }
            $scope.selected.nested = [];
            $timeout(function () {
                $scope.$broadcast('component:request-focus', $scope.selected.nested);
            });
            if (!component.list.isCommittable()) {
                return;
            }
            var index = $scope.data.list.indexOf($scope.selected);
            editorState.history.commit({
                undo: function undo() {
                    $scope.data.list[index].nested = undefined;
                },
                redo: function redo() {
                    $scope.data.list[index].nested = [];
                }
            });
        });
        $scope.destroyNested = function () {
            if (!$scope.selected.nested) {
                return;
            }
            var addToHistory = commit(function () {
                delete $scope.selected.nested;
                if (!component.list.isCommittable()) {
                    return;
                }
                var index = $scope.data.list.indexOf($scope.selected);
                editorState.history.commit({
                    undo: function undo() {
                        $scope.data.list[index].nested = [];
                    },
                    redo: function redo() {
                        $scope.data.list[index].nested = undefined;
                    }
                });
            });
            if ($scope.selected.nested.length === 0) {
                addToHistory();
                return;
            }
            notify.confirm('Are you sure you want to remove all nested components?').result.then(function () {
                addToHistory();
            });
        };
        $scope.moveBullet = function (item, distance) {
            if (!item) {
                return;
            }
            var idx = $scope.data.list.indexOf(item);
            var moveTo = idx + distance;
            if ($scope.data.list[moveTo] === undefined) {
                return;
            }
            $scope.data.list.splice(moveTo, 0, $scope.data.list.splice(idx, 1)[0]);
            focusChild(element, moveTo);
        };
        $scope.moveBulletUp = commit(function () {
            $scope.moveBullet($scope.selected, -1);
            if (!component.list.isCommittable()) {
                return;
            }
            var distance;
            var index = $scope.data.list.indexOf($scope.selected);
            editorState.history.commit({
                undo: commit(function undo() {
                    distance = 1;
                    $scope.moveBullet($scope.data.list[index], distance);
                    index += distance;
                }),
                redo: commit(function redo() {
                    distance = -1;
                    $scope.moveBullet($scope.data.list[index], distance);
                    index += distance;
                })
            });
        });
        $scope.moveBulletDown = commit(function () {
            $scope.moveBullet($scope.selected, 1);
            if (!component.list.isCommittable()) {
                return;
            }
            var distance;
            var index = $scope.data.list.indexOf($scope.selected);
            editorState.history.commit({
                undo: commit(function undo() {
                    distance = -1;
                    $scope.moveBullet($scope.data.list[index], distance);
                    index += distance;
                }),
                redo: commit(function redo() {
                    distance = 1;
                    $scope.moveBullet($scope.data.list[index], distance);
                    index += distance;
                })
            });
        });
        $scope.getTrackables = function () {
            return {
                'data.list': {
                    deepWatch: true,
                    collection: true,
                    allowCommit: function allowCommit(newValue, oldValue) {
                        if (!historyCommitAllowed) {
                            return false;
                        }
                        var component;
                        var diffpatcher = jsondiffpatch.create({
                            propertyFilter: function propertyFilter(name) {
                                return name.slice(0, 1) !== '$';
                            }
                        });
                        var listDelta = diffpatcher.diff(oldValue, newValue);
                        for (var componentIndex in listDelta) {
                            // Skip if not a key but indicator that array' changed
                            if (componentIndex === '_t') {
                                continue;
                            }
                            component = listDelta[componentIndex];
                            // Don't commit any changes related with nested
                            // It has to do it in component way
                            if (component.hasOwnProperty('nested')) {
                                return false;
                            }
                        }
                        return true;
                    }
                },
                class: { deepWatch: false }
            };
        };
    }
}]);
'use strict';
angular.module('komondor-editor').directive('descriptionList', ["$timeout", "keys", function ($timeout, keys) {
    var bindings = {};
    bindings[keys.ENTER] = pressEnter;
    bindings[keys.BACKSPACE] = pressDelete;
    bindings[keys.DELETE] = pressDelete;
    return {
        replace: true,
        require: '^component',
        templateUrl: 'ng-komondor-editor/scripts/components/description-list/description-list.html',
        link: link
    };
    function cancel($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return false;
    }
    function focusChild(element, $index) {
        $timeout(function () {
            var items = element.children();
            if (items[$index]) {
                items[$index].focus();
            }
        });
    }
    function pressEnter($event, $scope, element, $index) {
        // Get tag of selected item
        var tag = $scope.data.list[$index].tag;
        // If item is a <dt> add a <dd> after and vice versa
        if (tag === 'dt') {
            $scope.data.list.splice($index + 1, 0, {
                tag: 'dd',
                html: ''
            });
        } else if (tag === 'dd') {
            $scope.data.list.splice($index + 1, 0, {
                tag: 'dt',
                html: ''
            });
        }
        // Focus new item
        focusChild(element, $index + 1);
        return cancel($event);
    }
    function pressDelete($event, $scope, element, $index) {
        // If the list item is not empty let the keypress through
        if ($scope.data.list[$index].html !== '') {
            return;
        }
        // If the list item has nested children let the keypress through
        if ($scope.data.list[$index].nested && $scope.data.list[$index].nested.length > 0) {
            return;
        }
        if ($scope.data.list.length > 1) {
            // Remove the list item
            $scope.data.list.splice($index, 1);
            // Focus the list item before this one, or the first onev
            var focusIdx = $index;
            if ($index > 0 && $event.keyCode === keys.BACKSPACE) {
                focusIdx = $index - 1;
            }
            focusChild(element, focusIdx);
        } else {
            // Destroy the whole element
            $scope.forceDestroy();
        }
        // Cancel the keypress
        return cancel($event);
    }
    function link($scope, element, attrs, component) {
        $scope.selected = null;
        $scope.data.list = $scope.data.list || [{
                    tag: 'dt',
                    html: ''
                }, {
                    tag: 'dd',
                    html: ''
                }];
        component.setFocusRequestHandler(function () {
            focusChild(element, 0);
        });
        $scope.onKeydown = function ($event, $index) {
            if (bindings[$event.keyCode]) {
                var result = bindings[$event.keyCode]($event, $scope, element, $index);
                return result;
            }
        };
        $scope.$on('component:focus', function ($event, value) {
            for (var i = 0; i < $scope.data.list.length; i++) {
                var item = $scope.data.list[i];
                if (item.html === value) {
                    $scope.selected = item;
                    break;
                }
            }
        });
        $scope.addDescListChild = function (childType) {
            var idx = $scope.data.list.indexOf($scope.selected);
            var item = {
                tag: childType,
                html: ''
            };
            if (idx === -1) {
                $scope.data.list.push(item);
            } else {
                $scope.data.list.splice(idx + 1, 0, item);
                focusChild(element, idx + 1);
            }
        };
    }
}]);
'use strict';
angular.module('komondor-editor').config(["$provide", function ($provide) {
    /**
     * intercept click
     */
    $provide.decorator('interactionHandlers', ["$delegate", "imagePopup", function ($delegate, imagePopup) {
        $delegate.addHandler('click', function ($event) {
            var elem = angular.element($event.target);
            // make sure have clicked the right target
            if (elem.hasClass('expand-icon')) {
                imagePopup.openFromEvent($event);
            }
        });
        return $delegate;
    }]);
}]);
'use strict';
angular.module('komondor-editor').directive('image', ["$uibModal", "assetCache", "$window", "$timeout", "debounce", "objectDefaults", "imagePopup", function ($uibModal, assetCache, $window, $timeout, debounce, objectDefaults, imagePopup) {
    controller.$inject = ["$scope", "$element"];
    return {
        replace: true,
        require: '^component',
        templateUrl: 'ng-komondor-editor/scripts/components/image/image.html',
        controller: controller
    };
    function controller($scope, $element) {
        var component = $element.controller('component');
        var innerElement = null;
        var urlAt = component.options.urlAt;
        var self = this;
        var imageDefaults = {
            asset_id: null,
            caption: '',
            ratio: [16, 9],
            overlayPos: 'bottom',
            anchor: 'Centre Middle',
            width: '100%',
            offline: false,
            hasCaption: false
        };
        this.$onInit = function () {
            // Backward compatibility property mapping
            if ($scope.data.imageConfig) {
                $scope.data.width = $scope.data.imageConfig.width + $scope.data.imageConfig.unit;
            }
            $scope.data = objectDefaults($scope.data, imageDefaults);
            $scope.state = component.editor.state;
            // Computed properties
            $scope.computed = {
                width: Number(splitValue($scope.data.width)[1]),
                widthUnit: splitValue($scope.data.width)[2],
                style: {}
            };
            // Component options
            $scope.overlayPositions = {
                top: 'Top',
                middle: 'Middle',
                bottom: 'Bottom'
            };
            $scope.anchorOptions = {
                'Left Top': {
                    class: 'left-top',
                    percent: '0 0'
                },
                'Left Middle': {
                    class: 'left-middle',
                    percent: '0 50%'
                },
                'Left Bottom': {
                    class: 'left-bottom',
                    percent: '0 100%'
                },
                'Centre Top': {
                    class: 'center-top',
                    percent: '50% 0'
                },
                'Centre Middle': {
                    class: 'center-middle',
                    percent: '50% 50%'
                },
                'Centre Bottom': {
                    class: 'center-bottom',
                    percent: '100% 100%'
                },
                'Right Top': {
                    class: 'right-top',
                    percent: '100% 0'
                },
                'Right Middle': {
                    class: 'right-middle',
                    percent: '100% 50%'
                },
                'Right Bottom': {
                    class: 'right-bottom',
                    percent: '100% 100%'
                }
            };
            var resize = debounce(function () {
                $scope.imageStyleChanged();
            }, 250);
            angular.element($window).on('resize', resize);
            $scope.$on('$destroy', function () {
                angular.element($window).off('resize', resize);
            });
            $scope.$watch('data.asset_id', function () {
                if (!$scope.data.asset_id) {
                    self.setUrl(component.options.placeholderImage);
                    $scope.imageStyleChanged();
                    return;
                }
                assetCache.get($scope.data.asset_id).then(function (asset) {
                    self.setUrl(asset.links.download);
                }).then($scope.imageStyleChanged);
            });
            //$watchGroup doesn't support deep watch
            $scope.$watchGroup(['computed.width', 'computed.widthUnit', 'data.ratio[0]', 'data.ratio[1]', 'data.anchor'], function (newValue, oldValue) {
                // Stop first call.
                if (newValue === oldValue) {
                    return;
                }
                $scope.imageStyleChanged();
            });
            // Init
            component.removeDataProperties(['fixedHeight', 'height', 'size', 'imageWidth', 'unit', 'placeholder', 'style', 'imageConfig', 'sources']);
            // Set aspect ratio after component is visible
            $scope.$watch(this.isVisible, function (newValue, oldValue) {
                // Show component if it was hidden before
                if (newValue === true && oldValue === false) {
                    $scope.imageStyleChanged();
                }
            });
        };
        this.isVisible = function () {
            // Ignore if no aspect ratio set
            if (!$scope.data.setAspectRatio) {
                return true;
            }
            // Component is displayed (all dims more than zero)
            if ($element[0].offsetWidth && $element[0].offsetHeight) {
                return true;
            }
            return false;
        };
        // Allow a single image-wrapper element to add its self
        this.addImageWrapperElement = function (element) {
            if (innerElement !== null) {
                return;
            }
            innerElement = element;
        };
        this.setUrl = function (url) {
            $scope[urlAt].url = url;
        };
        this.getUrl = function () {
            return $scope[urlAt].url;
        };
        // Scope functions
        $scope.setOverlayPosition = function (pos) {
            $scope.data.overlayPos = pos;
        };
        // Why is it popupFun?
        $scope.popupFun = function () {
            imagePopup.open(self.getUrl());
        };
        $scope.imageStyleChanged = function () {
            $scope.data.width = $scope.computed.width + $scope.computed.widthUnit;
            $scope.computed.style = {
                width: $scope.data.width,
                backgroundSize: 'cover'
            };
            if ($scope.data.setAspectRatio) {
                $timeout(function () {
                    var ratio = $scope.data.ratio[1] / $scope.data.ratio[0];
                    var percent = $scope.anchorOptions[$scope.data.anchor].percent;
                    $scope.computed.style.height = innerElement.clientWidth * ratio + 'px';
                    $scope.computed.style.backgroundImage = 'url(' + self.getUrl() + ')';
                    $scope.computed.style.backgroundPosition = percent;
                });
            } else {
                $scope.computed.style.height = 'auto';
                $scope.computed.style.backgroundPosition = 'initial';
            }
        };
        $scope.getTrackables = function () {
            return {
                'data.asset_id': { deepWatch: false },
                'data.offline': { deepWatch: false },
                'data.hasCaption': { deepWatch: false },
                'data.caption': { deepWatch: false },
                class: { deepWatch: false }
            };
        };
    }
    function splitValue(value) {
        return value.match(/^(\d+(?:\.\d+)?)(.*)$/);
    }
}]);
'use strict';
angular.module('komondor-editor').directive('imageWrapper', function () {
    return {
        restrict: 'C',
        require: '^image',
        controller: ["$scope", "$element", function controller($scope, $element) {
            var imageComponent = $element.controller('image');
            imageComponent.addImageWrapperElement($element[0]);
        }]
    };
});
'use strict';
angular.module('komondor-editor').directive('table', ["$timeout", "notify", "editorState", "objectDefaults", "TableValidator", "jsondiffpatch", "BackCompatTableAdapter", function ($timeout, notify, editorState, objectDefaults, TableValidator, jsondiffpatch, BackCompatTableAdapter) {
    controller.$inject = ["$scope", "Table", "$element"];
    return {
        restrict: 'A',
        require: '^component',
        templateUrl: 'ng-komondor-editor/scripts/components/table/table.html',
        controller: controller
    };
    /**
     * Controller
     *
     * @param  {service} $scope
     * @param  {service} Table
     * @param  {Object} $element
     */
    function controller($scope, Table, $element) {
        var sectionNames = ['thead', 'tbody'];
        var historyCommitAllowed = true;
        var cellNumberChange = false;
        var ctrl = this;
        var lastRemovedColumn = [];
        var tableOptions = {
            cols: 2,
            rows: 1,
            sections: sectionNames,
            emptyCell: function emptyCell() {
                return {
                    content: '',
                    classes: []
                };
            }
        };
        var component = $element.controller('component');
        var tableDefaults = {
            has_caption: false,
            caption: '',
            has_info: false,
            info: '',
            has_fixed: false,
            has_nowrap: false,
            wrapperClass: { has_hscroll: false },
            tableClass: component.options.tableClass
        };
        var contextParams = null;
        this.$onInit = function () {
            // Directive Members
            $scope.selected = null;
            // Persisted Members
            $scope.data = objectDefaults($scope.data, tableDefaults);
            $scope.highlightOptions = component.options.highlightOptions;
            $scope.allowTh = component.options.allowTh;
            this.mergeConfirmed = false;
            this.table = new Table($scope.data, tableOptions);
            this.validator = new TableValidator(this.table, $scope);
            // Backwards Compatibility
            var tableAdapter = new BackCompatTableAdapter(this.table);
            tableAdapter.adapt();
        };
        this.addColumn = function (before, column) {
            var cell = $scope.selected.cell;
            var pos = $scope.selected.position;
            var colspan = cell.colspan || 1;
            var col = pos.col + colspan;
            this.table.addColumn(col - 1, before, column);
            // Select newly added column cell
            var map = this.table.map(pos.section);
            var selectedCell = map[pos.row][col];
            $scope.select(selectedCell);
        };
        this.removeColumn = function () {
            var pos = $scope.selected.position;
            this.table.removeColumn(pos.col);
            // Select cell before or on the same position
            var cell = this.table.getCell(pos.section, pos.row, pos.colReal - 1);
            if (!cell) {
                cell = this.table.getCell(pos.section, pos.row, pos.colReal);
            }
            $scope.select(cell);
        };
        this.commit = function (action) {
            return function () {
                historyCommitAllowed = false;
                action.apply(ctrl, arguments);
                $timeout(function () {
                    historyCommitAllowed = true;
                });
            };
        };
        this.confirmMerge = function (confirmMessage, action) {
            return function () {
                if (ctrl.mergeConfirmed) {
                    action();
                    return;
                }
                notify.confirm(confirmMessage).result.then(function () {
                    ctrl.mergeConfirmed = true;
                    action();
                });
            };
        };
        this.selectDefaultCell = function () {
            var sectionName = 'tbody';
            var colIndex = this.table.getColNumber() - 1;
            var rowIndex = this.table.getRowNumber(sectionName) - 1;
            $scope.select(this.table.getCell(sectionName, rowIndex, colIndex));
        };
        this.findChangedCell = function (newRows, oldRows, section) {
            var row;
            var diffpatcher = jsondiffpatch.create({
                propertyFilter: function propertyFilter(name) {
                    return name.slice(0, 1) !== '$';
                }
            });
            var rowsDelta = diffpatcher.diff(oldRows, newRows);
            for (var rowIndex in rowsDelta) {
                // Skip if it's _t indicating that change has been made to array
                if (rowIndex === '_t') {
                    continue;
                }
                rowIndex = rowIndex.replace('_', '');
                row = rowsDelta[rowIndex];
                for (var colIndex in row) {
                    if (colIndex === '_t') {
                        continue;
                    }
                    colIndex = colIndex.replace('_', '');
                    var cell = $scope.data[section][rowIndex][colIndex];
                    return {
                        delta: row[colIndex],
                        position: ctrl.table.findCell(cell)
                    };
                }
            }
            return null;
        };
        this.getCommitContext = function (section) {
            var formTrackables = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            return function (newValue, oldValue) {
                var context = {
                    type: null,
                    params: {}
                };
                if (contextParams) {
                    context.params = angular.copy(contextParams);
                    contextParams = null;
                }
                if (!historyCommitAllowed) {
                    context.type = 'table:locked';
                    return context;
                }
                if (cellNumberChange) {
                    cellNumberChange = false;
                    context.type = 'cell-number:change';
                    return context;
                }
                var info = ctrl.findChangedCell(newValue, oldValue, section);
                var nestedChanged = info && info.delta ? info.delta.hasOwnProperty('nested') : null;
                // Don't commit any changes related with nested
                if (nestedChanged) {
                    context.type = 'cell-nested:change';
                    return context;
                }
                var contentChanged = info && info.delta ? info.delta.hasOwnProperty('content') : null;
                if (contentChanged && $scope.selected) {
                    context.type = 'cell-content:change';
                    context.params.selectedPosition = $scope.selected.position;
                    return context;
                }
                if (formTrackables) {
                    context.type = 'table:locked';
                    return context;
                }
                context.type = 'cell-flag:change';
                return context;
            };
        };
        this.allowCommit = function (newValue, oldValue, context) {
            // Not allow if table locked
            if (context.type === 'table:locked') {
                return false;
            }
            // Not allow on table cell nested component change
            if (context.type === 'cell-nested:change') {
                return false;
            }
            return true;
        };
        this.onHistoryChange = function (context) {
            if (!(context.params && context.params.selectedPosition)) {
                return;
            }
            return function () {
                var position = context.params.selectedPosition;
                var map = ctrl.table.map(position.section);
                $scope.select(map[position.row][position.col]);
            };
        };
        this.toggleCellNest = function (pos) {
            var cell = ctrl.table.getCell(pos.section, pos.row, pos.col);
            cell.nested = cell.hasNest ? [] : cell.nested;
            cell.hasNest = !cell.hasNest;
        };
        $scope.deleteTextAlign = function () {
            delete $scope.selected.cell.textAlign;
        };
        // Commit column add/remove separately from a watcher
        // As it does multiple changes
        $scope.addColumn = this.commit(function () {
            if (!$scope.selected) {
                this.selectDefaultCell();
            }
            if (!this.validator.canAddColumn()) {
                return;
            }
            cellNumberChange = true;
            var selectedCellPos = $scope.selected.position;
            var rowIndex = selectedCellPos.row;
            var colIndex = selectedCellPos.col;
            var colspan = $scope.selected.cell.colspan || 1;
            var nextCol = selectedCellPos.col + colspan;
            editorState.history.commit({
                undo: function undo() {
                    var map = ctrl.table.map(selectedCellPos.section);
                    $scope.select(map[rowIndex][nextCol]);
                    $scope.removeColumn();
                },
                redo: function redo() {
                    var map = ctrl.table.map(selectedCellPos.section);
                    $scope.select(map[rowIndex][colIndex]);
                    $scope.addColumn();
                }
            });
            this.addColumn.apply(ctrl, arguments);
        });
        $scope.addRow = function () {
            if (!$scope.selected) {
                ctrl.selectDefaultCell();
            }
            if (!ctrl.validator.canAddRow()) {
                return;
            }
            cellNumberChange = true;
            var cell = $scope.selected.cell;
            var pos = $scope.selected.position;
            var rowspan = cell.rowspan || 1;
            var nextRow = pos.row + rowspan;
            ctrl.table.addRow(pos.section, nextRow);
            var selectedCell = ctrl.table.getCell(pos.section, nextRow, pos.col);
            // Select cell in next column
            $scope.select(selectedCell);
        };
        $scope.removeColumn = this.commit(function () {
            if (!ctrl.validator.canRemoveColumn()) {
                return;
            }
            cellNumberChange = true;
            var pos = $scope.selected.position;
            var rowIndex = pos.row;
            var colIndex = pos.col;
            var section = pos.section;
            editorState.history.commit({
                undo: function undo() {
                    var map = ctrl.table.map(section);
                    var row = map[rowIndex];
                    var before = row[colIndex];
                    var col = before ? colIndex : colIndex - 1;
                    var cell = row[col];
                    $scope.select(cell);
                    $scope.addColumn(before, lastRemovedColumn);
                },
                redo: function redo() {
                    var cell = ctrl.table.getCell(pos.section, rowIndex, colIndex);
                    $scope.select(cell);
                    $scope.removeColumn();
                }
            });
            lastRemovedColumn = this.table.getColumn(pos.col);
            ctrl.removeColumn.apply(ctrl, arguments);
        });
        // Remove row from bottom to the top
        $scope.removeRow = function () {
            if (!ctrl.validator.canRemoveRow()) {
                return;
            }
            cellNumberChange = true;
            var pos = $scope.selected.position;
            ctrl.table.removeRow(pos.section, pos.row);
            // Select cell before or on the same position
            var cell = ctrl.table.getCell(pos.section, pos.row - 1, pos.colReal);
            if (!cell) {
                cell = ctrl.table.getCell(pos.section, pos.row, pos.colReal);
            }
            // Select cell in next column
            $scope.select(cell);
        };
        $scope.select = function (cell) {
            var position = ctrl.table.findCell(cell);
            if (!position) {
                throw new Error('Cell select failed due to it cannot be found');
            }
            $scope.selected = {
                cell: cell,
                position: position
            };
        };
        $scope.isSelected = function (cell) {
            return $scope.selected && $scope.selected.cell === cell;
        };
        $scope.toggleHighlight = ctrl.commit(function () {
            var position = $scope.selected.position;
            var toggle = function toggle() {
                var cell = ctrl.table.getCell(position.section, position.row, position.col);
                cell.highlight = !cell.highlight;
                $scope.updateCellClasses(cell);
            };
            editorState.history.commit({
                undo: ctrl.commit(toggle),
                redo: ctrl.commit(toggle)
            });
            $scope.updateCellClasses($scope.selected.cell);
        });
        $scope.selectHighlightClass = ctrl.commit(function (oldValue) {
            var highlightClass = $scope.selected.cell.highlightClass;
            var position = $scope.selected.position;
            $scope.updateCellClasses($scope.selected.cell);
            editorState.history.commit({
                undo: ctrl.commit(function () {
                    var cell = ctrl.table.getCell(position.section, position.row, position.col);
                    cell.highlightClass = oldValue;
                    $scope.updateCellClasses(cell);
                }),
                redo: ctrl.commit(function () {
                    var cell = ctrl.table.getCell(position.section, position.row, position.col);
                    cell.highlightClass = highlightClass;
                    $scope.updateCellClasses(cell);
                })
            });
        });
        $scope.updateCellClasses = function (cell) {
            cell = cell || $scope.selected.cell;
            var classes = [];
            if (cell.th) {
                classes.push('th');
            }
            if (cell.textAlign) {
                classes.push(cell.textAlign);
            }
            if (cell.highlight) {
                classes.push('highlight');
                if (cell.highlightClass) {
                    classes.push(cell.highlightClass);
                }
            }
            cell.classes = classes;
        };
        $scope.toggleNest = ctrl.commit(function () {
            var cell = $scope.selected.cell;
            var pos = $scope.selected.position;
            var commit = function commit() {
                editorState.history.commit({
                    undo: ctrl.commit(function () {
                        ctrl.toggleCellNest(pos);
                    }),
                    redo: ctrl.commit(function () {
                        ctrl.toggleCellNest(pos);
                    })
                });
            };
            if (!cell.hasNest && cell.nested && cell.nested.length) {
                notify.confirm('Remove all nested cell components?').result.then(function () {
                    delete cell.nested;
                    commit();
                }, function () {
                    cell.hasNest = true;
                    $timeout(function () {
                        editorState.history.cancelLast();
                    });
                });
                return;
            }
            commit();
        });
        $scope.mergeRight = this.confirmMerge('Merging cells will only preserve the top-leftmost value. Merge anyway?', function () {
            if (!ctrl.validator.canMergeRight()) {
                return;
            }
            cellNumberChange = true;
            ctrl.table.mergeRight($scope.selected.cell);
            contextParams = { selectedPosition: $scope.selected.position };
        });
        $scope.mergeDown = this.confirmMerge('Merging cells will only preserve the top-leftmost value. Merge anyway?', function () {
            if (!ctrl.validator.canMergeDown()) {
                return;
            }
            cellNumberChange = true;
            ctrl.table.mergeDown($scope.selected.cell);
            contextParams = { selectedPosition: $scope.selected.position };
        });
        $scope.unmerge = function () {
            if (!ctrl.validator.canUnmerge()) {
                return;
            }
            cellNumberChange = true;
            ctrl.table.unmerge($scope.selected.cell);
            contextParams = { selectedPosition: $scope.selected.position };
        };
        $scope.getTrackables = function () {
            return {
                'data.thead': {
                    deepWatch: true,
                    collection: true,
                    onChange: ctrl.onHistoryChange,
                    allowCommit: ctrl.allowCommit,
                    getContext: ctrl.getCommitContext('thead', true)
                },
                'data.tbody': {
                    deepWatch: true,
                    collection: true,
                    onChange: ctrl.onHistoryChange,
                    allowCommit: ctrl.allowCommit,
                    getContext: ctrl.getCommitContext('tbody', true)
                },
                'data.has_caption': { deepWatch: false },
                'data.caption': { deepWatch: false },
                'data.has_info': { deepWatch: false },
                'data.info': { deepWatch: false },
                'data.has_fixed': { deepWatch: false }
            };
        };
    }
}]);
'use strict';
angular.module('komondor-editor').factory('Table', function () {
    return function Table(data, options) {
        var defaultOptions = {
            cols: 1,
            rows: 1,
            sections: ['thead', 'tbody'],
            emptyCell: function emptyCell() {
                return { content: '' };
            }
        };
        var addToMap = function addToMap(map, cell, posY, posX) {
            var colSpan = cell.colspan || 1;
            var rowSpan = cell.rowspan || 1;
            if (colSpan === 1 && rowSpan === 1) {
                map[posY][posX] = cell;
            } else {
                for (var cellRow = 0; cellRow < rowSpan; cellRow++) {
                    for (var cellCol = 0; cellCol < colSpan; cellCol++) {
                        map[posY + cellRow][posX + cellCol] = cell;
                    }
                }
            }
        };
        var removeCells = function removeCells(sectionName, cellsToRemove) {
            var rows = data[sectionName];
            var cell = cellsToRemove.pop();
            while (cell) {
                for (var rowIndex = 0; rowIndex < rows.length; rowIndex++) {
                    var cells = rows[rowIndex];
                    var cellIndex = cells.indexOf(cell);
                    if (cellIndex !== -1) {
                        cells.splice(cellIndex, 1);
                    }
                }
                cell = cellsToRemove.pop();
            }
        };
        var self = this;
        this.options = {};
        this.init = function () {
            if (!data) {
                throw new Error('Table data has to be an object.');
            }
            options = options || {};
            this.options = angular.extend(defaultOptions, options);
            this.setDefaults();
        };
        this.setDefaults = function () {
            // Populate table if with empty rows if set in options
            if (this.isEmpty() && this.options.rows) {
                this.applyForEverySection(function (section, sectionName) {
                    // Making sure section is an array
                    data[sectionName] = angular.isArray(data[sectionName]) ? data[sectionName] : [];
                    for (var rowCounter = 0; self.options.rows > rowCounter; rowCounter++) {
                        self.addRow(sectionName);
                    }
                });
            }
        };
        this.applyForEverySection = function (cb) {
            var section;
            for (var sectionIdx in this.options.sections) {
                section = this.options.sections[sectionIdx];
                if (cb(data[section], section)) {
                    return;
                }
            }
        };
        this.applyForEveryCell = function (callback) {
            // tbody, thead
            this.applyForEverySection(function (section) {
                // rows
                angular.forEach(section, function (row) {
                    // cells
                    angular.forEach(row, callback);
                });
            });
        };
        this.isEmpty = function () {
            var empty = true;
            this.applyForEverySection(function (section) {
                if (angular.isArray(section) && section.length) {
                    empty = false;
                    // Stop looping through other sections
                    return true;
                }
            });
            return empty;
        };
        this.addRow = function (sectionName, rowIndex) {
            var row = [];
            var colNumber = this.getColNumber() || self.options.cols;
            rowIndex = angular.isUndefined(rowIndex) ? this.getRowNumber(sectionName) - 1 : rowIndex;
            for (var colCounter = 0; colNumber > colCounter; colCounter++) {
                row.push(this.options.emptyCell());
            }
            data[sectionName].splice(rowIndex, 0, row);
        };
        this.addColumn = function (colIndex, before, colToAdd) {
            colIndex = angular.isUndefined(colIndex) ? this.getColNumber() : colIndex + 1;
            // Reduce index by 1 if column needs to be added before
            colIndex -= before ? 1 : 0;
            colToAdd = angular.isArray(colToAdd) ? angular.copy(colToAdd) : [];
            this.applyForEverySection(function (section, sectionName) {
                var row;
                var cell;
                var cellAfter;
                var cellAfterIndex;
                var map = self.map(sectionName);
                for (var rowIndex = 0; rowIndex < section.length; rowIndex++) {
                    row = section[rowIndex];
                    // Check in a map so it works if cell has got a colspan
                    cellAfter = map[rowIndex][colIndex];
                    cellAfterIndex = row.indexOf(cellAfter);
                    cellAfterIndex = cellAfterIndex !== -1 ? cellAfterIndex : colIndex;
                    cell = colToAdd.length ? colToAdd.shift() : self.options.emptyCell();
                    row.splice(cellAfterIndex, 0, cell);
                }
            });
        };
        this.removeColumn = function (colIndex) {
            colIndex = angular.isUndefined(colIndex) ? this.getColNumber() - 1 : colIndex;
            this.applyForEverySection(function (section, sectionName) {
                var row;
                var mapRow;
                var cell;
                var map = self.map(sectionName);
                for (var rowIndex = 0; rowIndex < section.length; rowIndex++) {
                    mapRow = map[rowIndex];
                    cell = mapRow[colIndex];
                    row = section[rowIndex];
                    row.splice(row.indexOf(cell), 1);
                }
            });
        };
        this.removeRow = function (sectionName, rowIndex) {
            data[sectionName].splice(rowIndex, 1);
        };
        this.map = function (sectionName) {
            var section = data[sectionName];
            var map = [];
            var counter;
            for (counter = 0; counter < section.length; counter++) {
                map[counter] = [];
            }
            for (var posY = 0; posY < section.length; posY++) {
                var row = section[posY];
                var posX = 0;
                for (var col = 0; col < row.length; col++) {
                    while (map[posY][posX]) {
                        posX++;
                    }
                    var cell = row[col];
                    addToMap(map, cell, posY, posX);
                    posX += cell.colspan || 1;
                }
            }
            return map;
        };
        this.isColSpanned = function (colIndex) {
            var spanned = false;
            this.applyForEverySection(function (section, sectionName) {
                var map = self.map(sectionName);
                for (var rowIndex = 0; rowIndex < map.length; rowIndex++) {
                    var cell = map[rowIndex][colIndex];
                    if (cell && cell.colspan > 1) {
                        spanned = true;
                        // Stop looping through other sections
                        return true;
                    }
                }
            });
            return spanned;
        };
        this.isRowSpanned = function (sectionName, rowIndex) {
            var map = self.map(sectionName);
            if (!map[rowIndex]) {
                return false;
            }
            for (var colIndex = 0; colIndex < map[rowIndex].length; colIndex++) {
                var cell = map[rowIndex][colIndex];
                if (cell && cell.rowspan > 1) {
                    return true;
                }
            }
            return false;
        };
        this.getColNumber = function () {
            var colNumber = 0;
            this.applyForEverySection(function (section) {
                var firstRow = section[0] ? section[0] : [];
                for (var colIndex = 0; colIndex < firstRow.length; colIndex++) {
                    var cell = firstRow[colIndex];
                    colNumber += cell.colspan || 1;
                }
                return true;
            });
            return colNumber;
        };
        this.getRowNumber = function (sectioName) {
            return data[sectioName].length;
        };
        this.getColumn = function (colIndex) {
            var column = [];
            this.applyForEverySection(function (section, sectionName) {
                var mapRow;
                var map = self.map(sectionName);
                for (var rowIndex = 0; rowIndex < section.length; rowIndex++) {
                    mapRow = map[rowIndex];
                    column.push(mapRow[colIndex]);
                }
            });
            return column;
        };
        this.findCell = function (cell) {
            if (!cell) {
                return false;
            }
            var sectionNames = self.options.sections;
            for (var sectionIndex = 0; sectionIndex < sectionNames.length; sectionIndex++) {
                var info = self.findCellInSection(sectionNames[sectionIndex], cell);
                if (info) {
                    info.section = sectionNames[sectionIndex];
                    return info;
                }
            }
            return false;
        };
        this.findCellInSection = function (sectionName, cell) {
            var map = self.map(sectionName);
            for (var rowIndex = 0; rowIndex < map.length; rowIndex++) {
                var colIndex = map[rowIndex].indexOf(cell);
                if (colIndex > -1) {
                    return {
                        row: rowIndex,
                        col: colIndex,
                        colReal: data[sectionName][rowIndex].indexOf(cell),
                        map: map
                    };
                }
            }
            return false;
        };
        this.getCell = function (sectionName, rowIndex, colIndex) {
            var section = self.map(sectionName);
            return section[rowIndex] && section[rowIndex][colIndex] ? section[rowIndex][colIndex] : null;
        };
        this.replaceCell = function (sectionName, rowIndex, colIndex, cellToReplaceBy) {
            var cellToReplace = self.getCell(sectionName, rowIndex, colIndex);
            if (cellToReplace) {
                var position = self.findCellInSection(sectionName, cellToReplace);
                data[sectionName][position.row][position.colReal] = cellToReplaceBy;
                return true;
            }
            return false;
        };
        this.mergeDown = function (cell) {
            var pos = self.findCell(cell);
            var map = pos.map;
            var section = pos.section;
            var rowspan = cell.rowspan || 1;
            var nextRow = pos.row + rowspan;
            var nextCell = self.getCell(section, nextRow, pos.col);
            var nextRowspan = nextCell.rowspan || 1;
            var cellsToBeRemoved = [];
            var colspan = cell.colspan || 1;
            if (nextCell.colspan > colspan) {
                var colNumber = nextCell.colspan - colspan;
                for (var colspanIndex = 0; colspanIndex < colNumber; colspanIndex++) {
                    self.mergeRight(cell);
                }
            }
            colspan = cell.colspan || 1;
            for (var col = pos.col; col < pos.col + colspan; col++) {
                if (map[nextRow] && map[nextRow][col]) {
                    cellsToBeRemoved.push(map[nextRow][col]);
                }
            }
            removeCells(pos.section, cellsToBeRemoved);
            cell.rowspan = rowspan + nextRowspan;
        };
        this.mergeRight = function (cell) {
            var pos = self.findCell(cell);
            var map = pos.map;
            var rowspan = cell.rowspan || 1;
            var colspan = cell.colspan || 1;
            var nextCol = pos.col + colspan;
            var nextCell = self.getCell(pos.section, pos.row, nextCol);
            var nextColspan = nextCell.colspan || 1;
            // Update colspan on next row
            if (nextCell.rowspan > rowspan) {
                var rowNumber = nextCell.rowspan - rowspan;
                for (var rowspanIndex = 0; rowspanIndex < rowNumber; rowspanIndex++) {
                    self.mergeDown(cell);
                }
            }
            rowspan = cell.rowspan || 1;
            var cellsToBeRemoved = [];
            for (var row = pos.row; row < pos.row + rowspan; row++) {
                if (map[row] && map[row][nextCol]) {
                    cellsToBeRemoved.push(map[row][nextCol]);
                }
            }
            removeCells(pos.section, cellsToBeRemoved);
            // Update selected cell colspan value
            cell.colspan = colspan + nextColspan;
        };
        this.unmerge = function (cell) {
            var pos = self.findCell(cell);
            var section = pos.section;
            var row = data[section];
            var colspan = cell.colspan || 1;
            var rowspan = cell.rowspan || 1;
            var colIndex;
            if (colspan > 1) {
                for (colIndex = 0; colIndex < colspan - 1; colIndex++) {
                    row[pos.row].splice(pos.col + 1, 0, self.options.emptyCell());
                }
            }
            if (rowspan > 1) {
                var rowPosition = pos.row;
                for (var rowIndex = 0; rowIndex < rowspan - 1; rowIndex++) {
                    rowPosition++;
                    // Add cell colspan times
                    for (colIndex = 0; colIndex < colspan; colIndex++) {
                        row[rowPosition].splice(pos.col, 0, self.options.emptyCell());
                    }
                }
            }
            cell.colspan = 1;
            cell.rowspan = 1;
        };
        this.getNextRightCell = function (cell) {
            var position = self.findCell(cell);
            var colspan = cell.colspan || 1;
            var nextCol = position.col + colspan;
            return self.getCell(position.section, position.row, nextCol);
        };
        this.getNextBottomCell = function (cell) {
            var position = self.findCell(cell);
            var rowspan = cell.rowspan || 1;
            var nextRow = position.row + rowspan;
            return self.getCell(position.section, nextRow, position.col);
        };
        this.init();
    };
});
'use strict';
angular.module('komondor-editor').factory('TableValidator', ["notify", function (notify) {
    return function TableValidator(table, scope) {
        var getSelected = function getSelected() {
            return scope.selected;
        };
        // table columns
        this.canRemoveColumn = function () {
            var selected = getSelected();
            if (!selected) {
                notify.alert('Please select a column to remove a column.');
                return false;
            }
            var pos = selected.position;
            if (table.isColSpanned(pos.col)) {
                notify.alert('Unmerge cells before removing a column.');
                return false;
            }
            // Don't delete if there is only col in row
            if (table.getColNumber() === 1) {
                notify.alert('There has to be at least one column.');
                return false;
            }
            return true;
        };
        this.canAddColumn = function () {
            var selected = getSelected();
            // Not found - select last cell in a first row
            if (!selected) {
                notify.alert('Please select a cell to add a column after.');
                return false;
            }
            var selectedCellPos = selected.position;
            var colspan = selected.cell.colspan || 1;
            var nextCol = selectedCellPos.col + colspan;
            if (table.isColSpanned(nextCol)) {
                notify.alert('We cannot add a column when there are multi-column cells in the next column already.');
                return false;
            }
            return true;
        };
        // table rows
        this.canRemoveRow = function () {
            var selected = getSelected();
            if (!selected) {
                notify.alert('Please select a row you want to remove.');
                return false;
            }
            var pos = selected.position;
            // Don't delete last row
            if (table.getRowNumber(pos.section) === 1) {
                notify.alert('Cannot delete only row.');
                return false;
            }
            if (table.isRowSpanned(pos.section, pos.row)) {
                notify.alert('Unmerge cells before removing row.');
                return false;
            }
            return true;
        };
        this.canAddRow = function () {
            var selected = getSelected();
            if (!selected) {
                notify.alert('Please select a cell you want to add a row after.');
                return false;
            }
            var pos = selected.position;
            var rowspan = selected.cell.rowspan || 1;
            var nextRow = pos.row + rowspan;
            // Don't add a row if there are multi rowspan cells
            if (table.isRowSpanned(pos.section, nextRow)) {
                notify.alert('We cannot add a row when there are multirow cells on the next row already.');
                return false;
            }
            return true;
        };
        // table cell merging
        this.canMergeRight = function () {
            var selected = getSelected();
            var position = selected.position;
            var colspan = selected.cell.colspan || 1;
            var colsNumber = table.getColNumber();
            // Selected cell is single cell
            if (colsNumber === colspan) {
                notify.alert('Cannot merge single cell.');
                return false;
            }
            // Selected cell is last in row
            if (position.col === colsNumber - 1) {
                notify.alert('Cannot merge last cell in a row.');
                return false;
            }
            var nextCell = table.getNextRightCell(selected.cell);
            var nextPosition = table.findCell(nextCell);
            if (position.row > nextPosition.row) {
                notify.alert('Cannot merge. Please unmerge cell from right first.');
                return false;
            }
            var rowspan = selected.cell.rowspan || 1;
            var bottomRow = position.row + rowspan - 1;
            var nextCol = position.col + colspan;
            var nextRightBottomCell = table.getCell(position.section, bottomRow, nextCol);
            var nextRightBottomCellRowspan = nextRightBottomCell.rowspan || 1;
            if (nextRightBottomCellRowspan > 1 && nextRightBottomCell !== nextCell) {
                notify.alert('Cannot merge. Please unmerge cell from right first.');
                return false;
            }
            return true;
        };
        this.canMergeDown = function () {
            var selected = getSelected();
            var position = selected.position;
            var rowspan = selected.cell.rowspan || 1;
            var nextRow = position.row + rowspan;
            if (!position.map[nextRow]) {
                notify.alert('Cannot merge last row.');
                return false;
            }
            var nextCell = table.getNextBottomCell(selected.cell);
            var nextPosition = table.findCell(nextCell);
            if (position.col > nextPosition.col) {
                notify.alert('Cannot merge. Please unmerge bottom cell first.');
                return false;
            }
            var colspan = selected.cell.colspan || 1;
            var rightCol = position.col + colspan - 1;
            var nextBottomRightCell = table.getCell(position.section, nextRow, rightCol);
            var nextBottomRightColspan = nextBottomRightCell.colspan || 1;
            if (nextBottomRightColspan > 1 && nextCell !== nextBottomRightCell) {
                notify.alert('Cannot merge. Please unmerge bottom cell first.');
                return false;
            }
            return true;
        };
        this.canUnmerge = function () {
            var selected = getSelected();
            var colspan = selected.cell.colspan || 1;
            var rowspan = selected.cell.rowspan || 1;
            if (colspan === 1 && rowspan === 1) {
                notify.alert('Can only unmerge merged columns/rows.');
                return false;
            }
            return true;
        };
    };
}]);
'use strict';
angular.module('komondor-editor').directive('tabContent', function () {
    return {
        restrict: 'A',
        templateUrl: 'ng-komondor-editor/scripts/components/tabs/tab.content.html',
        controller: ["$scope", "$timeout", function controller($scope, $timeout) {
            var boardcastVideoEvent = function boardcastVideoEvent() {
                if ($scope.active) {
                    $scope.$broadcast('video:play');
                } else {
                    $scope.$broadcast('video:pause');
                }
            };
            $timeout(boardcastVideoEvent);
            $scope.$watch('active', boardcastVideoEvent);
        }],
        scope: {
            tab: '=',
            active: '='
        }
    };
});
'use strict';
angular.module('komondor-editor').factory('TabsInteractionHandler', function () {
    return function TabsInteractionHandler(container) {
        var jqLite = angular.element;
        this.init = function () {
            // Set DOM elements
            this.next = jqLite(container.getElementsByClassName('next')[0]);
            this.prev = jqLite(container.getElementsByClassName('prev')[0]);
            this.tabsItems = jqLite(container.getElementsByClassName('tabs-heading-tab'));
            this.tabsContents = jqLite(container.getElementsByClassName('tabs-content'));
            this.tabContainer = container.getElementsByClassName('tabs-heading-container')[0];
            this.tabs = container.getElementsByClassName('tabs-heading')[0];
            // Defaults
            this.margin = 0;
            // Event handlers
            this.next.on('click', this.showRightTabs.bind(this));
            this.prev.on('click', this.showLeftTabs.bind(this));
        };
        this.showRightTabs = function () {
            var maxScroll = this.getMaxScroll();
            this.margin = this.margin - this.step();
            this.margin = Math.max(this.margin, maxScroll);
            this.showNext(this.margin !== maxScroll);
            this.showPrev(true);
            this.tabs.style.marginLeft = this.margin + 'px';
        };
        this.showLeftTabs = function () {
            this.margin = this.margin + this.step();
            this.margin = Math.min(0, this.margin);
            this.showPrev(this.margin !== 0);
            this.showNext(true);
            this.tabs.style.marginLeft = this.margin + 'px';
        };
        this.goToView = function () {
            this.showNext(this.tabs.scrollWidth > this.tabs.offsetWidth);
        };
        this.goToEdit = function () {
            this.tabs.style.marginLeft = 0;
        };
        this.step = function () {
            return this.tabContainer.clientWidth / 2;
        };
        this.showNext = function (show) {
            this.next.toggleClass('visible', show);
        };
        this.showPrev = function (show) {
            this.prev.toggleClass('visible', show);
        };
        this.getMaxScroll = function () {
            return this.tabs.offsetWidth + this.margin - this.tabs.scrollWidth;
        };
    };
});
'use strict';
angular.module('komondor-editor').directive('tabs', ["TabsInteractionHandler", "$timeout", "editorState", "$compile", "$templateCache", "BackCompatTabsAdapter", function (TabsInteractionHandler, $timeout, editorState, $compile, $templateCache, BackCompatTabsAdapter) {
    controller.$inject = ["$scope", "$element"];
    return {
        restrict: 'A',
        replace: true,
        require: '^component',
        templateUrl: 'ng-komondor-editor/scripts/components/tabs/tabs.html',
        controller: controller,
        controllerAs: '$ctrl'
    };
    function controller($scope, $element) {
        var tabsHandler = void 0;
        var titleTemplateUrl = 'ng-komondor-editor/scripts/components/tabs/tabs.heading.html';
        this.$onInit = function () {
            var adapter = new BackCompatTabsAdapter($scope.data);
            adapter.adapt();
            // Scope data
            $scope.data.tabs = $scope.data.tabs || [this.getEmptyTab(1)];
            $scope.data.hasTitle = angular.isUndefined($scope.data.hasTitle) ? true : $scope.data.hasTitle;
            $scope.data.title = $scope.data.title || 'Tabs title...';
            $scope.data.hasInfo = $scope.data.hasInfo || false;
            $scope.data.info = $scope.data.info || 'Tabs info...';
            $scope.data.tabAlign = $scope.data.tabAlign || 'left';
            // Selected tab index
            $scope.selectedIndex = $scope.selectedIndex || 0;
            $scope.getTrackables = getTrackables;
            // Class data
            this.changed = null;
            this.titleTemplate = null;
            this.compileTitle($scope.ctrl.options.titlePosition);
            this.editorState = editorState;
            // Set tabs interaction handler
            $timeout(this.tabsInit.bind(this));
        };
        /**
         * Compile title element at top|bottom
         * @param {String} position
         */
        this.compileTitle = function (position) {
            var topHeading = position === 'top';
            this.titleTemplate = $compile($templateCache.get(titleTemplateUrl))($scope);
            $timeout(this.appendTitle.bind(this, topHeading));
        };
        /**
         * Append|prepend title to $element
         * @param {Boolean} topHeading
         */
        this.appendTitle = function (topHeading) {
            if (topHeading) {
                this.titleTemplate.addClass('tabs-title-top');
                $element.prepend(this.titleTemplate);
            } else {
                this.titleTemplate.addClass('tabs-title-bottom');
                $element.append(this.titleTemplate);
            }
        };
        this.tabsInit = function () {
            tabsHandler = new TabsInteractionHandler($element[0]);
            tabsHandler.init(this.topHeading);
            this.switchToMode(editorState.editMode);
            // Switch from/to edit mode
            $scope.$on('editor:editmode', this.onEditModeChange.bind(this));
        };
        this.onEditModeChange = function (event, editMode) {
            this.switchToMode(editMode);
        };
        this.switchToMode = function (editMode) {
            if (editMode) {
                tabsHandler.goToEdit();
            } else {
                $timeout(tabsHandler.goToView.bind(tabsHandler, this.changed));
                this.changed = false;
            }
        };
        this.addTab = function () {
            var oldTabs = $scope.data.tabs;
            var newTabs = angular.copy($scope.data.tabs);
            var newIndex = $scope.data.tabs.length;
            newTabs.push(this.getEmptyTab(newIndex + 1));
            $scope.data.tabs = newTabs;
            $scope.selectedIndex = newIndex;
            this.changed = true;
            commitHistory(newTabs, oldTabs);
        };
        this.removeTab = function () {
            var oldTabs = $scope.data.tabs;
            var newTabs = angular.copy($scope.data.tabs);
            var index = $scope.data.tabs.indexOf($scope.data.selected);
            newTabs.splice(index, 1);
            $scope.data.tabs = newTabs;
            $scope.selectedIndex = $scope.data.tabs.length - 1;
            commitHistory(newTabs, oldTabs);
        };
        this.select = function (tab) {
            $scope.selectedIndex = $scope.data.tabs.indexOf(tab);
        };
        this.getEmptyTab = function (num) {
            return {
                title: 'Tab ' + num + ' title...',
                hasNest: true,
                noText: false,
                content: 'Tab content....',
                nested: {}
            };
        };
        this.setAlign = function (type) {
            $scope.data.tabAlign = type;
        };
        function commitHistory(newTabs, oldTabs) {
            editorState.history.commit({
                undo: function undo() {
                    $scope.data.tabs = oldTabs;
                },
                redo: function redo() {
                    $scope.data.tabs = newTabs;
                }
            });
        }
        function getTrackables() {
            return {
                'data.hasInfo': { deepWatch: false },
                'data.hasTitle': { deepWatch: false },
                'data.info': { deepWatch: false },
                'data.tabAlign': { deepWatch: false },
                'data.title': { deepWatch: false }
            };
        }
    }
}]);
'use strict';
angular.module('komondor-editor').directive('textblock', ["htmlSanitizer", "$templateCache", "$compile", "keys", "htmlSplitter", function (htmlSanitizer, $templateCache, $compile, keys, htmlSplitter) {
    var bindings = {};
    bindings[keys.ENTER] = pressEnter;
    bindings[keys.BACKSPACE] = pressDelete;
    bindings[keys.DELETE] = pressDelete;
    return {
        restrict: 'A',
        priority: 9999,
        terminal: true,
        require: '^component',
        link: link
    };
    function cancel($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return false;
    }
    function pressEnter($event, $scope) {
        $scope.createNewParagraph('');
        return cancel($event);
    }
    function pressShiftEnter($event) {
        $event.stopPropagation();
        return false;
    }
    function pressDelete($event, $scope) {
        if ($scope.model.html !== '') {
            return;
        }
        $scope.forceDestroy($event.keyCode === keys.BACKSPACE);
        return cancel($event);
    }
    function link($scope, element, attrs, component) {
        attrs.$set('editable', '');
        attrs.$set('ng-trim', 'false');
        attrs.$set('ng-model', 'model.html');
        component.setHtmlProcessor(function (html) {
            return htmlSplitter(html, function (html) {
                $scope.createNewParagraph(html, true);
            }, component.sanitizerRules);
        });
        component.setFocusRequestHandler(function () {
            element[0].focus();
        });
        $scope.createNewParagraph = function (html, disableRequestFocus) {
            var para = {
                type: 'textblock',
                tag: $scope.model.tag,
                class: $scope.model.class,
                html: html
            };
            var insertAfter = $scope.model;
            $scope.$emit('component:new', para, insertAfter, false, disableRequestFocus);
        };
        element.on('keydown', function ($event) {
            if ($scope.ctrl.editor.options.softReturn) {
                if ($event.shiftKey === true && $event.keyCode === keys.ENTER) {
                    var result = pressShiftEnter($event, $scope, element);
                    $scope.$apply();
                    return result;
                }
            }
            if (bindings[$event.keyCode]) {
                var _result = bindings[$event.keyCode]($event, $scope, element);
                $scope.$apply();
                return _result;
            }
        });
        $compile(element, null, 9999)($scope);
        $scope.getTrackables = function () {
            return {
                html: {
                    deepWatch: false,
                    allowCommit: function allowCommit(newModel, oldModel) {
                        return !(!newModel && !oldModel);
                    }
                },
                class: { deepWatch: false }
            };
        };
    }
}]);
'use strict';
angular.module('komondor-editor').controller('VideoPlayerCtrl', ["$scope", "$sce", "assetCache", "Fullscreen", "editorState", "$timeout", "objectDefaults", function ($scope, $sce, assetCache, Fullscreen, editorState, $timeout, objectDefaults) {
    var _this = this;
    var self = this;
    var defaultThumb = $scope.ctrl.options.placeholderImage;
    $scope.state = editorState;
    $scope.data.asset_id = $scope.data.asset_id || null;
    $scope.data.caption = $scope.data.caption || '';
    $scope.data.vAlign = $scope.data.vAlign || 'bottom';
    $scope.computed = {
        links: null,
        thumbSafe: null
    };
    $scope.vAlign = {
        top: 'Top',
        middle: 'Middle',
        bottom: 'Bottom'
    };
    $scope.getTrackables = getTrackables;
    function setSrc(links) {
        $scope.computed.links = links || null;
        if (editorState.editMode && self.video) {
            // Reload (in edit mode) video on after src changed
            self.video.load();
        }
    }
    $scope.$watch('data.asset_id', function () {
        if (!$scope.data.asset_id) {
            $scope.computed.thumbSafe = $sce.trustAsResourceUrl(defaultThumb);
            for (var i = 0; i < self.video.children.length; i++) {
                self.video.children[i].src = '';
            }
            setSrc(null);
            return;
        }
        assetCache.get($scope.data.asset_id).then(function (asset) {
            var currThumb = asset.links.poster || asset.links.thumb || defaultThumb;
            $scope.computed.thumbSafe = $sce.trustAsResourceUrl(currThumb);
            setSrc(asset.links);
        });
    });
    $scope.playback = {
        volume: 1,
        volumeBeforeMute: 0,
        currTime: 0,
        duration: 1,
        currTimeDisplay: '0:00',
        isPlaying: $scope.model.data.autoplay,
        isSeeking: false,
        isMute: $scope.model.data.muted,
        wasPlaying: null
    };
    this.video = null;
    this.$onInit = function () {
        objectDefaults($scope.data, $scope.ctrl.options.defaults);
        backCompat();
    };
    $scope.$on('video:pause', function () {
        $timeout(function () {
            if (_this.isPlaying() || $scope.model.data.autoplay && $scope.playback.wasPlaying === null) {
                $scope.playback.wasPlaying = true;
                _this.pause();
            }
        });
    });
    $scope.$on('video:play', function () {
        $timeout(function () {
            if ($scope.playback.wasPlaying === true) {
                _this.play();
            }
        });
    });
    // helper playback functions
    this.togglePlay = function () {
        if (!this.isPlaying()) {
            this.play();
        } else {
            $scope.playback.wasPlaying = false;
            this.pause();
        }
    };
    this.restartPlayback = function () {
        this.jumpTo($scope.model.data.startFrom || 0);
        this.play();
    };
    this.isPlaying = function () {
        return !this.video.paused;
    };
    // basic playback functions
    this.play = function () {
        this.video.play();
        $scope.playback.isPlaying = true;
    };
    this.pause = function () {
        this.video.pause();
        $scope.playback.isPlaying = false;
    };
    this.jumpTo = function (t) {
        this.video.currentTime = t;
    };
    this.mute = function () {
        if (this.video.volume) {
            $scope.playback.volumeBeforeMute = this.video.volume;
            this.video.volume = $scope.playback.volume = 0;
        } else {
            this.video.volume = $scope.playback.volume = $scope.playback.volumeBeforeMute;
        }
    };
    this.updateVolume = function () {
        this.video.volume = $scope.playback.volume;
    };
    this.toggleFullScreen = function () {
        Fullscreen.enable(this.video);
    };
    function backCompat() {
        if ($scope.data.links) {
            delete $scope.data.links;
        }
    }
    function getTrackables() {
        return {
            'data.asset_id': { deepWatch: false },
            'data.caption': { deepWatch: false },
            'data.hasCaption': { deepWatch: false },
            'data.vAlign': { deepWatch: false },
            'data.fullSize': { deepWatch: false },
            'data.autoplay': {
                deepWatch: false,
                callOnChangeAfter: true,
                onChange: function onChange() {
                    return $scope.configChanged('autoplay');
                }
            },
            'data.controls': {
                deepWatch: false,
                callOnChangeAfter: true,
                onChange: function onChange() {
                    return $scope.configChanged('controls');
                }
            },
            'data.loop': {
                deepWatch: false,
                callOnChangeAfter: true,
                onChange: function onChange() {
                    return $scope.configChanged('loop');
                }
            },
            'data.hideDownloads': {
                deepWatch: false,
                callOnChangeAfter: true,
                onChange: function onChange() {
                    return $scope.configChanged('hideDownloads');
                }
            },
            'data.startFrom': {
                deepWatch: false,
                callOnChangeAfter: true,
                onChange: function onChange() {
                    return $scope.configChanged();
                }
            },
            'data.stopAt': {
                deepWatch: false,
                callOnChangeAfter: true,
                onChange: function onChange() {
                    return $scope.configChanged();
                }
            }
        };
    }
}]);
'use strict';
angular.module('komondor-editor').directive('videoPlayerControls', ["$document", "editorState", function ($document, editorState) {
    return {
        scope: { state: '=' },
        replace: true,
        restrict: 'A',
        require: ['^videoPlayer', '^editor'],
        templateUrl: 'ng-komondor-editor/scripts/components/video-player/video-player.controls.html',
        link: link
    };
    function link(scope, elem, attrs, controllers) {
        var videoPlayerCtrl = controllers[0];
        var editorCtrl = controllers[1];
        var videoElem = elem.parent();
        var slideElem = angular.element($document[0].getElementsByClassName('slide'));
        var editorElem = editorCtrl.element;
        if (editorElem.hasClass('editor-back-layer')) {
            scope.$watchGroup([function () {
                            return editorElem.hasClass('disabled-controls');
                        }, function () {
                            return editorState.editMode;
                        }], function (newValues) {
                var disabled = newValues[0];
                var editMode = newValues[1];
                if (!disabled || !editMode) {
                    slideElem[0].appendChild(elem[0]);
                    return;
                }
                videoElem[0].appendChild(elem[0]);
            });
        }
        // Make sure element removed due to it's a bit lost
        scope.$on('$destroy', function () {
            elem.remove();
        });
        scope.videoPlayerCtrl = videoPlayerCtrl;
        var seekBar = angular.element(elem.children()[0]).children()[1];
        // to decide if continue play or pause after seekBar dragging stopped
        var isPlayingBeforeSeek = null;
        seekBar.addEventListener('mousedown', function () {
            scope.state.isSeeking = true;
            isPlayingBeforeSeek = videoPlayerCtrl.isPlaying();
            videoPlayerCtrl.pause();
        });
        seekBar.addEventListener('mouseup', function () {
            if (!videoPlayerCtrl) {
                return;
            }
            videoPlayerCtrl.jumpTo(seekBar.value);
            if (isPlayingBeforeSeek) {
                videoPlayerCtrl.play();
            }
            scope.state.isSeeking = false;
        });
        seekBar.addEventListener('mousemove', function () {
            if (!scope.state.isSeeking) {
                return;
            }
            videoPlayerCtrl.jumpTo(seekBar.value);
        });
    }
}]);
'use strict';
angular.module('komondor-editor').directive('videoPlayer', ["$window", "$document", "$log", "$timeout", "debounce", "muteService", function ($window, $document, $log, $timeout, debounce, muteService) {
    return {
        replace: true,
        templateUrl: 'ng-komondor-editor/scripts/components/video-player/video-player.html',
        link: link,
        controller: 'VideoPlayerCtrl as videoPlayerCtrl',
        require: '^editor'
    };
    function link($scope, element, attrs, editorCtrl) {
        var options = $scope.ctrl.options;
        $scope.forcePoster = options.forcePoster;
        if ($scope.ctrl.editor.state.printMode || $scope.forcePoster) {
            return;
        }
        var videoControlsTimer;
        var videoControls;
        var debounced = debounce(setScale, 100);
        var videoDiv = element[0].getElementsByTagName('video')[0];
        /**
         * Check whether video is in the back layer
         */
        var isInBackLayer = function isInBackLayer() {
            return editorCtrl.property === 'back_layer';
        };
        $scope.videoInBackLayer = isInBackLayer();
        /**
         * start watching parent element resize
         */
        function startWatchingParentResize() {
            setScale();
            angular.element($window).bind('resize', debounced);
        }
        /**
         * stop watching parent element resize
         */
        function stopWatchingParentResize() {
            // unbind $window.resize
            angular.element($window).unbind('resize', debounced);
            resetScale();
        }
        function toggleCustomControls() {
            if ($scope.model.data.controls) {
                angular.element(videoControls).addClass('in');
                $window.addEventListener('mousemove', videoMouseMoveHandler);
            } else {
                $timeout.cancel(videoControlsTimer);
                angular.element(videoControls).removeClass('in');
                $window.removeEventListener('mousemove', videoMouseMoveHandler);
            }
        }
        function toggleNativeControls() {
            if ($scope.model.data.controls) {
                videoDiv.setAttribute('controls', '');
            } else {
                videoDiv.removeAttribute('controls');
            }
        }
        function toggleControls() {
            if (options.nativeControls) {
                toggleNativeControls();
            } else {
                toggleCustomControls();
            }
        }
        function videoMouseMoveHandler() {
            angular.element(videoControls).addClass('in');
            $timeout.cancel(videoControlsTimer);
            videoControlsTimer = $timeout(function () {
                angular.element(videoControls).removeClass('in');
            }, 5000);
        }
        function toggleAttribute(configKey) {
            angular.element(videoDiv)[$scope.model.data[configKey] ? 'attr' : 'removeAttr'](configKey, '');
        }
        function toggleFullsizeWatcher() {
            if ($scope.model.data.fullSize) {
                startWatchingParentResize();
            } else {
                stopWatchingParentResize();
            }
        }
        function toggleHideDownloads() {
            if ($scope.model.data.hideDownloads) {
                videoDiv.setAttribute('oncontextmenu', 'return false;');
            } else {
                videoDiv.removeAttribute('oncontextmenu');
            }
        }
        function setScale() {
            if (!videoDiv.videoWidth && !videoDiv.videoHeight) {
                return;
            }
            var parentDiv = angular.element(videoDiv).parent()[0], rOriginal = videoDiv.videoWidth / videoDiv.videoHeight, rBox = parentDiv.clientWidth / parentDiv.clientHeight, css;
            if (rBox > rOriginal) {
                css = {
                    width: parentDiv.clientWidth + 'px',
                    height: 'auto',
                    'margin-left': 0,
                    'margin-top': -(parentDiv.clientWidth / rOriginal - parentDiv.clientHeight) / 2 + 'px'
                };
                if ($scope.data.vAlign === 'middle') {
                    css['margin-top'] = 0;
                } else if ($scope.data.vAlign === 'top') {
                    css['margin-top'] = (parentDiv.clientWidth / rOriginal - parentDiv.clientHeight) / 2 + 'px';
                }
            } else {
                css = {
                    height: parentDiv.clientHeight + 'px',
                    'margin-left': -(parentDiv.clientHeight * rOriginal - parentDiv.clientWidth) / 2 + 'px',
                    width: 'auto',
                    'margin-top': 0
                };
            }
            angular.element(videoDiv).css(css);
        }
        /**
         * reset back to original video dimension
         */
        function resetScale() {
            angular.element(videoDiv).css({
                width: '100%',
                height: '100%',
                'margin-left': 'auto',
                'margin-right': 'auto',
                'margin-top': 'auto'
            });
        }
        ///////////////////
        // local members //
        ///////////////////
        $scope.$on('$stateChangeStart', function () {
            videoDiv.pause();
        });
        videoDiv.addEventListener('loadedmetadata', function () {
            if ($scope.model.data.fullSize) {
                $timeout(setScale);
            }
            // jump to customized startFrom time
            if ($scope.model.data.startFrom) {
                $scope.videoPlayerCtrl.jumpTo($scope.model.data.startFrom);
            }
            $scope.playback.duration = $scope.videoPlayerCtrl.video.duration;
        }, false);
        videoDiv.addEventListener('ended', function () {
            $scope.playback.wasPlaying = null;
        });
        videoDiv.addEventListener('timeupdate', function () {
            if ($scope.playback.isSeeking) {
                return;
            }
            $scope.playback.currTime = this.currentTime;
            var minutes = Math.floor(this.currentTime / 60);
            var seconds = Math.round(this.currentTime - minutes * 60);
            $scope.playback.currTimeDisplay = minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
            $scope.$apply();
            // stop/loop-play while reaching stopAt time
            // or seekBar is dragged to a position after data.stopAt
            if ($scope.model.data.stopAt && this.currentTime > $scope.model.data.stopAt) {
                $scope.videoPlayerCtrl.jumpTo($scope.model.data.stopAt);
                if ($scope.model.data.loop) {
                    $scope.videoPlayerCtrl.restartPlayback();
                } else {
                    this.pause();
                }
            }    // jump to data.startFrom while seekBar is dragged to a position before data.startFrom
            else if ($scope.model.data.startFrom && this.currentTime < $scope.model.data.startFrom) {
                $scope.videoPlayerCtrl.jumpTo($scope.model.data.startFrom);
            }
        });
        //////////
        // init //
        //////////
        $scope.videoPlayerCtrl.video = videoDiv;
        if ($scope.model.data.fullSize) {
            startWatchingParentResize();
        }
        angular.element(videoDiv)[$scope.model.data.autoplay ? 'attr' : 'removeAttr']('autoplay', '');
        // Add force mute when video is muted so that the mute service doesn't unmute
        angular.element(videoDiv)[$scope.model.data.muted ? 'attr' : 'removeAttr']('data-forcemute', '');
        angular.element(videoDiv)[$scope.model.data.loop ? 'attr' : 'removeAttr']('loop', '');
        if ($scope.model.data.muted) {
            videoDiv.muted = true;
        }
        $scope.playback.fullscreenDisabled = options.fullscreenDisabled;
        muteService.set(element[0]);
        $timeout(function () {
            if (!options.nativeControls) {
                videoDiv.removeAttribute('controls');
                videoControls = element[0].getElementsByClassName('video-controls')[0];
                if ($scope.videoInBackLayer) {
                    var backlayerControls = angular.element($document[0].querySelector('.slide > .video-controls'));
                    videoControls = backlayerControls.length ? backlayerControls[0] : videoControls;
                }
                var videoParentWidth = angular.element(videoDiv).parent()[0].clientWidth;
                if (videoParentWidth < 500) {
                    angular.element(videoControls).addClass('tiny');
                } else if (videoParentWidth < 800) {
                    angular.element(videoControls).addClass('small');
                }
            }
            toggleControls();
        });
        /**
         * config change handlers
         */
        var configChangeHandlers = {
            controls: toggleControls,
            autoplay: toggleAttribute,
            loop: toggleAttribute,
            muted: toggleAttribute,
            fullSize: toggleFullsizeWatcher,
            hideDownloads: toggleHideDownloads
        };
        $scope.configChanged = function (configKey) {
            if (configChangeHandlers[configKey]) {
                configChangeHandlers[configKey](configKey);
            }
        };
        $scope.configAlignment = function (position) {
            $scope.data.vAlign = position;
            setScale();
        };
    }
}]);
'use strict';
angular.module('komondor-editor').directive('interactionContainer', ["$filter", "interactionHandlers", function ($filter, interactionHandlers) {
    return {
        restrict: 'A',
        link: function link($scope, element) {
            var addEventHandlers = function addEventHandlers(eventName, handlerList) {
                handlerList = $filter('orderBy')(handlerList, 'priority');
                element.on(eventName, function ($event) {
                    for (var i = 0; i < handlerList.length; i++) {
                        handlerList[i].callback($event);
                        if ($event.stopInteractionHandlers) {
                            return;
                        }
                    }
                });
            };
            for (var eventName in interactionHandlers.handlers) {
                addEventHandlers(eventName, interactionHandlers.handlers[eventName]);
            }
        }
    };
}]);
'use strict';
angular.module('komondor-editor').factory('interactionHandlers', function () {
    return {
        handlers: {},
        addHandler: function addHandler(eventName, callback, priority) {
            if (!this.handlers[eventName]) {
                this.handlers[eventName] = [];
            }
            this.handlers[eventName].push({
                priority: angular.isDefined(priority) ? priority : 500,
                callback: callback
            });
        }
    };
});
'use strict';
angular.module('komondor-editor').directive('marginControls', ["editorState", function (editorState) {
    controller.$inject = ["$scope"];
    var fromCommitAction = void 0;
    // Default options
    var marginDirections = ['top', 'right', 'bottom', 'left'];
    var autoOption = '';
    var defaultUnit = 'px';
    var defaultMargin = {
        top: '',
        topUnit: 'px',
        right: '',
        rightUnit: 'px',
        bottom: '',
        bottomUnit: 'px',
        left: '',
        leftUnit: 'px'
    };
    return {
        replace: true,
        restrict: 'A',
        require: '^componentOptions',
        templateUrl: 'ng-komondor-editor/scripts/directives/margin-controls/margin-controls.html',
        controller: controller
    };
    function controller($scope) {
        editorState.marginScope = $scope;
        /**
            Backwards compatibility for old way of setting margins:
            "margin: 0 0 0 0"
            As opposed to the current way:
            "margin-top: 0,
             margin-right: 0,
             margin-bottom: 0,
             margin-left: 0"
         */
        var checkMarginCompatibility = function checkMarginCompatibility(margins) {
            var marginsObj = {};
            if (margins && margins.hasOwnProperty('margin')) {
                var marginsList = margins.margin.split(' ');
                marginsObj['margin-top'] = marginsList[0];
                marginsObj['margin-right'] = marginsList[1];
                marginsObj['margin-bottom'] = marginsList[2];
                marginsObj['margin-left'] = marginsList[3];
                delete margins.margin;
            } else {
                marginsObj = margins;
            }
            return marginsObj;
        };
        /**
         * Check if it matches auto margin value
         * @param {mixed}
         * @returns {boolean}
         */
        var isAutoMarginValue = function isAutoMarginValue(value) {
            var autoMarginValues = ['', 'auto', undefined];
            return autoMarginValues.indexOf(value) !== -1;
        };
        /**
         * Get style name field
         * @param direction
         * @returns {string}
         */
        var getOffsetField = function getOffsetField(direction) {
            return 'margin-' + direction;
        };
        /**
         * Get unit name field
         * @param direction
         * @returns {string}
         */
        var getOffsetUnitField = function getOffsetUnitField(direction) {
            return direction + 'Unit';
        };
        /**
         * Generate new margin by applying css changes to the ctrl element
         */
        var generateMargin = function generateMargin(directions) {
            var margins = editorState.marginScope.marginConfig, style = {}, unitField, fieldName;
            angular.forEach(directions, function (direction) {
                fieldName = getOffsetField(direction);
                unitField = getOffsetUnitField(direction);
                editorState.marginScope.ctrl.removeStyle(fieldName);
                style[fieldName] = isAutoMarginValue(margins[direction]) ? autoOption : margins[direction] + margins[unitField];
            });
            if (Object.keys(style).length) {
                editorState.marginScope.ctrl.addStyle(style);
            }
        };
        /**
         * Extract value from a string
         * @param {string}
         * @returns {number}
         */
        var getValue = function getValue(value) {
            return parseInt(value) || 0;
        };
        var getUnit = function getUnit(value) {
            var unit = value.replace(/(\-?[^\D]\.?)/g, '');
            return ['%', 'px'].indexOf(unit) !== -1 ? unit : defaultUnit;
        };
        /**
         * Extract margins from ctrl element styles and apply default ones if not set
         * @returns {object}
         */
        var getMargin = function getMargin() {
            var styles = checkMarginCompatibility($scope.ctrl.getStyle()), formattedStyles = {}, unitField, fieldName, marginValue;
            angular.forEach(marginDirections, function (direction) {
                fieldName = getOffsetField(direction);
                unitField = getOffsetUnitField(direction);
                marginValue = styles[fieldName];
                /**
                 * For backwards compatibility set it to zero for very first time
                 * as it's a default css option for margin
                 */
                if (angular.isUndefined(marginValue)) {
                    formattedStyles[direction] = '';
                    formattedStyles[unitField] = defaultMargin[unitField];
                } else {
                    var isAutoMargin = isAutoMarginValue(marginValue);
                    formattedStyles[direction] = isAutoMargin ? defaultMargin[direction] : getValue(marginValue);
                    formattedStyles[unitField] = isAutoMargin ? defaultMargin[unitField] : getUnit(marginValue);
                }
            });
            return formattedStyles;
        };
        /**
         * Validate margin value
         * @param {string} direction
         */
        var valueChanged = function valueChanged(direction) {
            if (!isAutoMarginValue($scope.marginConfig[direction])) {
                $scope.marginConfig[direction] = Number($scope.marginConfig[direction]) || 0;
            }
        };
        this.$onInit = function () {
            // Init here
            $scope.marginConfig = getMargin();
            generateMargin(marginDirections);
        };
        /**
         * Increase/Decrease margin values using arrow keys
         * @param {object} $event
         * @param {string} direction
         */
        $scope.onKeyDown = function ($event, direction) {
            if ($event.keyCode === 38 || $event.keyCode === 40) {
                $scope.marginConfig[direction] = $scope.marginConfig[direction] + ($event.keyCode === 38 ? 1 : -1);
                $scope.valueChanged(direction);
            }
        };
        /**
         * Apply value & regenerate margin style
         * @param {string} direction
         */
        $scope.valueChanged = function (direction) {
            valueChanged(direction);
            generateMargin([direction]);
        };
        /**
         * Toggle unit & regenerate margin style
         * @param {string} direction
         * @param {string} currentUnit
         */
        $scope.unitChanged = function (direction, currentUnit) {
            var unitField = getOffsetUnitField(direction);
            $scope.marginConfig[unitField] = currentUnit === 'px' ? '%' : 'px';
            generateMargin([direction]);
        };
        $scope.$watch('marginConfig', function (newValue, oldValue) {
            if (angular.equals(newValue, oldValue) || fromCommitAction) {
                fromCommitAction = false;
                return;
            }
            var undoValue = angular.copy(oldValue);
            var redoValue = angular.copy(newValue);
            editorState.history.commit({
                undo: function undo() {
                    fromCommitAction = true;
                    editorState.marginScope.marginConfig = undoValue;
                    generateMargin(marginDirections);
                },
                redo: function redo() {
                    fromCommitAction = true;
                    editorState.marginScope.marginConfig = redoValue;
                    generateMargin(marginDirections);
                }
            });
        }, true);
    }
}]);
'use strict';
angular.module('komondor-editor').controller('ComponentListCtrl', ["$scope", "$timeout", "editorState", "$element", function ($scope, $timeout, editorState, $element) {
    var self = this;
    this.slot = $scope.slot;
    this.options = $scope.options;
    // Backward compatibility check for append
    if ($scope.append) {
        this.options.append = $scope.append;
    }
    var getItems = function getItems() {
        return $scope.model[$scope.slot];
    };
    this.addChild = function (child, insertNear, before, committable, disableRequestFocus) {
        if (committable) {
            var commit = {
                undo: function undo() {
                    self.removeChild(child, false, committable);
                },
                redo: function redo() {
                    self.addChild(child, insertNear, before, committable, true);
                }
            };
            editorState.history.commit(commit);
            $timeout(function () {
                self.setComponentPath(commit, child);
            });
        }
        var list = getItems();
        var idx = list.indexOf(insertNear);
        if (idx !== -1) {
            // We might have a component selected above
            // this list, so idx can be -1 which is OK
            if (!before) {
                idx++;
            }
            list.splice(idx, 0, child);
        } else {
            list.push(child);
        }
        $timeout(function () {
            $scope.$emit('component:added', child, idx);
            if (!disableRequestFocus) {
                $scope.$broadcast('component:request-focus', child);
            }
        });
    };
    this.replace = function (child, oldChild) {
        var list = getItems();
        var idx = list.indexOf(oldChild);
        if (idx !== -1) {
            list.splice(idx, 1, child);
        }
        $timeout(function () {
            $scope.$broadcast('component:request-focus', child);
        });
    };
    this.indexOfChild = function (child) {
        var list = getItems();
        return list.indexOf(child);
    };
    this.getByIndex = function (index) {
        var list = getItems();
        return list[index];
    };
    this.pasteChild = function (model, insertNear, before, committable) {
        var child = angular.copy(model);
        if (child.uid) {
            delete child.uid;
        }
        this.patchComponent(child);
        this.addChild(child, insertNear, before, committable);
    };
    this.addNewChild = function (type, insertNear, before, committable, data) {
        var child = {
            type: type,
            data: data || {}
        };
        this.patchComponent(child);
        this.addChild(child, insertNear, before, committable);
    };
    this.removeChild = function (child, backspace, committable) {
        var list = getItems();
        var idx = list.indexOf(child);
        if (idx === -1) {
            throw new Error('Unable to remove component, not found in list');
        }
        if (committable) {
            var insertNear = list[idx + 1] ? list[idx + 1] : null;
            var commit = {
                undo: function undo() {
                    self.addChild(child, insertNear, true, committable, true);
                },
                redo: function redo() {
                    self.removeChild(child, backspace, committable);
                }
            };
            this.setComponentPath(commit, child);
            editorState.history.commit(commit);
        }
        list.splice(idx, 1);
        $scope.$emit('component:removed', child, idx);
        if (!backspace) {
            return;
        }
        var focusElem = backspace ? list[idx - 1] : list[idx];
        $scope.$broadcast('component:request-focus', focusElem);
    };
    this.getChildCount = function () {
        return $scope.model[$scope.slot] ? $scope.model[$scope.slot].length : 0;
    };
    this.isCommittable = function () {
        return $scope.committable;
    };
    this.setComponentPath = function (commit, model) {
        $scope.$broadcast('component:commit', model, commit);
    };
    this.patchComponent = function (model) {
        if (!this.editorOptions) {
            return;
        }
        // Backwards compatibility
        var convert = this.editorOptions.backwardsCompatibility;
        if (convert && convert[model.type]) {
            convert[model.type](model);
        }
    };
    this.getElement = function () {
        return $element;
    };
}]);
'use strict';
angular.module('komondor-editor').directive('componentList', ["$timeout", "componentSelectorModal", "editorState", function ($timeout, componentSelectorModal, editorState) {
    return {
        restrict: 'A',
        replace: true,
        require: ['^editor', '?^component'],
        scope: {
            model: '=',
            slot: '@componentList',
            append: '@',
            options: '=?',
            committable: '=?',
            path: '='
        },
        link: link,
        controller: 'ComponentListCtrl as list',
        templateUrl: 'ng-komondor-editor/scripts/editor/component-list/component-list.html'
    };
    function link($scope, element, attributes, controllers) {
        var init = function init() {
            // If this is the root scope then the editor is initialising, select this list
            if ($scope.list.context === 'editor') {
                $scope.list.select();
            }
        };
        var editorCtrl = controllers[0];
        var componentCtrl = controllers[1];
        $scope.canAddChild = false;
        $scope.committable = angular.isUndefined($scope.committable) ? true : $scope.committable;
        $scope.list.context = componentCtrl ? componentCtrl.getComponentName() : 'editor';
        $scope.list.editorOptions = editorCtrl.options;
        if (!$scope.model[$scope.slot]) {
            $scope.model[$scope.slot] = [];
        }
        for (var comp in $scope.model[$scope.slot]) {
            $scope.list.patchComponent($scope.model[$scope.slot][comp]);
        }
        $scope.$on('component:new', function ($event, child, insertNear, before, disableRequestFocus) {
            $event.stopPropagation();
            $scope.list.addChild(child, insertNear, before, $scope.committable, disableRequestFocus);
        });
        $scope.$on('component:destroy', function ($event, child, backspace) {
            $event.stopPropagation();
            $scope.list.removeChild(child, backspace, $scope.committable);
            if (editorCtrl.state.selected === child) {
                $scope.list.select(false, true);
            }
        });
        $scope.$on('component:request-focus', function ($event, model) {
            if ($scope.model[$scope.slot] === model) {
                $timeout(function () {
                    $scope.list.select();
                });
            }
        });
        $scope.$on('component:de-select', function () {
            $scope.$broadcast('component:request-focus', editorCtrl.rootModel);
        });
        $scope.$on('component:trace', function ($event, data) {
            if (!componentCtrl) {
                data.push({
                    label: 'Page',
                    type: 'component-list',
                    model: $scope.model[$scope.slot]
                });
            }
        });
        $scope.list.setSelected = function (value) {
            $scope.canAddChild = false;
            if (value) {
                element.addClass('selected');
                $scope.canAddChild = Object.keys(editorState.nestableComponents).length > 0;
            } else {
                element.removeClass('selected');
            }
        };
        $scope.list.select = function (triggerClick, selectParent) {
            var componentModel = componentCtrl ? componentCtrl.getModel() : null;
            var componentScope = componentCtrl ? componentCtrl.getScope() : null;
            $scope.$emit('component:trace', []);
            var list = $scope.list;
            if (selectParent && componentCtrl) {
                list = componentCtrl.list;
            }
            if (triggerClick) {
                editorCtrl.click(componentModel, componentScope, $scope.list, selectParent && list);
            } else {
                editorCtrl.select(componentModel, componentScope, list);
            }
        };
        $scope.dropTarget = function (yes) {
            if (yes) {
                element.addClass('drop-area');
            } else {
                element.removeClass('drop-area');
            }
        };
        element.on('click', function ($event) {
            if (!$event.target.hasAttribute('component-list-click-disabled')) {
                $event.stopPropagation();
                $scope.list.select(true);
                $scope.$apply();
            }
        });
        element.on('mouseover', function ($event) {
            if (!editorCtrl.state.pickup || $scope.model[$scope.slot].length) {
                return;
            }
            if (!editorCtrl.isComponentNestable($scope.list.context, $scope.list.slot)) {
                return;
            }
            $event.stopPropagation();
            editorCtrl.changeDropTarget($scope);
        });
        element.on('mouseleave', function () {
            if (editorCtrl.state.pickup) {
                editorCtrl.changeDropTarget(null);
            }
        });
        element.on('mouseup', function ($event) {
            if (!editorCtrl.state.pickup || editorCtrl.state.pickup.drop !== $scope) {
                return;
            }
            $event.stopPropagation();
            // to move into an empty component-list
            if (!$scope.model[$scope.slot].length) {
                editorCtrl.moveComponent(null, $scope.list);
            }
            editorCtrl.state.pickup.destroy();
        });
        $scope.insertElement = function (component) {
            componentSelectorModal.show($scope.list.editorOptions).then(function (name) {
                if (angular.isObject(name)) {
                    $scope.list.pasteChild(name, component, false, $scope.committable);
                } else {
                    $scope.list.addNewChild(name, component, false, $scope.committable);
                }
            });
        };
        init();
    }
}]);
'use strict';
angular.module('komondor-editor').controller('ComponentCtrl', ["$scope", "$timeout", "$parse", "htmlSanitizer", "editorControls", "editorState", function ($scope, $timeout, $parse, htmlSanitizer, editorControls, editorState) {
    var _this2 = this;
    var self = this;
    if (!$scope.model.data || angular.isArray($scope.model.data)) {
        $scope.model.data = {};
    }
    if (!$scope.model.style || angular.isArray($scope.model.style)) {
        $scope.model.style = {};
    }
    // Add shorthand alias
    $scope.data = $scope.model.data;
    var focusRequestHandler;
    $scope.$on('component:request-focus', function ($event, model) {
        if ($scope.model === model) {
            $timeout(self.requestFocus);
        }
    });
    this.element = null;
    this.editor = null;
    this.list = null;
    this.callback = null;
    this.setClickCallback = function (callback) {
        this.callback = callback;
    };
    this.processHtml = function (html) {
        return htmlSanitizer(html, this.sanitizerRules);
    };
    this.getElement = function () {
        return this.element;
    };
    this.select = function () {
        $scope.$emit('component:trace', []);
        this.editor.click($scope.model, $scope, this.list);
    };
    this.rebuild = function (newTag, oldTag) {
        var _this = this;
        var oldModel = editorState.componentScope.model;
        var newModel = angular.copy(editorState.componentScope.model);
        if (oldTag && newTag) {
            oldModel.tag = oldTag;
            newModel.tag = newTag;
        }
        this.tagUpdate(newModel, oldModel);
        editorState.history.commit({
            undo: function undo() {
                _this.tagUpdate(oldModel, newModel);
            },
            redo: function redo() {
                _this.tagUpdate(newModel, oldModel);
            }
        });
    };
    this.tagUpdate = function (newModel, oldModel) {
        _this2.list.replace(newModel, oldModel);
        $timeout(function () {
            editorControls.rebuild();
        });
    };
    this.getModel = function () {
        return $scope.model;
    };
    this.getScope = function () {
        return $scope;
    };
    this.setHtmlProcessor = function (callback) {
        this.processHtml = callback;
    };
    this.setFocusRequestHandler = function (callback) {
        focusRequestHandler = callback;
    };
    this.getComponentName = function () {
        return $scope.model.type;
    };
    this.requestFocus = function () {
        self.select();
        if (focusRequestHandler) {
            focusRequestHandler();
        }
    };
    this.addStyle = function (obj) {
        var component = getStyleLocation();
        $scope.model[component] = angular.extend({}, $scope.model[component], obj);
    };
    this.removeStyle = function (name) {
        var style = getStyleLocation();
        if ($scope.model[style] && $scope.model[style][name]) {
            delete $scope.model[style][name];
        }
    };
    this.getStyle = function () {
        return $scope.model[getStyleLocation()] || {};
    };
    this.isLast = function () {
        var element = this.getElement();
        return element.hasClass('component-list-last');
    };
    this.removeDataProperties = function (list) {
        angular.forEach(list, function (item) {
            delete $scope.data[item];
        });
    };
    function getStyleLocation() {
        return $scope.model.data.applyStyleToParent ? 'componentStyle' : 'style';
    }
}]);
'use strict';
angular.module('komondor-editor').directive('component', ["$compile", "componentTemplate", "notify", "getRelativeEventCoords", "ComponentGhost", "debounce", "editorControls", "editorState", function ($compile, componentTemplate, notify, getRelativeEventCoords, ComponentGhost, debounce, editorControls, editorState) {
    return {
        restrict: 'A',
        require: ['^editor', '^componentList'],
        scope: {
            model: '=',
            path: '='
        },
        link: link,
        controller: 'ComponentCtrl as ctrl'
    };
    function link($scope, element, attrs, controllers) {
        $scope.ctrl.element = element;
        $scope.ctrl.editor = controllers[0];
        $scope.ctrl.list = controllers[1];
        var select;
        var editorId;
        var dropClassAdded = false;
        var init = function init() {
            select = debounce(function () {
                $scope.ctrl.select();
            }, 250);
            editorId = $scope.ctrl.editor.getScopeId();
            editorState.componentDomStorage.set(editorId, $scope.getPath(), element);
            // Fetch commonly used variables from editorOptions
            $scope.ctrl.options = $scope.ctrl.editor.options.componentOptions[$scope.model.type];
            if (!$scope.ctrl.options) {
                $scope.ctrl.options = {};
            }
            $scope.ctrl.sanitizerRules = $scope.ctrl.options ? $scope.ctrl.options.allowedTags : null;
            $scope.ctrl.classes = $scope.ctrl.editor.options.componentClasses[$scope.model.type];
            // Use the default element tag if available and not currently set
            if (!$scope.model.tag && $scope.ctrl.options.defaultTag) {
                $scope.model.tag = $scope.ctrl.options.defaultTag;
            }
            $scope.model.class = getClass($scope.model.class, $scope.ctrl.classes);
            function getClass(className, classes) {
                if (!classes) {
                    return '';
                }
                var validClassList = Object.keys(classes.classes);
                var defaultClass = validClassList.indexOf(classes.default) >= 0 ? classes.default : validClassList[0];
                return validClassList.indexOf(className) >= 0 ? className : defaultClass;
            }
            // Add some component classes to the wrapper
            element.addClass('component component-' + $scope.model.type);
            // Build the dynamic component directive
            var html = componentTemplate($scope.model);
            $compile(html)($scope, function (child) {
                element.append(child);
            });
            setWritingDirection($scope.ctrl.options.rtl ? true : false);
            $scope.$on('component:text-direction-rtl', function ($event, rtl) {
                setWritingDirection(rtl);
            });
        };
        function setWritingDirection(rtl) {
            element.toggleClass('component-direction-rtl', rtl);
        }
        ////
        // Scope functions
        $scope.dropTarget = function (yes) {
            if (!yes) {
                element.removeClass('drop-below drop-above');
            }
        };
        $scope.destroy = function () {
            notify.confirm('Are you sure you want to delete this component?').result.then(function () {
                $scope.forceDestroy();
            });
        };
        $scope.forceDestroy = function (backspace) {
            $scope.$parent.$emit('component:destroy', $scope.model, backspace);
        };
        $scope.$on('$destroy', function () {
            editorState.componentDomStorage.set(editorId, $scope.getPath(), null);
        });
        element.on('click', function ($event) {
            $event.stopPropagation();
            select();
            $scope.$apply();
        });
        /**
         * Dropping other element on this element.
         */
        element.on('mouseup', function ($event) {
            if (!$scope.ctrl.editor.state.pickup) {
                return;
            }
            if (dropClassAdded) {
                $event.stopPropagation();
                $scope.move(element.hasClass('drop-below'));
                $scope.ctrl.editor.state.pickup.destroy();
            }
        });
        element.on('mouseleave', function ($event) {
            if (dropClassAdded) {
                $scope.dropTarget(false);
                dropClassAdded = false;
            }
            if (!$scope.ctrl.editor.state.pickup) {
                return;
            }
            $event.stopPropagation();
            $scope.ctrl.editor.changeDropTarget(null);
        });
        element.on('mouseover', function ($event) {
            if (!$scope.ctrl.editor.state.pickup) {
                return;
            }
            $event.stopPropagation();
            $scope.ctrl.editor.changeDropTarget($scope);
        });
        element.on('mousemove', function ($event) {
            if (!$scope.ctrl.editor.state.pickup) {
                return;
            }
            if (!$scope.ctrl.editor.isComponentNestable($scope.ctrl.list.context, $scope.ctrl.list.slot)) {
                return;
            }
            if ($scope !== $scope.ctrl.editor.state.pickup.drop) {
                return;
            }
            // if mouse moved within 0 ~ thresholdH, drop component BEFORE THIS
            // if mouse moved within (bottom - thresholdH) ~ bottom, drop component AFTER THIS
            // if mouse moved within thresholdH ~ (bottom - thresholdH), do nothing
            var coords = getRelativeEventCoords($event, element[0]);
            var rect = element[0].getBoundingClientRect();
            var threshold = rect.height / 2;
            dropClassAdded = true;
            if (coords.y < threshold) {
                element.removeClass('drop-below').addClass('drop-above');
            } else {
                element.removeClass('drop-above').addClass('drop-below');
            }
        });
        $scope.$on('component:focus', function ($event) {
            $event.stopPropagation();
            select();
        });
        $scope.$on('component:trace', function ($event, data) {
            data.push({
                label: $scope.model.type,
                type: 'component',
                model: $scope.model
            });
        });
        $scope.$on('component:commit', function ($event, model, commit) {
            if (model !== $scope.model) {
                return;
            }
            commit.compScopePath = $scope.getPath();
            commit.compEditorId = editorId;
        });
        $scope.setSelected = function (value) {
            if (value) {
                element.addClass('selected');
                editorControls.show();
            } else {
                element.removeClass('selected');
                editorControls.hide();
            }
            if (angular.isFunction($scope.ctrl.callback)) {
                $scope.ctrl.callback(value);
            }
        };
        $scope.pickup = function ($event) {
            var ghost = new ComponentGhost(element[0], $event, $scope.model.type);
            $scope.ctrl.editor.pickupComponent($scope.model, $scope.ctrl.list, ghost);
        };
        $scope.move = function (after) {
            $scope.ctrl.editor.moveComponent($scope.model, $scope.ctrl.list, after);
        };
        $scope.copyToClipboard = function () {
            $scope.ctrl.editor.copyToClipboard($scope.model);
        };
        $scope.getPath = function () {
            return $scope.path;
        };
        init();
    }
}]);
'use strict';
angular.module('komondor-editor').service('componentDomStorage', function () {
    var pool = {};
    this.get = function (editorId, path) {
        return pool[editorId] ? pool[editorId][path] : null;
    };
    this.set = function (editorId, path, dom) {
        if (!pool[editorId]) {
            pool[editorId] = {};
        }
        pool[editorId][path] = dom;
    };
    this.removeEditor = function (editorId) {
        if (!pool[editorId]) {
            return;
        }
        delete pool[editorId];
    };
});
'use strict';
angular.module('komondor-editor').factory('componentTemplate', function () {
    return function (model) {
        var tag = model.tag || 'div';
        var tagParts = [tag, model.type, 'model="model"', 'ng-class="model.class"', 'ng-style="model.style"'];
        var componentHtml = '<' + tagParts.join(' ') + '> </' + tag + '>';
        if (model.link) {
            componentHtml = '<a linked-component>' + componentHtml + '</a>';
        }
        return componentHtml;
    };
});
'use strict';
angular.module('komondor-editor').factory('ComponentGhost', ["$document", "$window", function ($document, $window) {
    return function (domElement, event, type) {
        var container;
        var ghostBusterElement;
        var mouseUpOutsideCallback;
        var ghostElement;
        var scrollTop = function scrollTop() {
            return $window.pageYOffset || $document[0].documentElement.scrollTop || 0;
        };
        var clearSelection = function clearSelection() {
            if ($document[0].selection) {
                $document[0].selection.empty();
                return;
            }
            if ($window.getSelection) {
                $window.getSelection().removeAllRanges();
            }
        };
        var followMouse = function followMouse($event) {
            container.style.left = $event.clientX + 5 + 'px';
            container.style.top = $event.clientY + scrollTop() + 5 + 'px';
        };
        this.init = function () {
            container = $document[0].createElement('div');
            container.className = 'editor-component-ghost';
            ghostElement = angular.element('<i class="material-icon material-icon-' + type + '"></i>');
            container.appendChild(ghostElement[0]);
            $document[0].body.appendChild(container);
            angular.element($document[0].body).addClass('editor-pickup-state');
            // Hide on before move so user CAN'T move anything in element itself
            angular.element(domElement).addClass('ng-hide');
            // Move ghost next to mouse cursor
            followMouse(event);
        };
        this.setMouseUpOutsideCallback = function (cb) {
            mouseUpOutsideCallback = cb;
            // It doesn't propagate if user releases mouse button inside of an editor
            $document.on('mouseup', mouseUpOutsideCallback);
        };
        this.setGhostBusterCallback = function (cb) {
            // Create a separate element to capture a mouse release event
            ghostBusterElement = angular.element($document[0].createElement('div'));
            ghostBusterElement.addClass('editor-component-ghost-buster');
            ghostBusterElement.css({
                left: event.clientX - 20 + 'px',
                top: event.clientY + scrollTop() - 20 + 'px'
            });
            $document[0].body.appendChild(ghostBusterElement[0]);
            // Remove ghost-buster so editor handles move event now
            ghostBusterElement.on('mouseleave', function () {
                ghostBusterElement.remove();
            });
            // Trigger a callback on mouse release captured by ghost-buster
            // This one to prevent component swap with above one
            ghostBusterElement.on('mouseup', cb);
        };
        this.destroy = function () {
            if (ghostBusterElement) {
                ghostBusterElement.remove();
            }
            $document[0].body.removeChild(container);
            $document.off('mouseup', mouseUpOutsideCallback);
            clearSelection();
            angular.element($document[0].body).removeClass('editor-pickup-state');
            // Enabling domElement on after being hidden
            angular.element(domElement).removeClass('ng-hide');
        };
        this.move = function ($event) {
            followMouse($event);
        };
        this.init();
    };
}]);
'use strict';
angular.module('komondor-editor').factory('ComponentLink', function () {
    return function ComponentLink(model, toggleCallback) {
        return {
            getAttributes: function getAttributes() {
                return model.link || {};
            },
            setAttributes: function setAttributes(attributes) {
                var copy = angular.copy(model.link);
                model.link = attributes;
                // Rebuild on applying it for very first time
                if (!copy && model.link) {
                    toggleCallback();
                }
            },
            onSetAttributesDismiss: angular.noop,
            emptyAttributes: function emptyAttributes() {
                model.link = null;
                toggleCallback();
            }
        };
    };
});
'use strict';
angular.module('komondor-editor').directive('componentOptions', ["$injector", "$compile", "$timeout", "editorState", "editorControls", function ($injector, $compile, $timeout, editorState, editorControls) {
    return {
        scope: {},
        link: function link(scope, element) {
            editorControls.componentOptionsScope = scope;
            var componentScope;
            scope.$on('component-controls:build', build);
            scope.$on('$destroy', function () {
                if (componentScope) {
                    componentScope.$destroy();
                }
            });
            function build($event, callback, compScope) {
                element.empty();
                if (componentScope) {
                    componentScope.$destroy();
                }
                if (editorState.gates.options) {
                    componentScope = compScope.$new();
                    element.append(getControls(componentScope));
                    $timeout(callback);
                }
            }
            function getControls($scope) {
                var templateUrl = $scope.ctrl.options.templateUrl;
                var ctrl = $scope.ctrl.options.controller;
                var list = $scope.ctrl.list;
                var html = '';
                // Component options
                html += '<div class=\'component-options\' ng-click=\'$event.stopPropagation();\' ';
                if (ctrl) {
                    html += 'ng-controller=\'' + ctrl + '\'';
                }
                if (templateUrl) {
                    html += ' ng-include=\'"' + templateUrl + '"\' ng-include-replace';
                }
                html += '></div>';
                // Allow the component list to append options to all its immediate children's component options panel
                if (list.options) {
                    // Backward compatibility, map appendOptions to templateUrl
                    if (list.options.appendOptions) {
                        list.options.templateUrl = list.options.appendOptions;
                    }
                    // Include the list's options template and controller
                    if (list.options.templateUrl) {
                        html += '<div class="extra-options-wrapper" ng-include=\'"' + list.options.templateUrl + '"\'';
                        html += ' ng-include-replace';
                        if (list.options.controller) {
                            html += ' ng-controller=\'' + list.options.controller + '\'';
                        }
                        html += '></div>';
                    }
                }
                // Check selected component has margins enabled
                if ($scope.ctrl.options.margin) {
                    html += '<div margin-controls ></div>';
                }
                //Ability to add list of extra options to a component
                if (angular.isArray($scope.ctrl.options.extra) && $scope.ctrl.options.extra.length > 0) {
                    html += '<div class="extra-options-wrapper">';
                    angular.forEach($scope.ctrl.options.extra, function (extraOption) {
                        html += extraOption;
                    });
                    html += '</div>';
                }
                return $compile(html)($scope);
            }
        }
    };
}]);
'use strict';
angular.module('komondor-editor').service('componentSelectorModal', ["$uibModal", "editorState", "editorClipboard", function ($uibModal, editorState, editorClipboard) {
    var modalInstance;
    this.show = function () {
        var editorOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        modalInstance = $uibModal.open({
            windowClass: 'component-selector-modal',
            templateUrl: 'ng-komondor-editor/scripts/editor/component-selector/editor.component-selector.html',
            controller: ['$scope', function ($scope) {
                            $scope.editorState = editorState;
            
                            $scope.paste = function (selected) {
                                if (editorOptions) {
                                    editorOptions.onPasteComponent(editorClipboard.get('copied-component')).then(function (component) {
                                        modalInstance.close(component, selected);
                                    });
                                } else {
                                    modalInstance.close(editorClipboard.get('copied-component'), selected);
                                }
                            };
            
                            $scope.select = function (name, selected) {
                                modalInstance.close(name, selected);
                            };
            
                            var copied = editorClipboard.get('copied-component');
            
                            $scope.canPaste = editorOptions.copyComponent && copied && editorState.nestableComponents[copied.type];
                            $scope.isEmpty = Object.keys($scope.editorState.nestableComponents).length === 0;
                        }]
        });
        return modalInstance.result;
    };
}]);
'use strict';
angular.module('komondor-editor').directive('editorControls', ["editorState", function (editorState) {
    return {
        replace: false,
        require: '^editor',
        templateUrl: 'ng-komondor-editor/scripts/editor/editor-controls/editor-controls.html',
        controllerAs: '$ctrl',
        controller: ["$scope", "$element", function controller($scope, $element) {
            var _this = this;
            $element.on('click', function ($event) {
                $event.stopPropagation();
            });
            this.$onInit = function () {
                _this.gates = editorState.gates;
            };
            /**
             * Used to make a class by color name.
             */
            this.colorClassName = function (value) {
                return value.toLowerCase().replace(/ /g, '-').replace(/[^\w-]+/g, '');
            };
        }]
    };
}]);
'use strict';
angular.module('komondor-editor').service('editorControls', ["$compile", "$timeout", function ($compile, $timeout) {
    this.controls = null;
    this.scope = null;
    this.editorElement = null;
    this.editorScope = null;
    this.componentOptionsScope = null;
    this.create = function (element, $scope, editorScope) {
        if ($scope.$$destroyed) {
            return;
        }
        if (this.scope === $scope) {
            return;
        }
        if (editorScope !== this.editorScope) {
            this.editorScope = editorScope;
        }
        //Remove old controls..
        this.removeControls();
        //Compile new ones
        this.controls = $compile('<div editor-controls class="ng-hide"></div>')(editorScope);
        this.scope = $scope;
        this.editorElement = $scope.ctrl.editor.element;
        this.appendTo(element);
        $timeout(this.componentControlsBuild.bind(this));
    };
    this.componentControlsBuild = function () {
        this.editorScope.$broadcast('component-controls:build', this.checkPosition.bind(this), this.scope);
    };
    this.appendTo = function (element) {
        element.append(this.controls);
    };
    this.rebuild = function () {
        if (this.controls && this.editorScope) {
            this.controls = $compile(this.controls[0])(this.editorScope);
        }
    };
    this.show = function () {
        if (!this.controls) {
            return;
        }
        this.controls.removeClass('ng-hide');
    };
    this.hide = function () {
        if (!this.controls) {
            return;
        }
        this.controls.addClass('ng-hide');
    };
    this.removeControls = function () {
        if (!this.controls) {
            return;
        }
        this.controls.remove();
        this.controls = null;
        if (this.componentOptionsScope) {
            this.componentOptionsScope.$destroy();
        }
    };
    this.reset = function () {
        this.removeControls();
        this.scope = null;
        this.editorElement = null;
        this.editorScope = null;
    };
    this.checkPosition = function () {
        // Hide controls while we check if off screen
        this.controls.css({ visibility: 'hidden' });
        // Remove display none so we can get controls width
        this.show();
        // Remove class to ensure controls in default position before cheching offset
        this.controls.removeClass('editor-option-right');
        // Check if controls hang off the screen
        this.controls[this.isOffScreen() ? 'addClass' : 'removeClass']('editor-option-right');
        // After correct class applied show controls
        this.controls.css({ visibility: '' });
    };
    this.isOffScreen = function () {
        var innerOptions = this.controls.children()[0];
        var innerRect = innerOptions.getBoundingClientRect();
        var editorRect = this.editorElement[0].getBoundingClientRect();
        return editorRect.width - innerRect.left - (innerRect.width - editorRect.left) < 0;
    };
}]);
'use strict';
angular.module('komondor-editor').factory('EditorHistory', ["UndoManager", "$window", "$timeout", "editorState", function (UndoManager, $window, $timeout, editorState) {
    return function EditorHistory(options) {
        var manager = new UndoManager();
        var enabled = options.enabled;
        var scrollable = options.scroll.enabled;
        var self = this;
        var check = function check(callback) {
            return function () {
                if (!self.isEnabled()) {
                    return false;
                }
                return callback.apply(self, arguments);
            };
        };
        var compPath = null;
        var compEditorId = null;
        this.enable = function () {
            enabled = true;
        };
        this.disable = function () {
            enabled = false;
        };
        this.isEnabled = function () {
            return enabled;
        };
        this.setComponentScopePath = check(function (editorId, path) {
            compPath = path;
            compEditorId = editorId;
        });
        this.commit = check(function (action) {
            if (!angular.isFunction(action.redo)) {
                throw new Error('Commit action.redo has to be a function');
            }
            if (!angular.isFunction(action.undo)) {
                throw new Error('Commit action.undo has to be a function');
            }
            if (!action.compScopePath) {
                action.compScopePath = compPath;
                action.compEditorId = compEditorId;
            }
            manager.add(action);
            return true;
        });
        this.getCommandsCount = function () {
            return manager.getCommands().length;
        };
        this.cancelLast = function () {
            var commands = manager.getCommands();
            commands.pop();
        };
        this.redo = function () {
            this.exec('redo');
        };
        this.undo = function () {
            this.exec('undo');
        };
        this.exec = check(function (action) {
            var redo = action === 'redo';
            var hasItem = redo ? 'hasRedo' : 'hasUndo';
            if (!manager[hasItem]()) {
                return;
            }
            var scrolled;
            var command = self.getCommand(redo);
            if (scrollable && !command.scrollAfter) {
                scrolled = self.scroll(redo);
            }
            manager[action]();
            // Scroll to element if it's available only after action
            if (scrollable && !scrolled) {
                $timeout(function () {
                    self.scroll(!redo);
                });
            }
        });
        this.scroll = function (isRedo) {
            var element = self.getElementToScrollTo(isRedo);
            if (!element || !element[0]) {
                return;
            }
            var offsetTop = element[0].getBoundingClientRect().top + options.scroll.offset;
            var className = 'component-reverted';
            element.addClass(className);
            $window.scrollBy(0, offsetTop);
            $timeout(function () {
                element.removeClass(className);
            }, 1000);
            return true;
        };
        this.getCommand = function (redo) {
            var commands = manager.getCommands();
            if (commands.length === 0) {
                return;
            }
            var index = manager.getIndex() + (redo ? 1 : 0);
            return commands[index];
        };
        this.getElementToScrollTo = function (redo) {
            if (!scrollable) {
                return;
            }
            var command = this.getCommand(redo);
            if (!command) {
                return;
            }
            return editorState.componentDomStorage.get(command.compEditorId, command.compScopePath);
        };
        this.clear = check(manager.clear);
        this.hasRedo = manager.hasRedo;
        this.hasUndo = manager.hasUndo;
    };
}]);
'use strict';
angular.module('komondor-editor').factory('EditorTracker', ["$parse", function ($parse) {
    return function EditorTracker(history, options) {
        var self = this;
        var scope = null;
        var olderValue;
        var applyOlderValue;
        var skipCommit = false;
        var lastChangedSrc = null;
        var defaults = {
            allowCommit: function allowCommit() {
                return true;
            },
            getContext: function getContext() {
                return 'default';
            },
            onChange: angular.noop
        };
        this.history = history;
        this.namespace = options.namespace || 'model';
        this.component = null;
        this.model = null;
        this.watchers = [];
        this.isScopeActive = function (scopeToCompare) {
            return scope === scopeToCompare;
        };
        this.setWatchers = function (newScope) {
            this.removeWatchers();
            scope = newScope;
            var props = scope.getTrackables ? scope.getTrackables() : null;
            if (!props) {
                return false;
            }
            this.model = scope[this.namespace];
            this.component = this.model.type;
            var propOptions;
            var listener;
            for (var prop in props) {
                propOptions = props[prop];
                listener = this.attachWatcher(prop, propOptions);
                this.watchers.push(listener);
            }
            return true;
        };
        this.attachWatcher = function (prop, propOptions) {
            if (!scope) {
                return;
            }
            var allowCommit = propOptions.allowCommit || defaults.allowCommit;
            var getContext = propOptions.getContext || defaults.getContext;
            var onChange = propOptions.onChange || defaults.onChange;
            var watcher = self.watcherFactory(allowCommit, getContext, onChange, prop, propOptions.collection, propOptions.callOnChangeAfter);
            return scope.$watch(this.namespace + '.' + prop, watcher, propOptions.deepWatch);
        };
        this.watcherFactory = function (allowCommit, getContext, onChange, prop, collection, callOnChangeAfter) {
            return function (newValue, oldValue) {
                if (skipCommit) {
                    skipCommit = false;
                    applyOlderValue = true;
                    olderValue = oldValue;
                    // Apply it to the next commit
                    return;
                }
                oldValue = applyOlderValue ? olderValue : oldValue;
                applyOlderValue = false;
                if (angular.equals(newValue, oldValue)) {
                    return;
                }
                var context = getContext(newValue, oldValue);
                if (!allowCommit(newValue, oldValue, context)) {
                    return;
                }
                if (callOnChangeAfter) {
                    self.commitObject(oldValue, newValue, scope[self.namespace], onChange.bind(null, context), prop, collection);
                } else {
                    self.commitObject(oldValue, newValue, scope[self.namespace], onChange(context), prop, collection);
                }
            };
        };
        this.commitObject = function (oldValue, newValue, dest, onChange, path, collection) {
            // We don't want to commit the last change that's triggered from undo or redo
            if (lastChangedSrc === dest) {
                lastChangedSrc = null;
                return;
            }
            var afterEach = function afterEach(type) {
                lastChangedSrc = dest;
                if (onChange) {
                    onChange(type, newValue, oldValue, dest);
                }
            };
            var setter = $parse(path).assign;
            /*
             * Used for object arrays to apply a new value
             * Rather than apply changes directly on an object
             */
            var oldValueStr = JSON.stringify(oldValue);
            var newValueStr = JSON.stringify(newValue);
            return self.history.commit({
                undo: function undo() {
                    var valueToApply = collection ? JSON.parse(oldValueStr) : oldValue;
                    setter(dest, valueToApply);
                    afterEach('undo');
                },
                redo: function redo() {
                    var valueToApply = collection ? JSON.parse(newValueStr) : newValue;
                    setter(dest, valueToApply);
                    afterEach('redo');
                }
            });
        };
        this.skip = function () {
            skipCommit = true;
        };
        this.removeWatchers = function () {
            olderValue = undefined;
            scope = null;
            lastChangedSrc = null;
            for (var index in this.watchers) {
                this.watchers[index]();
            }
        };
    };
}]);
'use strict';
angular.module('komondor-editor').factory('UndoManager', ["$window", function ($window) {
    return $window.UndoManager;
}]);
'use strict';
angular.module('ng-komondor-editor.templates', []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("ng-komondor-editor/scripts/editor/editor.html", "<div class=\"editor\"><div class=\"editor-content\"><div model=\"model\" component-list=\"{{property}}\"></div></div><div class=\"component-trace\" ng-class=\"{active: isEditorSelected() && options.showBreadcrumbs === true}\"><a href ng-repeat=\"item in componentTraceItems\" ng-click=\"setFocusToItem(item.model, $event)\">{{ item.label }}</a></div></div>");
  $templateCache.put("ng-komondor-editor/scripts/components/bullets/bullets.html", "<ul><li ng-class=\"item.class\" ng-repeat=\"item in data.list\"><div editable ng-keydown=\"onKeydown($event, $index)\" ng-model=\"item.html\" ng-trim=\"false\"></div><div model=\"item\" committable=\"false\" component-list=\"nested\" ng-if=\"item.nested\"></div></li></ul>");
  $templateCache.put("ng-komondor-editor/scripts/components/bullets/bullets.options.html", "<div uib-dropdown class=\"btn-group btn-group-xs\"><button uib-dropdown-toggle class=\"btn btn-default\"><span class=\"text\">Options</span><span class=\"caret\"></span></button><ul uib-dropdown-menu class=\"dropdown-menu\" role=\"menu\"><li class=\"dropdown-item\" role=\"menuitem\"><button type=\"button\" class=\"btn btn-default btn-xs btn-block\" ng-if=\"!selected.nested\" ng-click=\"addNested()\">Indent</button><button type=\"button\" class=\"btn btn-default btn-xs btn-block\" ng-if=\"selected.nested\" ng-click=\"destroyNested()\">Remove Indent</button></li></ul></div><div class=\"btn-group btn-group-xs\"><button type=\"button\" ng-if=\"selected\" class=\"btn btn-default btn-xs ng-scope\" ng-click=\"moveBulletUp()\"><i class=\"material-icon material-icon-arrow-upward\"></i></button><button type=\"button\" ng-if=\"selected\" class=\"btn btn-default btn-xs ng-scope\" ng-click=\"moveBulletDown()\"><i class=\"material-icon material-icon-arrow-downward\"></i></button></div>");
  $templateCache.put("ng-komondor-editor/scripts/components/description-list/description-list.html", "<dl><dt ng-repeat-start=\"item in data.list\" ng-if=\"item.tag === \'dt\'\" editable ng-keydown=\"onKeydown($event, $index)\" ng-model=\"item.html\" ng-trim=\"false\"></dt><dd ng-repeat-end ng-if=\"item.tag === \'dd\'\" editable ng-keydown=\"onKeydown($event, $index)\" ng-model=\"item.html\" ng-trim=\"false\"></dd></dl>");
  $templateCache.put("ng-komondor-editor/scripts/components/description-list/description-list.options.html", "<div class=\"btn-group btn-group-xs\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"addDescListChild(\'dt\')\">Add Title</button></div><div class=\"btn-group btn-group-xs\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"addDescListChild(\'dd\')\">Add Description</button></div>");
  $templateCache.put("ng-komondor-editor/scripts/components/image/image.html", "<div class=\"image\"><div class=\"image-wrapper\" ng-style=\"computed.style\" ng-if=\"state.editMode ? true : data.asset_id\"><img ng-if=\"!data.setAspectRatio\" alt=\"\" class=\"screen-image\" ng-src=\"{{ ctrl.options.urlAt === \'data\' ? data.url : computed.url }}\"><div ng-if=\"data.setAspectRatio\" picture=\"data.url\" class=\"print-image\" ng-class=\"anchorOptions[data.anchor].class\"></div><div class=\"overlay-section {{data.overlayPos}}\" ng-if=\"data.hasOverlay\" model=\"model\" component-list=\"overlay\"></div></div><p class=\"caption\" ng-if=\"data.hasCaption\" editable ng-model=\"data.caption\" ng-trim=\"false\"></p><div class=\"popup-btn\" ng-click=\"popupFun()\"><div class=\"expand-icon\"></div></div></div>");
  $templateCache.put("ng-komondor-editor/scripts/components/image/image.modal.html", "<div class=\"modal-body\"><div class=\"image-container\"><img ng-src=\"{{ image.url }}\"></div><div class=\"close-btn\"><div class=\"close-icon\" ng-click=\"$close()\"></div></div></div>");
  $templateCache.put("ng-komondor-editor/scripts/components/image/image.options.html", "<div media-picker class=\"btn-group btn-group-xs\" ng-model=\"data.asset_id\" types=\"image\"></div><div uib-dropdown class=\"btn-group btn-group-xs\" ng-if=\"ctrl.options.dropdown\"><button uib-dropdown-toggle class=\"btn btn-default\"><span class=\"text\">Options</span><span class=\"caret\"></span></button><ul uib-dropdown-menu class=\"dropdown-menu\"><li class=\"dropdown-item\" ng-if=\"ctrl.options.resizable\"><div class=\"input-group input-group-sm\"><span class=\"input-group-addon\" id=\"basic-addon1\">Width</span><input type=\"number\" class=\"form-control\" ng-model=\"computed.width\" min=\"1\"><span class=\"input-group-btn input-group-sm\"><button ng-click=\"computed.widthUnit = computed.widthUnit === \'px\' ? \'%\' : \'px\'\" class=\"btn btn-default\" type=\"button\">{{ computed.widthUnit }}</button></span></div></li><li class=\"dropdown-item\" ng-if=\"ctrl.options.resizable\"><checkbox-input class=\"checkbox-input-inverted checkbox-input-xs\" name=\"aspect-ratio-checkbox\" label=\"\'Aspect ratio\'\" ng-model=\"data.setAspectRatio\" ng-change=\"imageStyleChanged()\"></checkbox-input></li><li class=\"dropdown-item\" ng-if=\"ctrl.options.resizable\"><div class=\"input-group\" ng-if=\"data.setAspectRatio\"><span class=\"input-wrapper\"><input type=\"number\" class=\"form-control form-control-xs\" ng-model=\"data.ratio[0]\" min=\"0\" ng-change=\"imageStyleChanged()\"></span><span class=\"input-group-addon\" id=\"basic-addon2\">:</span><span class=\"input-wrapper\"><input type=\"number\" class=\"form-control form-control-xs\" ng-model=\"data.ratio[1]\" min=\"0\" ng-change=\"imageStyleChanged()\"></span></div></li><li class=\"dropdown-item\" ng-if=\"ctrl.options.resizable\"><div uib-dropdown class=\"dropdown btn-group btn-group-xs btn-block\" ng-if=\"data.setAspectRatio\"><button uib-dropdown-toggle class=\"btn btn-default btn-block\"><span>{{ data.anchor }}</span><span class=\"caret\"></span></button><ul uib-dropdown-menu class=\"dropdown-menu\"><li class=\"dropdown-item\" ng-repeat=\"(key, value) in anchorOptions\"><button class=\"btn btn-default btn-block btn-xs\" ng-click=\"data.anchor = key\"><span>{{ key }}</span></button></li></ul></div></li><li class=\"dropdown-item\" ng-show=\"ctrl.options.caption || data.hasCaption\"><checkbox-input class=\"checkbox-input-inverted checkbox-input-xs\" name=\"caption-checkbox\" label=\"\'Caption\'\" ng-model=\"data.hasCaption\"></checkbox-input></li><li class=\"dropdown-item\" ng-if=\"ctrl.options.overlay\"><checkbox-input class=\"checkbox-input-inverted checkbox-input-xs\" name=\"overlay-checkbox\" label=\"\'Overlay\'\" ng-model=\"data.hasOverlay\"></checkbox-input></li><li class=\"dropdown-item\" ng-if=\"ctrl.options.overlay\"><div uib-dropdown class=\"dropdown btn-group btn-group-xs btn-block\" ng-if=\"data.hasOverlay\"><button uib-dropdown-toggle class=\"btn btn-default btn-block\"><span>{{ overlayPositions[data.overlayPos] }}</span><span class=\"caret\"></span></button><ul uib-dropdown-menu class=\"dropdown-menu\"><li ng-repeat=\"(key, pos) in overlayPositions\"><button class=\"btn btn-default btn-block btn-xs\" ng-click=\"setOverlayPosition(key)\"><span>{{ pos }}</span></button></li></ul></div></li><li class=\"dropdown-item\" ng-show=\"ctrl.options.offline\"><checkbox-input class=\"checkbox-input-inverted checkbox-input-xs\" name=\"offline-checkbox\" label=\"\'Available offline\'\" ng-model=\"data.offline\"></checkbox-input></li></ul></div>");
  $templateCache.put("ng-komondor-editor/scripts/components/table/table.html", "<table class=\"{{ data.tableClass }}\" ng-class=\"{\'fixed-columns\': data.has_fixed, \'no-wrap\': data.has_nowrap}\"><caption editable ng-model=\"data.caption\" ng-if=\"data.has_caption\"></caption><thead><tr ng-repeat=\"row in data.thead\"><th rowspan=\"{{ cell.rowspan }}\" colspan=\"{{ cell.colspan }}\" ng-repeat=\"cell in row\" ng-class=\"{selected: cell === selected.cell}\" class=\"{{ cell.classes.join(\' \') }}\" ng-click=\"select(cell)\"><div editable ng-model=\"cell.content\" ng-if=\"!cell.noText\" class=\"table-cell\"></div><div component-list=\"nested\" model=\"cell\" ng-if=\"cell.hasNest\"></div></th></tr></thead><tbody><tr ng-repeat=\"row in data.tbody\"><td ng-repeat=\"cell in row\" rowspan=\"{{ cell.rowspan }}\" colspan=\"{{ cell.colspan }}\" ng-repeat=\"cell in row\" ng-class=\"{selected: cell === selected.cell}\" class=\"{{ cell.classes.join(\' \') }}\" ng-click=\"select(cell)\"><div editable ng-model=\"cell.content\" ng-if=\"!cell.noText\" class=\"table-cell\"></div><div component-list=\"nested\" path=\"path\" model=\"cell\" committable=\"false\" ng-if=\"cell.hasNest\"></div></td></tr></tbody></table><p class=\"table-info\" ng-if=\"data.has_info\" editable ng-model=\"data.info\"></p>");
  $templateCache.put("ng-komondor-editor/scripts/components/table/table.options.html", "<div uib-dropdown class=\"btn-group btn-group-xs\"><button uib-dropdown-toggle class=\"btn btn-default\"><span class=\"text\">Table options</span><span class=\"caret\"></span></button><ul uib-dropdown-menu class=\"dropdown-menu btn-block\"><li class=\"dropdown-item\"><div class=\"btn-group btn-group-justified\"><div class=\"btn-group btn-group-xs\"><button type=\"button\" class=\"btn btn-default\" ng-disabled=\"true\"><i class=\"material-icon material-icon-view-column\"></i></button></div><div class=\"btn-group btn-group-xs\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"addColumn()\" title=\"Add Column\"><i class=\"material-icon material-icon-add\"></i></button></div><div class=\"btn-group btn-group-xs\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"removeColumn()\" title=\"Remove Column\"><i class=\"material-icon material-icon-remove\"></i></button></div></div></li><li class=\"dropdown-item\"><div class=\"btn-group btn-group-justified\"><div class=\"btn-group btn-group-xs\"><button type=\"button\" class=\"btn btn-default\" ng-disabled=\"true\"><i class=\"material-icon material-icon-view-stream\"></i></button></div><div class=\"btn-group btn-group-xs\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"addRow()\" title=\"Add Row\"><i class=\"material-icon material-icon-add\"></i></button></div><div class=\"btn-group btn-group-xs\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"removeRow()\" title=\"Remove Row\"><i class=\"material-icon material-icon-remove\"></i></button></div></div></li><li class=\"dropdown-item\"><checkbox-input class=\"checkbox-input-inverted checkbox-input-xs\" name=\"caption-checkbox\" label=\"\'Caption\'\" ng-model=\"data.has_caption\"></checkbox-input></li><li class=\"dropdown-item\"><checkbox-input class=\"checkbox-input-inverted checkbox-input-xs\" name=\"info-checkbox\" label=\"\'Info\'\" ng-model=\"data.has_info\"></checkbox-input></li><li class=\"dropdown-item\"><checkbox-input class=\"checkbox-input-inverted checkbox-input-xs\" name=\"fixed-with-checkbox\" label=\"\'Fixed width\'\" ng-model=\"data.has_fixed\"></checkbox-input></li><li class=\"dropdown-item\"><checkbox-input class=\"checkbox-input-inverted checkbox-input-xs\" name=\"fixed-with-checkbox\" label=\"\'No wrap\'\" ng-model=\"data.has_nowrap\"></checkbox-input></li><li class=\"dropdown-item\"><checkbox-input class=\"checkbox-input-inverted checkbox-input-xs\" name=\"fixed-with-checkbox\" label=\"\'Horizontal scroll bar\'\" ng-model=\"data.wrapperClass.has_hscroll\"></checkbox-input></li></ul></div><div uib-dropdown class=\"btn-group btn-group-xs\" ng-show=\"selected.cell\"><button uib-dropdown-toggle class=\"btn btn-default\"><span class=\"text\">Cell options</span><span class=\"caret\"></span></button><ul uib-dropdown-menu class=\"dropdown-menu btn-block\"><li class=\"dropdown-item\" ng-show=\"allowTh\"><checkbox-input class=\"checkbox-input-inverted checkbox-input-xs\" name=\"th-checkbox\" label=\"\'TH\'\" ng-model=\"selected.cell.th\" ng-change=\"updateCellClasses()\"></checkbox-input></li><li class=\"dropdown-item\"><checkbox-input class=\"checkbox-input-inverted checkbox-input-xs\" name=\"no-text-checkbox\" label=\"\'No text\'\" ng-model=\"selected.cell.noText\" ng-true-value=\"undefined\" ng-false-value=\"true\"></checkbox-input></li><li class=\"dropdown-item\"><checkbox-input class=\"checkbox-input-inverted checkbox-input-xs\" name=\"nest-checkbox\" label=\"\'Nest\'\" ng-model=\"selected.cell.hasNest\" ng-change=\"toggleNest()\"></checkbox-input></li><li class=\"table-highlight-options dropdown-item\"><checkbox-input class=\"checkbox-input-inverted checkbox-input-xs\" name=\"highlight-checkbox\" label=\"\'Highlight\'\" ng-model=\"selected.cell.highlight\" ng-change=\"toggleHighlight()\"></checkbox-input><select ng-show=\"selected.cell.highlight\" ng-if=\"highlightOptions.length\" class=\"highlight btn-block\" ng-class=\"selected.cell.highlightClass\" ng-model=\"selected.cell.highlightClass\" ng-change=\"selectHighlightClass(\'{{selected.cell.highlightClass}}\')\"><option value=\"\" class=\"highlight\">Highlight</option><option ng-repeat=\"item in highlightOptions\" value=\"{{ item.class }}\" class=\"highlight\" ng-class=\"item.class\">{{ item.name }}</option></select></li><li class=\"dropdown-item\"><div class=\"btn-group btn-group-justified\"><div class=\"btn-group btn-group-xs\"><button class=\"btn btn-default\" ng-click=\"deleteTextAlign(); updateCellClasses()\" title=\"Align Left\"><i class=\"material-icon material-icon-format-align-left\"></i></button></div><div class=\"btn-group btn-group-xs\"><button class=\"btn btn-default\" ng-click=\"selected.cell.textAlign = \'align-center\'; updateCellClasses()\" title=\"Align Center\"><i class=\"material-icon material-icon-format-align-center\"></i></button></div><div class=\"btn-group btn-group-xs\"><button class=\"btn btn-default\" ng-click=\"selected.cell.textAlign = \'align-right\'; updateCellClasses()\" title=\"Align Right\"><i class=\"material-icon material-icon-format-align-right\"></i></button></div></div></li><li class=\"dropdown-item\"><div class=\"btn-group btn-group-justified\"><div class=\"btn-group btn-group-xs\"><button class=\"btn btn-default\" title=\"Merge Right\" ng-click=\"mergeRight()\"><i class=\"material-icon material-icon-arrow-forward\"></i></button></div><div class=\"btn-group btn-group-xs\"><button class=\"btn btn-default\" ng-click=\"mergeDown()\" title=\"Merge Down\"><i class=\"material-icon material-icon-arrow-downward\"></i></button></div><div class=\"btn-group btn-group-xs\"><button class=\"btn btn-default\" ng-click=\"unmerge()\" title=\"Unmerge\"><i class=\"material-icon material-icon-open-with\"></i></button></div></div></li></ul></div>");
  $templateCache.put("ng-komondor-editor/scripts/components/tabs/tab.content.html", "<div ng-class=\"{\'tabs-content\' : true, active: active}\"><div class=\"tab-print-title\">{{ tab.title }}</div><div component-list=\"nested\" model=\"tab.nested\" ng-if=\"tab.hasNest\"></div></div>");
  $templateCache.put("ng-komondor-editor/scripts/components/tabs/tabs.heading.html", "<div class=\"tabs-title-container\" ng-class=\"\'tabs-heading-align-\' + data.tabAlign\"><h3 ng-if=\"data.hasTitle\" class=\"tabs-component-title\"><span ng-model=\"data.title\" bind-content-editable=\"$ctrl.editorState.editMode\"></span></h3><div class=\"tabs-heading-container\"><a class=\"slider-control prev\"><span class=\"material-icon material-icon-chevron-left\"></span></a><ul class=\"tabs-heading\"><li ng-repeat=\"tab in data.tabs\" ng-class=\"{active: $index === selectedIndex || ($index === 0 && !selectedIndex)}\" class=\"tabs-heading-tab\" ng-click=\"$ctrl.select(tab)\"><span ng-bind=\"tab.title\"></span><input type=\"text\" ng-model=\"tab.title\" size=\"{{tab.title.length}}\"></li></ul><a class=\"slider-control next\"><span class=\"material-icon material-icon-chevron-right\"></span></a></div></div>");
  $templateCache.put("ng-komondor-editor/scripts/components/tabs/tabs.html", "<div class=\"tabs-component\"><div class=\"tabs-content-containter\"><div ng-repeat=\"tab in data.tabs\" tab-content tab=\"tab\" active=\"$index === selectedIndex\" class=\"tab-{{$index}}\"></div><p ng-if=\"data.hasInfo\" class=\"tabs-component-info\"><small editable ng-model=\"data.info\"></small></p></div></div>");
  $templateCache.put("ng-komondor-editor/scripts/components/tabs/tabs.options.html", "<div uib-dropdown class=\"btn-group btn-group-xs\"><button uib-dropdown-toggle class=\"btn btn-default\"><span class=\"text\">Options</span><span class=\"caret\"></span></button><ul class=\"dropdown-menu\" uib-dropdown-menu><li class=\"dropdown-item\"><div class=\"btn-group btn-group-justified\"><div class=\"btn-group\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.addTab()\" title=\"Add tab\"><i class=\"material-icon material-icon-add\"></i></button></div><div class=\"btn-group\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.removeTab()\" title=\"Remove tab\"><i class=\"material-icon material-icon-remove\"></i></button></div></div></li><li class=\"dropdown-item\"><div class=\"btn-group btn-group-justified\"><div class=\"btn-group btn-group-xs\"><button class=\"btn btn-default\" ng-click=\"$ctrl.setAlign(\'left\')\" title=\"Align Left\"><i class=\"material-icon material-icon-format-align-left\"></i></button></div><div class=\"btn-group btn-group-xs\"><button class=\"btn btn-default\" ng-click=\"$ctrl.setAlign(\'center\')\" title=\"Align Centre\"><i class=\"material-icon material-icon-format-align-center\"></i></button></div></div></li><li class=\"dropdown-item\"><checkbox-input class=\"checkbox-input-inverted checkbox-input-xs\" name=\"show-title\" label=\"\'Title\'\" ng-model=\"data.hasTitle\"></checkbox-input></li><li class=\"dropdown-item\"><checkbox-input class=\"checkbox-input-inverted checkbox-input-xs\" name=\"show-info\" label=\"\'Info\'\" ng-model=\"data.hasInfo\"></checkbox-input></li></ul></div>");
  $templateCache.put("ng-komondor-editor/scripts/components/video-player/video-player.controls.html", "<div class=\"video-controls fade\"><div class=\"controls-panel\"><button type=\"button\" class=\"btn play-pause\" ng-click=\"videoPlayerCtrl.togglePlay()\"><span class=\"glyphicon-komondor-play\" ng-hide=\"state.isPlaying\"></span><span class=\"glyphicon-komondor-pause\" ng-show=\"state.isPlaying\"></span></button><input type=\"range\" class=\"seek-bar\" min=\"0\" max=\"{{ state.duration }}\" step=\"0.5\" value=\"{{ state.currTime }}\" ng-model=\"state.currTime\"><button type=\"button\" class=\"btn time-code\">{{ state.currTimeDisplay }}</button><button type=\"button\" class=\"btn btn-primary mute\" ng-click=\"videoPlayerCtrl.mute()\"><span class=\"glyphicon-komondor-volume-on\" ng-hide=\"state.volume == 0\"></span><span class=\"glyphicon-komondor-volume-off\" ng-show=\"state.volume == 0\"></span></button><input type=\"range\" class=\"volume-bar\" min=\"0\" max=\"1\" step=\"0.1\" value=\"{{ state.volume }}\" ng-model=\"state.volume\" ng-change=\"videoPlayerCtrl.updateVolume()\"><button type=\"button\" class=\"btn btn-primary full-screen\" ng-if=\"!state.fullscreenDisabled\" ng-click=\"videoPlayerCtrl.toggleFullScreen()\"><span class=\"glyphicon-komondor-expand\"></span></button></div></div>");
  $templateCache.put("ng-komondor-editor/scripts/components/video-player/video-player.html", "<div class=\"video-player\"><img class=\"video-poster\" ng-src=\"{{ computed.thumbSafe }}\" ng-class=\"{\'video-placeholder\':!data.asset_id || forcePoster }\" ng-if=\"state.editMode ? true: data.asset_id\"><video height=\"100%\" width=\"100%\" preload controls playsinline ng-attr-controlslist=\"{{data.hideDownloads === true ? \'nodownload\' : \'\'}}\" disable-right-click=\"{{data.hideDownloads}}\" ng-class=\"{\'fullscreen\': data.fullSize}\" ng-style=\"{ \'opacity\' : forcePoster ? \'0\' : \'1\' }\"><source ng-src=\"{{ computed.links.mp4 }}\" type=\"video/mp4\" ng-if=\"computed.links.mp4 && !forcePoster\"><source ng-src=\"{{ computed.links.webm }}\" type=\"video/webm\" ng-if=\"!computed.links.mp4 && computed.links.webm && !forcePoster\">Your browser does not support the video tag.</video><div ng-if=\"!ctrl.options.nativeControls\" video-player-controls state=\"playback\"></div><p class=\"caption\" ng-if=\"data.hasCaption\" editable ng-model=\"data.caption\" ng-trim=\"false\"></p></div>");
  $templateCache.put("ng-komondor-editor/scripts/components/video-player/video-player.options.html", "<div media-picker class=\"btn-group btn-group-xs\" ng-model=\"model.data.asset_id\" types=\"video\"></div><div uib-dropdown class=\"dropdown btn-group btn-group-xs\"><button uib-dropdown-toggle class=\"btn btn-default\"><span class=\"text\">Options</span><span class=\"caret\"></span></button><ul uib-dropdown-menu class=\"dropdown-menu btn-block\"><li class=\"dropdown-item\"><div uib-dropdown class=\"dropdown btn-group btn-group-xs btn-block\"><button uib-dropdown-toggle class=\"btn btn-default btn-block\"><span>{{ vAlign[data.vAlign] }}</span><span class=\"caret\"></span></button><ul uib-dropdown-menu class=\"dropdown-menu\"><li ng-repeat=\"(key, pos) in vAlign\"><button class=\"btn btn-default btn-block btn-xs\" ng-click=\"configAlignment(key)\">{{ pos }}</button></li></ul></div></li><li class=\"dropdown-item\"><checkbox-input class=\"checkbox-input-inverted checkbox-input-xs\" name=\"caption-checkbox\" label=\"\'Caption\'\" ng-model=\"model.data.hasCaption\"></checkbox-input></li><li class=\"dropdown-item\"><checkbox-input class=\"checkbox-input-inverted checkbox-input-xs\" name=\"controls-checkbox\" label=\"\'Controls\'\" ng-model=\"model.data.controls\" ng-change=\"configChanged(\'controls\')\"></checkbox-input></li><li class=\"dropdown-item\"><checkbox-input class=\"checkbox-input-inverted checkbox-input-xs\" name=\"autoplay-checkbox\" label=\"\'AutoPlay\'\" ng-model=\"model.data.autoplay\" ng-change=\"configChanged(\'autoplay\')\"></checkbox-input></li><li class=\"dropdown-item\"><checkbox-input class=\"checkbox-input-inverted checkbox-input-xs\" name=\"muted-checkbox\" label=\"\'Muted\'\" ng-model=\"model.data.muted\" ng-change=\"configChanged(\'muted\')\"></checkbox-input></li><li class=\"dropdown-item\"><checkbox-input class=\"checkbox-input-inverted checkbox-input-xs\" name=\"loop-checkbox\" label=\"\'Loop\'\" ng-model=\"model.data.loop\" ng-change=\"configChanged(\'loop\')\"></checkbox-input></li><li class=\"dropdown-item\"><checkbox-input class=\"checkbox-input-inverted checkbox-input-xs\" name=\"hide-downloads-checkbox\" label=\"\'Hide downloads\'\" ng-model=\"model.data.hideDownloads\" ng-change=\"configChanged(\'hideDownloads\')\"></checkbox-input></li><li class=\"dropdown-item\" ng-if=\"videoInBackLayer\"><checkbox-input class=\"checkbox-input-inverted checkbox-input-xs\" name=\"fullSize-checkbox\" label=\"\'FullSize\'\" ng-model=\"model.data.fullSize\" ng-change=\"configChanged(\'fullSize\')\"></checkbox-input></li><li ng-if=\"ctrl.options.preload\"><label>Preload</label><select class=\"form-control\" ng-model=\"model.data.preload\"><option value=\"auto\">Auto</option><option value=\"metadata\">Metadata</option><option value=\"none\">None</option></select></li><li class=\"dropdown-item\" ng-if=\"!ctrl.options.nativeControls\"><div class=\"input-group input-group-sm\"><span class=\"input-group-addon\">Start</span><input type=\"number\" class=\"form-control\" min=\"1\" placeholder=\"E.g: 1\" ng-model=\"model.data.startFrom\" ng-change=\"configChanged()\"></div></li><li class=\"dropdown-item\" ng-if=\"!ctrl.options.nativeControls\"><div class=\"input-group input-group-sm\"><span class=\"input-group-addon\">End</span><input type=\"number\" class=\"form-control\" min=\"1\" placeholder=\"E.g: 10\" ng-model=\"model.data.stopAt\" ng-change=\"configChanged()\"></div></li></ul></div>");
  $templateCache.put("ng-komondor-editor/scripts/directives/margin-controls/margin-controls.html", "<div class=\"btn-group btn-group-xs\"><div uib-dropdown class=\"btn-group btn-group-xs\"><button uib-dropdown-toggle class=\"btn btn-default\"><span class=\"text\">Margins</span><span class=\"caret\"></span></button><form name=\"marginForm\" uib-dropdown-menu class=\"dropdown-menu margin-settings\"><div class=\"row\"><div class=\"col-xs-4 col-xs-offset-4\"><div class=\"row\"><i class=\"material-icon material-icon-keyboard-arrow-up\"></i></div><div class=\"input-group input-group-sm\" ng-class=\"{\'has-error\': marginForm.top.$invalid}\"><input name=\"top\" type=\"text\" class=\"form-control\" placeholder=\"Auto\" ng-model=\"marginConfig.top\" ng-pattern=\"/^-?\\d+$/\" ng-change=\"valueChanged(\'top\')\" ng-keydown=\"onKeyDown($event, \'top\')\" uib-tooltip=\"Invalid\" tooltip-class=\"danger\" tooltip-enable=\"marginForm.top.$invalid\" tooltip-is-open=\"marginForm.top.$invalid\" tooltip-placement=\"bottom\" tooltip-trigger=\"none\"><span class=\"input-group-btn\"><button class=\"btn btn-default\" type=\"button\" ng-click=\"unitChanged(\'top\', marginConfig.topUnit)\">{{ marginConfig.topUnit }}</button></span></div></div></div><div class=\"row side-margins\"><div class=\"side-margin-left\"><i class=\"material-icon material-icon-keyboard-arrow-left\"></i></div><div class=\"col-xs-4\"><div class=\"input-group input-group-sm\" ng-class=\"{\'has-error\': marginForm.left.$invalid}\"><input name=\"left\" type=\"text\" class=\"form-control\" placeholder=\"Auto\" ng-model=\"marginConfig.left\" ng-pattern=\"/^-?\\d+$/\" ng-change=\"valueChanged(\'left\')\" ng-keydown=\"onKeyDown($event, \'left\')\" uib-tooltip=\"Invalid\" tooltip-class=\"danger\" tooltip-enable=\"marginForm.left.$invalid\" tooltip-is-open=\"marginForm.left.$invalid\" tooltip-placement=\"bottom\" tooltip-trigger=\"none\"><span class=\"input-group-btn\"><button class=\"btn btn-default\" type=\"button\" ng-click=\"unitChanged(\'left\', marginConfig.leftUnit)\">{{ marginConfig.leftUnit }}</button></span></div></div><div class=\"col-xs-4 col-xs-offset-4\"><div class=\"input-group input-group-sm\" ng-class=\"{\'has-error\': marginForm.right.$invalid}\"><input name=\"right\" type=\"text\" class=\"form-control\" placeholder=\"Auto\" ng-model=\"marginConfig.right\" ng-pattern=\"/^-?\\d+$/\" ng-change=\"valueChanged(\'right\')\" ng-keydown=\"onKeyDown($event, \'right\')\" uib-tooltip=\"Invalid\" tooltip-class=\"danger\" tooltip-enable=\"marginForm.right.$invalid\" tooltip-is-open=\"marginForm.right.$invalid\" tooltip-placement=\"bottom\" tooltip-trigger=\"none\"><span class=\"input-group-btn\"><button class=\"btn btn-default\" type=\"button\" ng-click=\"unitChanged(\'right\', marginConfig.rightUnit)\">{{ marginConfig.rightUnit }}</button></span></div></div><div class=\"side-margin-right\"><i class=\"material-icon material-icon-keyboard-arrow-right\"></i></div></div><div class=\"row\"><div class=\"col-xs-4 col-xs-offset-4\"><div class=\"input-group input-group-sm\" ng-class=\"{\'has-error\': marginForm.bottom.$invalid}\"><input name=\"bottom\" type=\"text\" class=\"form-control\" placeholder=\"Auto\" ng-model=\"marginConfig.bottom\" ng-pattern=\"/^-?\\d+$/\" ng-change=\"valueChanged(\'bottom\')\" ng-keydown=\"onKeyDown($event, \'bottom\')\" uib-tooltip=\"Invalid\" tooltip-class=\"danger\" tooltip-enable=\"marginForm.bottom.$invalid\" tooltip-is-open=\"marginForm.bottom.$invalid\" tooltip-placement=\"bottom\" tooltip-trigger=\"none\"><span class=\"input-group-btn\"><button class=\"btn btn-default\" type=\"button\" ng-click=\"unitChanged(\'bottom\', marginConfig.bottomUnit)\">{{ marginConfig.bottomUnit }}</button></span></div><div class=\"row\"><i class=\"material-icon material-icon-keyboard-arrow-down\"></i></div></div></div></form></div></div>");
  $templateCache.put("ng-komondor-editor/scripts/editor/component-list/component-list.html", "<div class=\"component-list\" ng-class=\"{empty: model[slot].length === 0}\"><div component model=\"comp\" path=\"path + \'.\' + slot +\'[\' + $index + \'].\' + comp.type\" ng-repeat-start=\"comp in model[slot]\" ng-class=\"[comp.data.wrapperClass, {\'component-list-first\': $first, \'component-list-last\': $last}]\" ng-style=\"comp.componentStyle\"><div class=\"btn-add-after\" title=\"Insert element after this\" ng-if=\"canAddChild\" ng-click=\"insertElement(comp)\"><i class=\"material-icon material-icon-add-circle\"></i></div></div><div ng-include=\"options.append\" ng-if=\"options.append\" ng-repeat-end></div></div>");
  $templateCache.put("ng-komondor-editor/scripts/editor/component-selector/editor.component-selector.html", "<div class=\"modal-header text-center\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><h1 class=\"modal-title\">Add an object</h1></div><div class=\"modal-body\"><div class=\"editor-components\"><button class=\"btn btn-default\" ng-repeat=\"(name, label) in ::editorState.nestableComponents\" ng-click=\"select(name, editorState.selected)\"><i class=\"material-icon material-icon-{{ name }}\"></i><span>{{ label }}</span></button></div><p ng-if=\"isEmpty\">Your current permission level does not allow you to add components here.</p></div><div class=\"modal-footer\"><div class=\"row\"><div class=\"col-xs-6\"><button class=\"btn btn-default btn-block\" ng-if=\"canPaste\" ng-click=\"paste(editorState.selected)\"><i class=\"material-icon material-icon-content-paste\"></i><span>Paste Component</span></button></div><div class=\"col-xs-6\"><button type=\"button\" class=\"btn btn-primary btn-block\" ng-click=\"$dismiss()\">Cancel</button></div></div></div>");
  $templateCache.put("ng-komondor-editor/scripts/editor/editor-controls/editor-controls.html", "<div class=\"editor-option\" ng-style=\"editor.options.style\" ng-if=\"editor.state.editMode\" ng-hide=\"editor.state.pickup\"><div class=\"btn-toolbar\"><div class=\"btn-group btn-group-xs\" ng-if=\"editor.state.selected\n                && $ctrl.gates.moveDelete\n                && editor.state.componentScope\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"editor.destroyComponent()\"><i class=\"material-icon material-icon-delete\"></i></button><button type=\"button\" class=\"btn btn-default btn-xs\" ng-mousedown=\"editor.startMoveComponent($event)\"><i class=\"material-icon material-icon-open-with\"></i></button><button ng-if=\"$ctrl.gates.copyComponent\" type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"editor.copyComponent()\"><i class=\"material-icon material-icon-content-copy\"></i></button></div><div class=\"btn-group btn-group-xs\" ng-if=\"$ctrl.gates.textOptions\" ng-include=\"editor.textFormattingTemplate\"></div><div class=\"btn-group btn-group-xs\" ng-if=\"editor.showTextControls(\'font\') && $ctrl.gates.textOptions\"><div uib-dropdown class=\"btn-group btn-group-xs\"><button uib-dropdown-toggle class=\"btn btn-default\"><i class=\"material-icon material-icon-format-color-text\"></i><span class=\"caret\"></span></button><ul uib-dropdown-menu class=\"dropdown-menu\"><li class=\"dropdown-item {{$ctrl.colorClassName(key)}}\" ng-repeat=\"(key, value) in editor.options.textColours\"><button type=\"button\" class=\"btn btn-default btn-block btn-xs\" ng-click=\"colorText(value)\"><span class=\"editor-swatch-label\">{{ key }}</span><span class=\"editor-text-options-swatch\" ng-style=\"{\'background\': value }\"></span></button></li></ul></div><div ng-if=\"$ctrl.gates.highlightText\" uib-dropdown class=\"btn-group btn-group-xs\"><button uib-dropdown-toggle class=\"btn btn-default\"><i class=\"material-icon material-icon-format-color-fill\"></i><span class=\"caret\"></span></button><ul uib-dropdown-menu class=\"dropdown-menu\"><li class=\"dropdown-item\"><button type=\"button\" class=\"btn btn-default btn-block btn-xs\" ng-click=\"colorTextBg(\'transparent\')\"><span class=\"editor-swatch-label\">None</span></button></li><li class=\"dropdown-item {{$ctrl.colorClassName(key)}}\" ng-repeat=\"(key, value) in editor.options.textColours\"><button type=\"button\" class=\"btn btn-default btn-block btn-xs\" ng-click=\"colorTextBg(value)\"><span class=\"editor-swatch-label\">{{ key }}</span><span class=\"editor-text-options-swatch\" ng-style=\"{\'background\': value }\"></span></button></li></ul></div><div uib-dropdown dropdown-select class=\"btn-group btn-group-xs\" ng-if=\"editor.state.tagList\" ng-model=\"editor.state.selected.tag\" options=\"editor.state.tagList\" ng-change=\"editor.state.componentScope.ctrl.rebuild(\n                            editor.state.selected.tag,\n                            \'{{ editor.state.selected.tag }}\')\"></div></div><div class=\"btn-group btn-group-xs\" ng-if=\"editor.state.classList && $ctrl.gates.classList\"><div uib-dropdown dropdown-select class=\"btn-group btn-group-xs\" ng-model=\"editor.state.selected.class\" options=\"editor.state.classList.classes\"></div></div><div component-options class=\"btn-group btn-group-xs\"></div></div></div>");
  $templateCache.put("ng-komondor-editor/scripts/editor/editor-controls/editor-controls.text-dropdown.html", "<div class=\"btn-group btn-group-xs\" ng-if=\"editor.showTextControls(\'b i u sub sup a font\')\"><div uib-dropdown class=\"btn-group btn-group-xs\"><button uib-dropdown-toggle class=\"btn btn-default\">Formatting<span class=\"caret\"></span></button><ul uib-dropdown-menu class=\"dropdown-menu\"><li class=\"dropdown-item\" ng-if=\"editor.showTextControls(\'b\')\"><button type=\"button\" class=\"btn btn-default btn-xs btn-block\" ng-click=\"execCommand(\'bold\', false, null)\"><i class=\"material-icon material-icon-format-bold\"></i>Bold</button></li><li class=\"dropdown-item\" ng-if=\"editor.showTextControls(\'i\')\"><button type=\"button\" class=\"btn btn-default btn-xs btn-block\" ng-click=\"execCommand(\'italic\', false, null)\"><i class=\"material-icon material-icon-format-italic\"></i>Italic</button></li><li class=\"dropdown-item\" ng-if=\"editor.showTextControls(\'u\')\"><button type=\"button\" class=\"btn btn-default btn-xs btn-block\" ng-click=\"execCommand(\'underline\', false, null)\"><i class=\"material-icon material-icon-format-underlined\"></i>Underline</button></li><li class=\"dropdown-item\" ng-if=\"editor.showTextControls(\'del\')\"><button type=\"button\" class=\"btn btn-default btn-xs btn-block\" ng-click=\"execCommand(\'strikeThrough\', false, null)\"><i class=\"material-icon material-icon-format-strikethrough\"></i>Strikethrough</button></li><li class=\"dropdown-item\" ng-if=\"editor.showTextControls(\'sub\')\"><button type=\"button\" class=\"btn btn-default btn-xs btn-block\" ng-click=\"execCommand(\'subscript\', false, null)\"><i class=\"glyphicon glyphicon-komondor-subscript\"></i>Subscript</button></li><li class=\"dropdown-item\" ng-if=\"editor.showTextControls(\'sup\')\"><button type=\"button\" class=\"btn btn-default btn-xs btn-block\" ng-click=\"execCommand(\'superscript\', false, null)\"><i class=\"glyphicon glyphicon-komondor-superscript\"></i>Superscript</button></li><li class=\"dropdown-item\" ng-if=\"editor.showTextControls(\'a\')\"><button type=\"button\" class=\"btn btn-default btn-xs btn-block\" ng-click=\"editor.state.link.create()\"><i class=\"material-icon material-icon-insert-link\"></i>Link</button></li><li class=\"dropdown-item\" ng-if=\"editor.showTextControls(\'a\')\"><button type=\"button\" class=\"btn btn-default btn-xs btn-block\" ng-show=\"editor.state.link.showRemoveButton()\" ng-click=\"editor.state.link.remove()\"><i class=\"glyphicon glyphicon-komondor-unlink\"></i>Unlink</button></li><li class=\"dropdown-item\" ng-if=\"editor.showTextControls(\'sub sup font\')\"><button type=\"button\" class=\"btn btn-primary btn-xs btn-block\" ng-click=\"execCommand(\'removeFormat\', false, null)\"><i class=\"material-icon material-icon-format-clear\"></i>Clear styling</button></li></ul></div></div>");
  $templateCache.put("ng-komondor-editor/scripts/editor/editor-controls/editor-controls.text-inline.html", "<button type=\"button\" class=\"btn btn-default btn-xs\" ng-if=\"editor.showTextControls(\'b\')\" ng-click=\"execCommand(\'bold\', false, null)\"><i class=\"material-icon material-icon-format-bold\"></i></button><button type=\"button\" class=\"btn btn-default btn-xs\" ng-if=\"editor.showTextControls(\'i\')\" ng-click=\"execCommand(\'italic\', false, null)\"><i class=\"material-icon material-icon-format-italic\"></i></button><button type=\"button\" class=\"btn btn-default btn-xs\" ng-if=\"editor.showTextControls(\'u\')\" ng-click=\"execCommand(\'underline\', false, null)\"><i class=\"material-icon material-icon-format-underlined\"></i></button><button type=\"button\" class=\"btn btn-default btn-xs\" ng-if=\"editor.showTextControls(\'del\')\" ng-click=\"execCommand(\'strikeThrough\', false, null)\"><i class=\"material-icon material-icon-format-strikethrough\"></i></button><button type=\"button\" class=\"btn btn-default btn-xs\" ng-if=\"editor.showTextControls(\'sub\')\" ng-click=\"execCommand(\'subscript\', false, null)\"><i class=\"glyphicon glyphicon-komondor-subscript\"></i></button><button type=\"button\" class=\"btn btn-default btn-xs\" ng-if=\"editor.showTextControls(\'sup\')\" ng-click=\"execCommand(\'superscript\', false, null)\"><i class=\"glyphicon glyphicon-komondor-superscript\"></i></button><button type=\"button\" class=\"btn btn-default btn-xs\" ng-if=\"editor.showTextControls(\'a\')\" ng-click=\"editor.state.link.create()\"><i class=\"material-icon material-icon-insert-link\"></i></button><button type=\"button\" class=\"btn btn-default btn-xs\" ng-if=\"editor.showTextControls(\'a\')\" ng-show=\"editor.state.link.showRemoveButton()\" ng-click=\"editor.state.link.remove()\"><i class=\"glyphicon glyphicon-komondor-unlink\"></i></button><button type=\"button\" class=\"btn btn-default btn-xs\" ng-if=\"editor.showTextControls(\'sub sup font\')\" ng-click=\"execCommand(\'removeFormat\', false, null)\"><i class=\"material-icon material-icon-format-clear\"></i></button>");
}]);
})();

//# sourceMappingURL=ng-komondor-editor.js.map
